/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as authIndexRouteImport } from './routes/(auth)/index'
import { Route as PulseTokenRouteImport } from './routes/pulse.$token'
import { Route as CheckinTokenRouteImport } from './routes/checkin.$token'
import { Route as AuthHandoffRouteImport } from './routes/auth.handoff'
import { Route as AtenderHashRouteImport } from './routes/atender.$hash'
import { Route as dashboardDashboardRouteImport } from './routes/(dashboard)/dashboard'
import { Route as authWorkspaceRouteImport } from './routes/(auth)/workspace'
import { Route as authRecuperarSenhaRouteImport } from './routes/(auth)/recuperar-senha'
import { Route as authConfiguracaoLoginRouteImport } from './routes/(auth)/configuracao-login'
import { Route as authAppRouteImport } from './routes/(auth)/app'
import { Route as authAbrirContaRouteImport } from './routes/(auth)/abrir-conta'
import { Route as PulsePreviewTokenRouteImport } from './routes/pulse.preview.$token'
import { Route as dashboardDashboardDashboardIdRouteImport } from './routes/(dashboard)/dashboard.$dashboardId'
import { Route as authLTokenRouteImport } from './routes/(auth)/l.$token'
import { Route as dashboardDashboardDashboardIdIndexRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.index'
import { Route as dashboardDashboardDashboardIdSuporteRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.suporte'
import { Route as dashboardDashboardDashboardIdAssinarRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.assinar'
import { Route as dashboardDashboardDashboardIdSitesRouteRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.sites/route'
import { Route as dashboardDashboardDashboardIdSistemaRouteRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.sistema/route'
import { Route as dashboardDashboardDashboardIdRelatorioRouteRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.relatorio/route'
import { Route as dashboardDashboardDashboardIdPropostasRouteRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.propostas/route'
import { Route as dashboardDashboardDashboardIdPortaisRouteRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.portais/route'
import { Route as dashboardDashboardDashboardIdOportunidadesRouteRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.oportunidades/route'
import { Route as dashboardDashboardDashboardIdMatchesRouteRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.matches/route'
import { Route as dashboardDashboardDashboardIdMarketingRouteRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.marketing/route'
import { Route as dashboardDashboardDashboardIdLeadsRouteRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.leads/route'
import { Route as dashboardDashboardDashboardIdIncorporadorasRouteRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.incorporadoras/route'
import { Route as dashboardDashboardDashboardIdImoveisRouteRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.imoveis/route'
import { Route as dashboardDashboardDashboardIdFinanceiroRouteRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.financeiro/route'
import { Route as dashboardDashboardDashboardIdEmpreendimentosRouteRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.empreendimentos/route'
import { Route as dashboardDashboardDashboardIdDocumentosDigitaisRouteRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.documentos-digitais/route'
import { Route as dashboardDashboardDashboardIdContatosRouteRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.contatos/route'
import { Route as dashboardDashboardDashboardIdColecoesRouteRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.colecoes/route'
import { Route as dashboardDashboardDashboardIdChavesRouteRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.chaves/route'
import { Route as dashboardDashboardDashboardIdChatRouteRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.chat/route'
import { Route as dashboardDashboardDashboardIdCatalogoRouteRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.catalogo/route'
import { Route as dashboardDashboardDashboardIdAutomacoesRouteRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.automacoes/route'
import { Route as dashboardDashboardDashboardIdAtividadesRouteRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.atividades/route'
import { Route as dashboardDashboardDashboardIdSitesIndexRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.sites/index'
import { Route as dashboardDashboardDashboardIdSistemaIndexRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.sistema/index'
import { Route as dashboardDashboardDashboardIdPortaisIndexRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.portais/index'
import { Route as dashboardDashboardDashboardIdOportunidadesIndexRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.oportunidades/index'
import { Route as dashboardDashboardDashboardIdMarketingIndexRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.marketing/index'
import { Route as dashboardDashboardDashboardIdIncorporadorasIndexRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.incorporadoras/index'
import { Route as dashboardDashboardDashboardIdImoveisIndexRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.imoveis/index'
import { Route as dashboardDashboardDashboardIdFinanceiroIndexRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.financeiro/index'
import { Route as dashboardDashboardDashboardIdEmpreendimentosIndexRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.empreendimentos/index'
import { Route as dashboardDashboardDashboardIdDocumentosDigitaisIndexRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.documentos-digitais/index'
import { Route as dashboardDashboardDashboardIdConversasIndexRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.conversas/index'
import { Route as dashboardDashboardDashboardIdColecoesIndexRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.colecoes/index'
import { Route as dashboardDashboardDashboardIdChatIndexRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.chat/index'
import { Route as dashboardDashboardDashboardIdCatalogoIndexRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.catalogo/index'
import { Route as dashboardDashboardDashboardIdAutomacoesIndexRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.automacoes/index'
import { Route as dashboardDashboardDashboardIdSistemaWebhooksRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.sistema.webhooks'
import { Route as dashboardDashboardDashboardIdSistemaWatermarkRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.sistema/watermark'
import { Route as dashboardDashboardDashboardIdSistemaUsuariosRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.sistema/usuarios'
import { Route as dashboardDashboardDashboardIdSistemaPulseCarteiraRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.sistema.pulse-carteira'
import { Route as dashboardDashboardDashboardIdSistemaPreviewCtasRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.sistema/preview-ctas'
import { Route as dashboardDashboardDashboardIdSistemaPortaisRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.sistema.portais'
import { Route as dashboardDashboardDashboardIdSistemaPlanoFaturasRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.sistema/plano-faturas'
import { Route as dashboardDashboardDashboardIdSistemaMotivosPerdasRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.sistema/motivos-perdas'
import { Route as dashboardDashboardDashboardIdSistemaMetaLeadsRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.sistema.meta-leads'
import { Route as dashboardDashboardDashboardIdSistemaLogsRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.sistema.logs'
import { Route as dashboardDashboardDashboardIdSistemaIsaRedatoraRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.sistema/isa-redatora'
import { Route as dashboardDashboardDashboardIdSistemaFunisRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.sistema/funis'
import { Route as dashboardDashboardDashboardIdSistemaFinanceiroRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.sistema.financeiro'
import { Route as dashboardDashboardDashboardIdSistemaDistribuicaoInteligenteRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.sistema/distribuicao-inteligente'
import { Route as dashboardDashboardDashboardIdSistemaDadosRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.sistema/dados'
import { Route as dashboardDashboardDashboardIdSistemaConversasRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.sistema.conversas'
import { Route as dashboardDashboardDashboardIdSistemaComodidadesRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.sistema/comodidades'
import { Route as dashboardDashboardDashboardIdSistemaCamposCustomizadosRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.sistema/campos-customizados'
import { Route as dashboardDashboardDashboardIdSistemaApiKeysRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.sistema.api-keys'
import { Route as dashboardDashboardDashboardIdOportunidadesFunilValueRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.oportunidades/$funilValue'
import { Route as dashboardDashboardDashboardIdMarketingSegmentosRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.marketing/segmentos'
import { Route as dashboardDashboardDashboardIdLeadsNovoRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.leads/novo'
import { Route as dashboardDashboardDashboardIdLeadsImportarRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.leads/importar'
import { Route as dashboardDashboardDashboardIdFinanceiroLancamentosRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.financeiro.lancamentos'
import { Route as dashboardDashboardDashboardIdContatosNovoRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.contatos/novo'
import { Route as dashboardDashboardDashboardIdContatosImportarRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.contatos/importar'
import { Route as dashboardDashboardDashboardIdChatChatIdRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.chat/$chatId'
import { Route as dashboardDashboardDashboardIdCatalogoMapaRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.catalogo/mapa'
import { Route as dashboardDashboardDashboardIdSitesSiteIdRouteRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.sites/$siteId/route'
import { Route as dashboardDashboardDashboardIdSistemaWhatsappRouteRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.sistema.whatsapp/route'
import { Route as dashboardDashboardDashboardIdSistemaIntegracoesRouteRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.sistema.integracoes/route'
import { Route as dashboardDashboardDashboardIdSistemaAgentesRouteRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.sistema.agentes/route'
import { Route as dashboardDashboardDashboardIdRelatoriosOportunidadesRouteRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.relatorios.oportunidades/route'
import { Route as dashboardDashboardDashboardIdRelatoriosLeadsRouteRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.relatorios.leads/route'
import { Route as dashboardDashboardDashboardIdRelatoriosImoveisRouteRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.relatorios.imoveis/route'
import { Route as dashboardDashboardDashboardIdPortaisPortalvalueRouteRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.portais/$portalvalue/route'
import { Route as dashboardDashboardDashboardIdMarketingModelosWhatsappRouteRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.marketing.modelos-whatsapp/route'
import { Route as dashboardDashboardDashboardIdMarketingModelosEmailsRouteRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.marketing.modelos-emails/route'
import { Route as dashboardDashboardDashboardIdMarketingCampanhasSegmentadasRouteRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.marketing.campanhas-segmentadas/route'
import { Route as dashboardDashboardDashboardIdImoveisImovelIdRouteRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.imoveis/$imovelId/route'
import { Route as dashboardDashboardDashboardIdEmpreendimentosEmpreendimentoIdRouteRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.empreendimentos/$empreendimentoId/route'
import { Route as dashboardDashboardDashboardIdDocumentosDigitaisModelosRouteRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.documentos-digitais.modelos/route'
import { Route as dashboardDashboardDashboardIdConversasChannelInstanceUuidRouteRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.conversas.$channelInstanceUuid/route'
import { Route as dashboardDashboardDashboardIdContatosIdRouteRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.contatos/$id/route'
import { Route as dashboardDashboardDashboardIdColecoesColecaoIdRouteRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.colecoes/$colecaoId/route'
import { Route as dashboardDashboardDashboardIdAutomacoesAutomacaoIdRouteRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.automacoes/$automacaoId/route'
import { Route as dashboardDashboardDashboardIdSitesSiteIdIndexRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.sites/$siteId/index'
import { Route as dashboardDashboardDashboardIdSistemaWhatsappIndexRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.sistema.whatsapp/index'
import { Route as dashboardDashboardDashboardIdSistemaIntegracoesIndexRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.sistema.integracoes/index'
import { Route as dashboardDashboardDashboardIdSistemaAgentesIndexRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.sistema.agentes/index'
import { Route as dashboardDashboardDashboardIdPropostasPropostaIdIndexRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.propostas/$propostaId/index'
import { Route as dashboardDashboardDashboardIdPortaisPortalvalueIndexRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.portais/$portalvalue/index'
import { Route as dashboardDashboardDashboardIdMarketingModelosWhatsappIndexRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.marketing.modelos-whatsapp/index'
import { Route as dashboardDashboardDashboardIdMarketingModelosEmailsIndexRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.marketing.modelos-emails/index'
import { Route as dashboardDashboardDashboardIdMarketingCampanhasSegmentadasIndexRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.marketing.campanhas-segmentadas/index'
import { Route as dashboardDashboardDashboardIdLeadsLeadIdIndexRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.leads/$leadId/index'
import { Route as dashboardDashboardDashboardIdIncorporadorasIncorporadoraIdIndexRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.incorporadoras/$incorporadoraId/index'
import { Route as dashboardDashboardDashboardIdImoveisImovelIdIndexRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.imoveis/$imovelId/index'
import { Route as dashboardDashboardDashboardIdEmpreendimentosEmpreendimentoIdIndexRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.empreendimentos/$empreendimentoId/index'
import { Route as dashboardDashboardDashboardIdDocumentosDigitaisModelosIndexRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.documentos-digitais.modelos/index'
import { Route as dashboardDashboardDashboardIdDocumentosDigitaisGeradosIndexRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.documentos-digitais.gerados/index'
import { Route as dashboardDashboardDashboardIdDocumentosDigitaisAssinaturasIndexRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.documentos-digitais.assinaturas/index'
import { Route as dashboardDashboardDashboardIdConversasChannelInstanceUuidIndexRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.conversas.$channelInstanceUuid/index'
import { Route as dashboardDashboardDashboardIdContatosIdIndexRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.contatos/$id/index'
import { Route as dashboardDashboardDashboardIdColecoesColecaoIdIndexRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.colecoes/$colecaoId/index'
import { Route as dashboardDashboardDashboardIdChavesRegistroChaveIdIndexRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.chaves/$registroChaveId/index'
import { Route as dashboardDashboardDashboardIdAutomacoesNovaIndexRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.automacoes/nova/index'
import { Route as dashboardDashboardDashboardIdAutomacoesAutomacaoIdIndexRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.automacoes/$automacaoId/index'
import { Route as dashboardDashboardDashboardIdAtividadesTarefaIdIndexRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.atividades/$tarefaId/index'
import { Route as dashboardDashboardDashboardIdSistemaWhatsappNovaRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.sistema.whatsapp/nova'
import { Route as dashboardDashboardDashboardIdSistemaIntegracoesEmailRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.sistema.integracoes/email'
import { Route as dashboardDashboardDashboardIdSistemaIntegracoesDwvRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.sistema.integracoes/dwv'
import { Route as dashboardDashboardDashboardIdSistemaIntegracoesAutentiqueRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.sistema.integracoes/autentique'
import { Route as dashboardDashboardDashboardIdSistemaAgentesNovoRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.sistema.agentes/novo'
import { Route as dashboardDashboardDashboardIdSistemaAgentesAgenteIdRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.sistema.agentes.$agenteId'
import { Route as dashboardDashboardDashboardIdMarketingModelosWhatsappNovoRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.marketing.modelos-whatsapp/novo'
import { Route as dashboardDashboardDashboardIdMarketingModelosWhatsappTemplateIdRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.marketing.modelos-whatsapp/$templateId'
import { Route as dashboardDashboardDashboardIdMarketingModelosEmailsNovoRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.marketing.modelos-emails/novo'
import { Route as dashboardDashboardDashboardIdMarketingModelosEmailsTemplateIdRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.marketing.modelos-emails/$templateId'
import { Route as dashboardDashboardDashboardIdMarketingCampanhasSegmentadasNovoRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.marketing.campanhas-segmentadas/novo'
import { Route as dashboardDashboardDashboardIdMarketingCampanhasSegmentadasCampanhaIdRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.marketing.campanhas-segmentadas/$campanhaId'
import { Route as dashboardDashboardDashboardIdIncorporadorasIncorporadoraIdEditarRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.incorporadoras/$incorporadoraId/editar'
import { Route as dashboardDashboardDashboardIdImoveisImovelIdEditarRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.imoveis/$imovelId/editar'
import { Route as dashboardDashboardDashboardIdEmpreendimentosEmpreendimentoIdEditarRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.empreendimentos/$empreendimentoId/editar'
import { Route as dashboardDashboardDashboardIdDocumentosDigitaisModelosNovoRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.documentos-digitais.modelos/novo'
import { Route as dashboardDashboardDashboardIdDocumentosDigitaisModelosModeloIdRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.documentos-digitais.modelos/$modeloId'
import { Route as dashboardDashboardDashboardIdDocumentosDigitaisGeradosNovoRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.documentos-digitais.gerados/novo'
import { Route as dashboardDashboardDashboardIdContatosIdEditarRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.contatos/$id/editar'
import { Route as dashboardDashboardDashboardIdAutomacoesNovaEditarRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.automacoes/nova/editar'
import { Route as dashboardDashboardDashboardIdAutomacoesAutomacaoIdExecucoesRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.automacoes/$automacaoId/execucoes'
import { Route as dashboardDashboardDashboardIdSitesSiteIdBlogRouteRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.sites/$siteId/blog/route'
import { Route as dashboardDashboardDashboardIdDocumentosDigitaisGeradosDocumentoIdRouteRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.documentos-digitais.gerados/$documentoId/route'
import { Route as dashboardDashboardDashboardIdSitesSiteIdBlogIndexRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.sites/$siteId/blog/index'
import { Route as dashboardDashboardDashboardIdOportunidadesFunilValueOportunidadeIdIndexRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.oportunidades.$funilValue.$oportunidadeId/index'
import { Route as dashboardDashboardDashboardIdDocumentosDigitaisGeradosDocumentoIdIndexRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.documentos-digitais.gerados/$documentoId/index'
import { Route as dashboardDashboardDashboardIdConversasChannelInstanceUuidConversationIdIndexRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.conversas.$channelInstanceUuid.$conversationId/index'
import { Route as dashboardDashboardDashboardIdSitesSiteIdBlogNovoRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.sites/$siteId/blog/novo'
import { Route as dashboardDashboardDashboardIdMarketingCampanhasSegmentadasDetalheCampanhaIdRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.marketing.campanhas-segmentadas/detalhe.$campanhaId'
import { Route as dashboardDashboardDashboardIdDocumentosDigitaisGeradosDocumentoIdEditarRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.documentos-digitais.gerados/$documentoId/editar'
import { Route as dashboardDashboardDashboardIdSitesSiteIdBlogArtigoIdIndexRouteImport } from './routes/(dashboard)/dashboard.$dashboardId.sites/$siteId/blog/$artigoId/index'

const authIndexRoute = authIndexRouteImport.update({
  id: '/(auth)/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PulseTokenRoute = PulseTokenRouteImport.update({
  id: '/pulse/$token',
  path: '/pulse/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckinTokenRoute = CheckinTokenRouteImport.update({
  id: '/checkin/$token',
  path: '/checkin/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthHandoffRoute = AuthHandoffRouteImport.update({
  id: '/auth/handoff',
  path: '/auth/handoff',
  getParentRoute: () => rootRouteImport,
} as any)
const AtenderHashRoute = AtenderHashRouteImport.update({
  id: '/atender/$hash',
  path: '/atender/$hash',
  getParentRoute: () => rootRouteImport,
} as any)
const dashboardDashboardRoute = dashboardDashboardRouteImport.update({
  id: '/(dashboard)/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const authWorkspaceRoute = authWorkspaceRouteImport.update({
  id: '/(auth)/workspace',
  path: '/workspace',
  getParentRoute: () => rootRouteImport,
} as any)
const authRecuperarSenhaRoute = authRecuperarSenhaRouteImport.update({
  id: '/(auth)/recuperar-senha',
  path: '/recuperar-senha',
  getParentRoute: () => rootRouteImport,
} as any)
const authConfiguracaoLoginRoute = authConfiguracaoLoginRouteImport.update({
  id: '/(auth)/configuracao-login',
  path: '/configuracao-login',
  getParentRoute: () => rootRouteImport,
} as any)
const authAppRoute = authAppRouteImport.update({
  id: '/(auth)/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const authAbrirContaRoute = authAbrirContaRouteImport.update({
  id: '/(auth)/abrir-conta',
  path: '/abrir-conta',
  getParentRoute: () => rootRouteImport,
} as any)
const PulsePreviewTokenRoute = PulsePreviewTokenRouteImport.update({
  id: '/pulse/preview/$token',
  path: '/pulse/preview/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const dashboardDashboardDashboardIdRoute =
  dashboardDashboardDashboardIdRouteImport.update({
    id: '/$dashboardId',
    path: '/$dashboardId',
    getParentRoute: () => dashboardDashboardRoute,
  } as any)
const authLTokenRoute = authLTokenRouteImport.update({
  id: '/(auth)/l/$token',
  path: '/l/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const dashboardDashboardDashboardIdIndexRoute =
  dashboardDashboardDashboardIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => dashboardDashboardDashboardIdRoute,
  } as any)
const dashboardDashboardDashboardIdSuporteRoute =
  dashboardDashboardDashboardIdSuporteRouteImport.update({
    id: '/suporte',
    path: '/suporte',
    getParentRoute: () => dashboardDashboardDashboardIdRoute,
  } as any)
const dashboardDashboardDashboardIdAssinarRoute =
  dashboardDashboardDashboardIdAssinarRouteImport.update({
    id: '/assinar',
    path: '/assinar',
    getParentRoute: () => dashboardDashboardDashboardIdRoute,
  } as any)
const dashboardDashboardDashboardIdSitesRouteRoute =
  dashboardDashboardDashboardIdSitesRouteRouteImport.update({
    id: '/sites',
    path: '/sites',
    getParentRoute: () => dashboardDashboardDashboardIdRoute,
  } as any)
const dashboardDashboardDashboardIdSistemaRouteRoute =
  dashboardDashboardDashboardIdSistemaRouteRouteImport.update({
    id: '/sistema',
    path: '/sistema',
    getParentRoute: () => dashboardDashboardDashboardIdRoute,
  } as any)
const dashboardDashboardDashboardIdRelatorioRouteRoute =
  dashboardDashboardDashboardIdRelatorioRouteRouteImport.update({
    id: '/relatorio',
    path: '/relatorio',
    getParentRoute: () => dashboardDashboardDashboardIdRoute,
  } as any)
const dashboardDashboardDashboardIdPropostasRouteRoute =
  dashboardDashboardDashboardIdPropostasRouteRouteImport.update({
    id: '/propostas',
    path: '/propostas',
    getParentRoute: () => dashboardDashboardDashboardIdRoute,
  } as any)
const dashboardDashboardDashboardIdPortaisRouteRoute =
  dashboardDashboardDashboardIdPortaisRouteRouteImport.update({
    id: '/portais',
    path: '/portais',
    getParentRoute: () => dashboardDashboardDashboardIdRoute,
  } as any)
const dashboardDashboardDashboardIdOportunidadesRouteRoute =
  dashboardDashboardDashboardIdOportunidadesRouteRouteImport.update({
    id: '/oportunidades',
    path: '/oportunidades',
    getParentRoute: () => dashboardDashboardDashboardIdRoute,
  } as any)
const dashboardDashboardDashboardIdMatchesRouteRoute =
  dashboardDashboardDashboardIdMatchesRouteRouteImport.update({
    id: '/matches',
    path: '/matches',
    getParentRoute: () => dashboardDashboardDashboardIdRoute,
  } as any)
const dashboardDashboardDashboardIdMarketingRouteRoute =
  dashboardDashboardDashboardIdMarketingRouteRouteImport.update({
    id: '/marketing',
    path: '/marketing',
    getParentRoute: () => dashboardDashboardDashboardIdRoute,
  } as any)
const dashboardDashboardDashboardIdLeadsRouteRoute =
  dashboardDashboardDashboardIdLeadsRouteRouteImport.update({
    id: '/leads',
    path: '/leads',
    getParentRoute: () => dashboardDashboardDashboardIdRoute,
  } as any)
const dashboardDashboardDashboardIdIncorporadorasRouteRoute =
  dashboardDashboardDashboardIdIncorporadorasRouteRouteImport.update({
    id: '/incorporadoras',
    path: '/incorporadoras',
    getParentRoute: () => dashboardDashboardDashboardIdRoute,
  } as any)
const dashboardDashboardDashboardIdImoveisRouteRoute =
  dashboardDashboardDashboardIdImoveisRouteRouteImport.update({
    id: '/imoveis',
    path: '/imoveis',
    getParentRoute: () => dashboardDashboardDashboardIdRoute,
  } as any)
const dashboardDashboardDashboardIdFinanceiroRouteRoute =
  dashboardDashboardDashboardIdFinanceiroRouteRouteImport.update({
    id: '/financeiro',
    path: '/financeiro',
    getParentRoute: () => dashboardDashboardDashboardIdRoute,
  } as any)
const dashboardDashboardDashboardIdEmpreendimentosRouteRoute =
  dashboardDashboardDashboardIdEmpreendimentosRouteRouteImport.update({
    id: '/empreendimentos',
    path: '/empreendimentos',
    getParentRoute: () => dashboardDashboardDashboardIdRoute,
  } as any)
const dashboardDashboardDashboardIdDocumentosDigitaisRouteRoute =
  dashboardDashboardDashboardIdDocumentosDigitaisRouteRouteImport.update({
    id: '/documentos-digitais',
    path: '/documentos-digitais',
    getParentRoute: () => dashboardDashboardDashboardIdRoute,
  } as any)
const dashboardDashboardDashboardIdContatosRouteRoute =
  dashboardDashboardDashboardIdContatosRouteRouteImport.update({
    id: '/contatos',
    path: '/contatos',
    getParentRoute: () => dashboardDashboardDashboardIdRoute,
  } as any)
const dashboardDashboardDashboardIdColecoesRouteRoute =
  dashboardDashboardDashboardIdColecoesRouteRouteImport.update({
    id: '/colecoes',
    path: '/colecoes',
    getParentRoute: () => dashboardDashboardDashboardIdRoute,
  } as any)
const dashboardDashboardDashboardIdChavesRouteRoute =
  dashboardDashboardDashboardIdChavesRouteRouteImport.update({
    id: '/chaves',
    path: '/chaves',
    getParentRoute: () => dashboardDashboardDashboardIdRoute,
  } as any)
const dashboardDashboardDashboardIdChatRouteRoute =
  dashboardDashboardDashboardIdChatRouteRouteImport.update({
    id: '/chat',
    path: '/chat',
    getParentRoute: () => dashboardDashboardDashboardIdRoute,
  } as any)
const dashboardDashboardDashboardIdCatalogoRouteRoute =
  dashboardDashboardDashboardIdCatalogoRouteRouteImport.update({
    id: '/catalogo',
    path: '/catalogo',
    getParentRoute: () => dashboardDashboardDashboardIdRoute,
  } as any)
const dashboardDashboardDashboardIdAutomacoesRouteRoute =
  dashboardDashboardDashboardIdAutomacoesRouteRouteImport.update({
    id: '/automacoes',
    path: '/automacoes',
    getParentRoute: () => dashboardDashboardDashboardIdRoute,
  } as any)
const dashboardDashboardDashboardIdAtividadesRouteRoute =
  dashboardDashboardDashboardIdAtividadesRouteRouteImport.update({
    id: '/atividades',
    path: '/atividades',
    getParentRoute: () => dashboardDashboardDashboardIdRoute,
  } as any)
const dashboardDashboardDashboardIdSitesIndexRoute =
  dashboardDashboardDashboardIdSitesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => dashboardDashboardDashboardIdSitesRouteRoute,
  } as any)
const dashboardDashboardDashboardIdSistemaIndexRoute =
  dashboardDashboardDashboardIdSistemaIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => dashboardDashboardDashboardIdSistemaRouteRoute,
  } as any)
const dashboardDashboardDashboardIdPortaisIndexRoute =
  dashboardDashboardDashboardIdPortaisIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => dashboardDashboardDashboardIdPortaisRouteRoute,
  } as any)
const dashboardDashboardDashboardIdOportunidadesIndexRoute =
  dashboardDashboardDashboardIdOportunidadesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => dashboardDashboardDashboardIdOportunidadesRouteRoute,
  } as any)
const dashboardDashboardDashboardIdMarketingIndexRoute =
  dashboardDashboardDashboardIdMarketingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => dashboardDashboardDashboardIdMarketingRouteRoute,
  } as any)
const dashboardDashboardDashboardIdIncorporadorasIndexRoute =
  dashboardDashboardDashboardIdIncorporadorasIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => dashboardDashboardDashboardIdIncorporadorasRouteRoute,
  } as any)
const dashboardDashboardDashboardIdImoveisIndexRoute =
  dashboardDashboardDashboardIdImoveisIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => dashboardDashboardDashboardIdImoveisRouteRoute,
  } as any)
const dashboardDashboardDashboardIdFinanceiroIndexRoute =
  dashboardDashboardDashboardIdFinanceiroIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => dashboardDashboardDashboardIdFinanceiroRouteRoute,
  } as any)
const dashboardDashboardDashboardIdEmpreendimentosIndexRoute =
  dashboardDashboardDashboardIdEmpreendimentosIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      dashboardDashboardDashboardIdEmpreendimentosRouteRoute,
  } as any)
const dashboardDashboardDashboardIdDocumentosDigitaisIndexRoute =
  dashboardDashboardDashboardIdDocumentosDigitaisIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      dashboardDashboardDashboardIdDocumentosDigitaisRouteRoute,
  } as any)
const dashboardDashboardDashboardIdConversasIndexRoute =
  dashboardDashboardDashboardIdConversasIndexRouteImport.update({
    id: '/conversas/',
    path: '/conversas/',
    getParentRoute: () => dashboardDashboardDashboardIdRoute,
  } as any)
const dashboardDashboardDashboardIdColecoesIndexRoute =
  dashboardDashboardDashboardIdColecoesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => dashboardDashboardDashboardIdColecoesRouteRoute,
  } as any)
const dashboardDashboardDashboardIdChatIndexRoute =
  dashboardDashboardDashboardIdChatIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => dashboardDashboardDashboardIdChatRouteRoute,
  } as any)
const dashboardDashboardDashboardIdCatalogoIndexRoute =
  dashboardDashboardDashboardIdCatalogoIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => dashboardDashboardDashboardIdCatalogoRouteRoute,
  } as any)
const dashboardDashboardDashboardIdAutomacoesIndexRoute =
  dashboardDashboardDashboardIdAutomacoesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => dashboardDashboardDashboardIdAutomacoesRouteRoute,
  } as any)
const dashboardDashboardDashboardIdSistemaWebhooksRoute =
  dashboardDashboardDashboardIdSistemaWebhooksRouteImport.update({
    id: '/webhooks',
    path: '/webhooks',
    getParentRoute: () => dashboardDashboardDashboardIdSistemaRouteRoute,
  } as any)
const dashboardDashboardDashboardIdSistemaWatermarkRoute =
  dashboardDashboardDashboardIdSistemaWatermarkRouteImport.update({
    id: '/watermark',
    path: '/watermark',
    getParentRoute: () => dashboardDashboardDashboardIdSistemaRouteRoute,
  } as any)
const dashboardDashboardDashboardIdSistemaUsuariosRoute =
  dashboardDashboardDashboardIdSistemaUsuariosRouteImport.update({
    id: '/usuarios',
    path: '/usuarios',
    getParentRoute: () => dashboardDashboardDashboardIdSistemaRouteRoute,
  } as any)
const dashboardDashboardDashboardIdSistemaPulseCarteiraRoute =
  dashboardDashboardDashboardIdSistemaPulseCarteiraRouteImport.update({
    id: '/pulse-carteira',
    path: '/pulse-carteira',
    getParentRoute: () => dashboardDashboardDashboardIdSistemaRouteRoute,
  } as any)
const dashboardDashboardDashboardIdSistemaPreviewCtasRoute =
  dashboardDashboardDashboardIdSistemaPreviewCtasRouteImport.update({
    id: '/preview-ctas',
    path: '/preview-ctas',
    getParentRoute: () => dashboardDashboardDashboardIdSistemaRouteRoute,
  } as any)
const dashboardDashboardDashboardIdSistemaPortaisRoute =
  dashboardDashboardDashboardIdSistemaPortaisRouteImport.update({
    id: '/portais',
    path: '/portais',
    getParentRoute: () => dashboardDashboardDashboardIdSistemaRouteRoute,
  } as any)
const dashboardDashboardDashboardIdSistemaPlanoFaturasRoute =
  dashboardDashboardDashboardIdSistemaPlanoFaturasRouteImport.update({
    id: '/plano-faturas',
    path: '/plano-faturas',
    getParentRoute: () => dashboardDashboardDashboardIdSistemaRouteRoute,
  } as any)
const dashboardDashboardDashboardIdSistemaMotivosPerdasRoute =
  dashboardDashboardDashboardIdSistemaMotivosPerdasRouteImport.update({
    id: '/motivos-perdas',
    path: '/motivos-perdas',
    getParentRoute: () => dashboardDashboardDashboardIdSistemaRouteRoute,
  } as any)
const dashboardDashboardDashboardIdSistemaMetaLeadsRoute =
  dashboardDashboardDashboardIdSistemaMetaLeadsRouteImport.update({
    id: '/meta-leads',
    path: '/meta-leads',
    getParentRoute: () => dashboardDashboardDashboardIdSistemaRouteRoute,
  } as any)
const dashboardDashboardDashboardIdSistemaLogsRoute =
  dashboardDashboardDashboardIdSistemaLogsRouteImport.update({
    id: '/logs',
    path: '/logs',
    getParentRoute: () => dashboardDashboardDashboardIdSistemaRouteRoute,
  } as any)
const dashboardDashboardDashboardIdSistemaIsaRedatoraRoute =
  dashboardDashboardDashboardIdSistemaIsaRedatoraRouteImport.update({
    id: '/isa-redatora',
    path: '/isa-redatora',
    getParentRoute: () => dashboardDashboardDashboardIdSistemaRouteRoute,
  } as any)
const dashboardDashboardDashboardIdSistemaFunisRoute =
  dashboardDashboardDashboardIdSistemaFunisRouteImport.update({
    id: '/funis',
    path: '/funis',
    getParentRoute: () => dashboardDashboardDashboardIdSistemaRouteRoute,
  } as any)
const dashboardDashboardDashboardIdSistemaFinanceiroRoute =
  dashboardDashboardDashboardIdSistemaFinanceiroRouteImport.update({
    id: '/financeiro',
    path: '/financeiro',
    getParentRoute: () => dashboardDashboardDashboardIdSistemaRouteRoute,
  } as any)
const dashboardDashboardDashboardIdSistemaDistribuicaoInteligenteRoute =
  dashboardDashboardDashboardIdSistemaDistribuicaoInteligenteRouteImport.update(
    {
      id: '/distribuicao-inteligente',
      path: '/distribuicao-inteligente',
      getParentRoute: () => dashboardDashboardDashboardIdSistemaRouteRoute,
    } as any,
  )
const dashboardDashboardDashboardIdSistemaDadosRoute =
  dashboardDashboardDashboardIdSistemaDadosRouteImport.update({
    id: '/dados',
    path: '/dados',
    getParentRoute: () => dashboardDashboardDashboardIdSistemaRouteRoute,
  } as any)
const dashboardDashboardDashboardIdSistemaConversasRoute =
  dashboardDashboardDashboardIdSistemaConversasRouteImport.update({
    id: '/conversas',
    path: '/conversas',
    getParentRoute: () => dashboardDashboardDashboardIdSistemaRouteRoute,
  } as any)
const dashboardDashboardDashboardIdSistemaComodidadesRoute =
  dashboardDashboardDashboardIdSistemaComodidadesRouteImport.update({
    id: '/comodidades',
    path: '/comodidades',
    getParentRoute: () => dashboardDashboardDashboardIdSistemaRouteRoute,
  } as any)
const dashboardDashboardDashboardIdSistemaCamposCustomizadosRoute =
  dashboardDashboardDashboardIdSistemaCamposCustomizadosRouteImport.update({
    id: '/campos-customizados',
    path: '/campos-customizados',
    getParentRoute: () => dashboardDashboardDashboardIdSistemaRouteRoute,
  } as any)
const dashboardDashboardDashboardIdSistemaApiKeysRoute =
  dashboardDashboardDashboardIdSistemaApiKeysRouteImport.update({
    id: '/api-keys',
    path: '/api-keys',
    getParentRoute: () => dashboardDashboardDashboardIdSistemaRouteRoute,
  } as any)
const dashboardDashboardDashboardIdOportunidadesFunilValueRoute =
  dashboardDashboardDashboardIdOportunidadesFunilValueRouteImport.update({
    id: '/$funilValue',
    path: '/$funilValue',
    getParentRoute: () => dashboardDashboardDashboardIdOportunidadesRouteRoute,
  } as any)
const dashboardDashboardDashboardIdMarketingSegmentosRoute =
  dashboardDashboardDashboardIdMarketingSegmentosRouteImport.update({
    id: '/segmentos',
    path: '/segmentos',
    getParentRoute: () => dashboardDashboardDashboardIdMarketingRouteRoute,
  } as any)
const dashboardDashboardDashboardIdLeadsNovoRoute =
  dashboardDashboardDashboardIdLeadsNovoRouteImport.update({
    id: '/novo',
    path: '/novo',
    getParentRoute: () => dashboardDashboardDashboardIdLeadsRouteRoute,
  } as any)
const dashboardDashboardDashboardIdLeadsImportarRoute =
  dashboardDashboardDashboardIdLeadsImportarRouteImport.update({
    id: '/importar',
    path: '/importar',
    getParentRoute: () => dashboardDashboardDashboardIdLeadsRouteRoute,
  } as any)
const dashboardDashboardDashboardIdFinanceiroLancamentosRoute =
  dashboardDashboardDashboardIdFinanceiroLancamentosRouteImport.update({
    id: '/lancamentos',
    path: '/lancamentos',
    getParentRoute: () => dashboardDashboardDashboardIdFinanceiroRouteRoute,
  } as any)
const dashboardDashboardDashboardIdContatosNovoRoute =
  dashboardDashboardDashboardIdContatosNovoRouteImport.update({
    id: '/novo',
    path: '/novo',
    getParentRoute: () => dashboardDashboardDashboardIdContatosRouteRoute,
  } as any)
const dashboardDashboardDashboardIdContatosImportarRoute =
  dashboardDashboardDashboardIdContatosImportarRouteImport.update({
    id: '/importar',
    path: '/importar',
    getParentRoute: () => dashboardDashboardDashboardIdContatosRouteRoute,
  } as any)
const dashboardDashboardDashboardIdChatChatIdRoute =
  dashboardDashboardDashboardIdChatChatIdRouteImport.update({
    id: '/$chatId',
    path: '/$chatId',
    getParentRoute: () => dashboardDashboardDashboardIdChatRouteRoute,
  } as any)
const dashboardDashboardDashboardIdCatalogoMapaRoute =
  dashboardDashboardDashboardIdCatalogoMapaRouteImport.update({
    id: '/mapa',
    path: '/mapa',
    getParentRoute: () => dashboardDashboardDashboardIdCatalogoRouteRoute,
  } as any)
const dashboardDashboardDashboardIdSitesSiteIdRouteRoute =
  dashboardDashboardDashboardIdSitesSiteIdRouteRouteImport.update({
    id: '/$siteId',
    path: '/$siteId',
    getParentRoute: () => dashboardDashboardDashboardIdSitesRouteRoute,
  } as any)
const dashboardDashboardDashboardIdSistemaWhatsappRouteRoute =
  dashboardDashboardDashboardIdSistemaWhatsappRouteRouteImport.update({
    id: '/whatsapp',
    path: '/whatsapp',
    getParentRoute: () => dashboardDashboardDashboardIdSistemaRouteRoute,
  } as any)
const dashboardDashboardDashboardIdSistemaIntegracoesRouteRoute =
  dashboardDashboardDashboardIdSistemaIntegracoesRouteRouteImport.update({
    id: '/integracoes',
    path: '/integracoes',
    getParentRoute: () => dashboardDashboardDashboardIdSistemaRouteRoute,
  } as any)
const dashboardDashboardDashboardIdSistemaAgentesRouteRoute =
  dashboardDashboardDashboardIdSistemaAgentesRouteRouteImport.update({
    id: '/agentes',
    path: '/agentes',
    getParentRoute: () => dashboardDashboardDashboardIdSistemaRouteRoute,
  } as any)
const dashboardDashboardDashboardIdRelatoriosOportunidadesRouteRoute =
  dashboardDashboardDashboardIdRelatoriosOportunidadesRouteRouteImport.update({
    id: '/relatorios/oportunidades',
    path: '/relatorios/oportunidades',
    getParentRoute: () => dashboardDashboardDashboardIdRoute,
  } as any)
const dashboardDashboardDashboardIdRelatoriosLeadsRouteRoute =
  dashboardDashboardDashboardIdRelatoriosLeadsRouteRouteImport.update({
    id: '/relatorios/leads',
    path: '/relatorios/leads',
    getParentRoute: () => dashboardDashboardDashboardIdRoute,
  } as any)
const dashboardDashboardDashboardIdRelatoriosImoveisRouteRoute =
  dashboardDashboardDashboardIdRelatoriosImoveisRouteRouteImport.update({
    id: '/relatorios/imoveis',
    path: '/relatorios/imoveis',
    getParentRoute: () => dashboardDashboardDashboardIdRoute,
  } as any)
const dashboardDashboardDashboardIdPortaisPortalvalueRouteRoute =
  dashboardDashboardDashboardIdPortaisPortalvalueRouteRouteImport.update({
    id: '/$portalvalue',
    path: '/$portalvalue',
    getParentRoute: () => dashboardDashboardDashboardIdPortaisRouteRoute,
  } as any)
const dashboardDashboardDashboardIdMarketingModelosWhatsappRouteRoute =
  dashboardDashboardDashboardIdMarketingModelosWhatsappRouteRouteImport.update({
    id: '/modelos-whatsapp',
    path: '/modelos-whatsapp',
    getParentRoute: () => dashboardDashboardDashboardIdMarketingRouteRoute,
  } as any)
const dashboardDashboardDashboardIdMarketingModelosEmailsRouteRoute =
  dashboardDashboardDashboardIdMarketingModelosEmailsRouteRouteImport.update({
    id: '/modelos-emails',
    path: '/modelos-emails',
    getParentRoute: () => dashboardDashboardDashboardIdMarketingRouteRoute,
  } as any)
const dashboardDashboardDashboardIdMarketingCampanhasSegmentadasRouteRoute =
  dashboardDashboardDashboardIdMarketingCampanhasSegmentadasRouteRouteImport.update(
    {
      id: '/campanhas-segmentadas',
      path: '/campanhas-segmentadas',
      getParentRoute: () => dashboardDashboardDashboardIdMarketingRouteRoute,
    } as any,
  )
const dashboardDashboardDashboardIdImoveisImovelIdRouteRoute =
  dashboardDashboardDashboardIdImoveisImovelIdRouteRouteImport.update({
    id: '/$imovelId',
    path: '/$imovelId',
    getParentRoute: () => dashboardDashboardDashboardIdImoveisRouteRoute,
  } as any)
const dashboardDashboardDashboardIdEmpreendimentosEmpreendimentoIdRouteRoute =
  dashboardDashboardDashboardIdEmpreendimentosEmpreendimentoIdRouteRouteImport.update(
    {
      id: '/$empreendimentoId',
      path: '/$empreendimentoId',
      getParentRoute: () =>
        dashboardDashboardDashboardIdEmpreendimentosRouteRoute,
    } as any,
  )
const dashboardDashboardDashboardIdDocumentosDigitaisModelosRouteRoute =
  dashboardDashboardDashboardIdDocumentosDigitaisModelosRouteRouteImport.update(
    {
      id: '/modelos',
      path: '/modelos',
      getParentRoute: () =>
        dashboardDashboardDashboardIdDocumentosDigitaisRouteRoute,
    } as any,
  )
const dashboardDashboardDashboardIdConversasChannelInstanceUuidRouteRoute =
  dashboardDashboardDashboardIdConversasChannelInstanceUuidRouteRouteImport.update(
    {
      id: '/conversas/$channelInstanceUuid',
      path: '/conversas/$channelInstanceUuid',
      getParentRoute: () => dashboardDashboardDashboardIdRoute,
    } as any,
  )
const dashboardDashboardDashboardIdContatosIdRouteRoute =
  dashboardDashboardDashboardIdContatosIdRouteRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => dashboardDashboardDashboardIdContatosRouteRoute,
  } as any)
const dashboardDashboardDashboardIdColecoesColecaoIdRouteRoute =
  dashboardDashboardDashboardIdColecoesColecaoIdRouteRouteImport.update({
    id: '/$colecaoId',
    path: '/$colecaoId',
    getParentRoute: () => dashboardDashboardDashboardIdColecoesRouteRoute,
  } as any)
const dashboardDashboardDashboardIdAutomacoesAutomacaoIdRouteRoute =
  dashboardDashboardDashboardIdAutomacoesAutomacaoIdRouteRouteImport.update({
    id: '/$automacaoId',
    path: '/$automacaoId',
    getParentRoute: () => dashboardDashboardDashboardIdAutomacoesRouteRoute,
  } as any)
const dashboardDashboardDashboardIdSitesSiteIdIndexRoute =
  dashboardDashboardDashboardIdSitesSiteIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => dashboardDashboardDashboardIdSitesSiteIdRouteRoute,
  } as any)
const dashboardDashboardDashboardIdSistemaWhatsappIndexRoute =
  dashboardDashboardDashboardIdSistemaWhatsappIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      dashboardDashboardDashboardIdSistemaWhatsappRouteRoute,
  } as any)
const dashboardDashboardDashboardIdSistemaIntegracoesIndexRoute =
  dashboardDashboardDashboardIdSistemaIntegracoesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      dashboardDashboardDashboardIdSistemaIntegracoesRouteRoute,
  } as any)
const dashboardDashboardDashboardIdSistemaAgentesIndexRoute =
  dashboardDashboardDashboardIdSistemaAgentesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => dashboardDashboardDashboardIdSistemaAgentesRouteRoute,
  } as any)
const dashboardDashboardDashboardIdPropostasPropostaIdIndexRoute =
  dashboardDashboardDashboardIdPropostasPropostaIdIndexRouteImport.update({
    id: '/$propostaId/',
    path: '/$propostaId/',
    getParentRoute: () => dashboardDashboardDashboardIdPropostasRouteRoute,
  } as any)
const dashboardDashboardDashboardIdPortaisPortalvalueIndexRoute =
  dashboardDashboardDashboardIdPortaisPortalvalueIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      dashboardDashboardDashboardIdPortaisPortalvalueRouteRoute,
  } as any)
const dashboardDashboardDashboardIdMarketingModelosWhatsappIndexRoute =
  dashboardDashboardDashboardIdMarketingModelosWhatsappIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      dashboardDashboardDashboardIdMarketingModelosWhatsappRouteRoute,
  } as any)
const dashboardDashboardDashboardIdMarketingModelosEmailsIndexRoute =
  dashboardDashboardDashboardIdMarketingModelosEmailsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      dashboardDashboardDashboardIdMarketingModelosEmailsRouteRoute,
  } as any)
const dashboardDashboardDashboardIdMarketingCampanhasSegmentadasIndexRoute =
  dashboardDashboardDashboardIdMarketingCampanhasSegmentadasIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        dashboardDashboardDashboardIdMarketingCampanhasSegmentadasRouteRoute,
    } as any,
  )
const dashboardDashboardDashboardIdLeadsLeadIdIndexRoute =
  dashboardDashboardDashboardIdLeadsLeadIdIndexRouteImport.update({
    id: '/$leadId/',
    path: '/$leadId/',
    getParentRoute: () => dashboardDashboardDashboardIdLeadsRouteRoute,
  } as any)
const dashboardDashboardDashboardIdIncorporadorasIncorporadoraIdIndexRoute =
  dashboardDashboardDashboardIdIncorporadorasIncorporadoraIdIndexRouteImport.update(
    {
      id: '/$incorporadoraId/',
      path: '/$incorporadoraId/',
      getParentRoute: () =>
        dashboardDashboardDashboardIdIncorporadorasRouteRoute,
    } as any,
  )
const dashboardDashboardDashboardIdImoveisImovelIdIndexRoute =
  dashboardDashboardDashboardIdImoveisImovelIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      dashboardDashboardDashboardIdImoveisImovelIdRouteRoute,
  } as any)
const dashboardDashboardDashboardIdEmpreendimentosEmpreendimentoIdIndexRoute =
  dashboardDashboardDashboardIdEmpreendimentosEmpreendimentoIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        dashboardDashboardDashboardIdEmpreendimentosEmpreendimentoIdRouteRoute,
    } as any,
  )
const dashboardDashboardDashboardIdDocumentosDigitaisModelosIndexRoute =
  dashboardDashboardDashboardIdDocumentosDigitaisModelosIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        dashboardDashboardDashboardIdDocumentosDigitaisModelosRouteRoute,
    } as any,
  )
const dashboardDashboardDashboardIdDocumentosDigitaisGeradosIndexRoute =
  dashboardDashboardDashboardIdDocumentosDigitaisGeradosIndexRouteImport.update(
    {
      id: '/gerados/',
      path: '/gerados/',
      getParentRoute: () =>
        dashboardDashboardDashboardIdDocumentosDigitaisRouteRoute,
    } as any,
  )
const dashboardDashboardDashboardIdDocumentosDigitaisAssinaturasIndexRoute =
  dashboardDashboardDashboardIdDocumentosDigitaisAssinaturasIndexRouteImport.update(
    {
      id: '/assinaturas/',
      path: '/assinaturas/',
      getParentRoute: () =>
        dashboardDashboardDashboardIdDocumentosDigitaisRouteRoute,
    } as any,
  )
const dashboardDashboardDashboardIdConversasChannelInstanceUuidIndexRoute =
  dashboardDashboardDashboardIdConversasChannelInstanceUuidIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        dashboardDashboardDashboardIdConversasChannelInstanceUuidRouteRoute,
    } as any,
  )
const dashboardDashboardDashboardIdContatosIdIndexRoute =
  dashboardDashboardDashboardIdContatosIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => dashboardDashboardDashboardIdContatosIdRouteRoute,
  } as any)
const dashboardDashboardDashboardIdColecoesColecaoIdIndexRoute =
  dashboardDashboardDashboardIdColecoesColecaoIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      dashboardDashboardDashboardIdColecoesColecaoIdRouteRoute,
  } as any)
const dashboardDashboardDashboardIdChavesRegistroChaveIdIndexRoute =
  dashboardDashboardDashboardIdChavesRegistroChaveIdIndexRouteImport.update({
    id: '/$registroChaveId/',
    path: '/$registroChaveId/',
    getParentRoute: () => dashboardDashboardDashboardIdChavesRouteRoute,
  } as any)
const dashboardDashboardDashboardIdAutomacoesNovaIndexRoute =
  dashboardDashboardDashboardIdAutomacoesNovaIndexRouteImport.update({
    id: '/nova/',
    path: '/nova/',
    getParentRoute: () => dashboardDashboardDashboardIdAutomacoesRouteRoute,
  } as any)
const dashboardDashboardDashboardIdAutomacoesAutomacaoIdIndexRoute =
  dashboardDashboardDashboardIdAutomacoesAutomacaoIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      dashboardDashboardDashboardIdAutomacoesAutomacaoIdRouteRoute,
  } as any)
const dashboardDashboardDashboardIdAtividadesTarefaIdIndexRoute =
  dashboardDashboardDashboardIdAtividadesTarefaIdIndexRouteImport.update({
    id: '/$tarefaId/',
    path: '/$tarefaId/',
    getParentRoute: () => dashboardDashboardDashboardIdAtividadesRouteRoute,
  } as any)
const dashboardDashboardDashboardIdSistemaWhatsappNovaRoute =
  dashboardDashboardDashboardIdSistemaWhatsappNovaRouteImport.update({
    id: '/nova',
    path: '/nova',
    getParentRoute: () =>
      dashboardDashboardDashboardIdSistemaWhatsappRouteRoute,
  } as any)
const dashboardDashboardDashboardIdSistemaIntegracoesEmailRoute =
  dashboardDashboardDashboardIdSistemaIntegracoesEmailRouteImport.update({
    id: '/email',
    path: '/email',
    getParentRoute: () =>
      dashboardDashboardDashboardIdSistemaIntegracoesRouteRoute,
  } as any)
const dashboardDashboardDashboardIdSistemaIntegracoesDwvRoute =
  dashboardDashboardDashboardIdSistemaIntegracoesDwvRouteImport.update({
    id: '/dwv',
    path: '/dwv',
    getParentRoute: () =>
      dashboardDashboardDashboardIdSistemaIntegracoesRouteRoute,
  } as any)
const dashboardDashboardDashboardIdSistemaIntegracoesAutentiqueRoute =
  dashboardDashboardDashboardIdSistemaIntegracoesAutentiqueRouteImport.update({
    id: '/autentique',
    path: '/autentique',
    getParentRoute: () =>
      dashboardDashboardDashboardIdSistemaIntegracoesRouteRoute,
  } as any)
const dashboardDashboardDashboardIdSistemaAgentesNovoRoute =
  dashboardDashboardDashboardIdSistemaAgentesNovoRouteImport.update({
    id: '/novo',
    path: '/novo',
    getParentRoute: () => dashboardDashboardDashboardIdSistemaAgentesRouteRoute,
  } as any)
const dashboardDashboardDashboardIdSistemaAgentesAgenteIdRoute =
  dashboardDashboardDashboardIdSistemaAgentesAgenteIdRouteImport.update({
    id: '/$agenteId',
    path: '/$agenteId',
    getParentRoute: () => dashboardDashboardDashboardIdSistemaAgentesRouteRoute,
  } as any)
const dashboardDashboardDashboardIdMarketingModelosWhatsappNovoRoute =
  dashboardDashboardDashboardIdMarketingModelosWhatsappNovoRouteImport.update({
    id: '/novo',
    path: '/novo',
    getParentRoute: () =>
      dashboardDashboardDashboardIdMarketingModelosWhatsappRouteRoute,
  } as any)
const dashboardDashboardDashboardIdMarketingModelosWhatsappTemplateIdRoute =
  dashboardDashboardDashboardIdMarketingModelosWhatsappTemplateIdRouteImport.update(
    {
      id: '/$templateId',
      path: '/$templateId',
      getParentRoute: () =>
        dashboardDashboardDashboardIdMarketingModelosWhatsappRouteRoute,
    } as any,
  )
const dashboardDashboardDashboardIdMarketingModelosEmailsNovoRoute =
  dashboardDashboardDashboardIdMarketingModelosEmailsNovoRouteImport.update({
    id: '/novo',
    path: '/novo',
    getParentRoute: () =>
      dashboardDashboardDashboardIdMarketingModelosEmailsRouteRoute,
  } as any)
const dashboardDashboardDashboardIdMarketingModelosEmailsTemplateIdRoute =
  dashboardDashboardDashboardIdMarketingModelosEmailsTemplateIdRouteImport.update(
    {
      id: '/$templateId',
      path: '/$templateId',
      getParentRoute: () =>
        dashboardDashboardDashboardIdMarketingModelosEmailsRouteRoute,
    } as any,
  )
const dashboardDashboardDashboardIdMarketingCampanhasSegmentadasNovoRoute =
  dashboardDashboardDashboardIdMarketingCampanhasSegmentadasNovoRouteImport.update(
    {
      id: '/novo',
      path: '/novo',
      getParentRoute: () =>
        dashboardDashboardDashboardIdMarketingCampanhasSegmentadasRouteRoute,
    } as any,
  )
const dashboardDashboardDashboardIdMarketingCampanhasSegmentadasCampanhaIdRoute =
  dashboardDashboardDashboardIdMarketingCampanhasSegmentadasCampanhaIdRouteImport.update(
    {
      id: '/$campanhaId',
      path: '/$campanhaId',
      getParentRoute: () =>
        dashboardDashboardDashboardIdMarketingCampanhasSegmentadasRouteRoute,
    } as any,
  )
const dashboardDashboardDashboardIdIncorporadorasIncorporadoraIdEditarRoute =
  dashboardDashboardDashboardIdIncorporadorasIncorporadoraIdEditarRouteImport.update(
    {
      id: '/$incorporadoraId/editar',
      path: '/$incorporadoraId/editar',
      getParentRoute: () =>
        dashboardDashboardDashboardIdIncorporadorasRouteRoute,
    } as any,
  )
const dashboardDashboardDashboardIdImoveisImovelIdEditarRoute =
  dashboardDashboardDashboardIdImoveisImovelIdEditarRouteImport.update({
    id: '/editar',
    path: '/editar',
    getParentRoute: () =>
      dashboardDashboardDashboardIdImoveisImovelIdRouteRoute,
  } as any)
const dashboardDashboardDashboardIdEmpreendimentosEmpreendimentoIdEditarRoute =
  dashboardDashboardDashboardIdEmpreendimentosEmpreendimentoIdEditarRouteImport.update(
    {
      id: '/editar',
      path: '/editar',
      getParentRoute: () =>
        dashboardDashboardDashboardIdEmpreendimentosEmpreendimentoIdRouteRoute,
    } as any,
  )
const dashboardDashboardDashboardIdDocumentosDigitaisModelosNovoRoute =
  dashboardDashboardDashboardIdDocumentosDigitaisModelosNovoRouteImport.update({
    id: '/novo',
    path: '/novo',
    getParentRoute: () =>
      dashboardDashboardDashboardIdDocumentosDigitaisModelosRouteRoute,
  } as any)
const dashboardDashboardDashboardIdDocumentosDigitaisModelosModeloIdRoute =
  dashboardDashboardDashboardIdDocumentosDigitaisModelosModeloIdRouteImport.update(
    {
      id: '/$modeloId',
      path: '/$modeloId',
      getParentRoute: () =>
        dashboardDashboardDashboardIdDocumentosDigitaisModelosRouteRoute,
    } as any,
  )
const dashboardDashboardDashboardIdDocumentosDigitaisGeradosNovoRoute =
  dashboardDashboardDashboardIdDocumentosDigitaisGeradosNovoRouteImport.update({
    id: '/gerados/novo',
    path: '/gerados/novo',
    getParentRoute: () =>
      dashboardDashboardDashboardIdDocumentosDigitaisRouteRoute,
  } as any)
const dashboardDashboardDashboardIdContatosIdEditarRoute =
  dashboardDashboardDashboardIdContatosIdEditarRouteImport.update({
    id: '/editar',
    path: '/editar',
    getParentRoute: () => dashboardDashboardDashboardIdContatosIdRouteRoute,
  } as any)
const dashboardDashboardDashboardIdAutomacoesNovaEditarRoute =
  dashboardDashboardDashboardIdAutomacoesNovaEditarRouteImport.update({
    id: '/nova/editar',
    path: '/nova/editar',
    getParentRoute: () => dashboardDashboardDashboardIdAutomacoesRouteRoute,
  } as any)
const dashboardDashboardDashboardIdAutomacoesAutomacaoIdExecucoesRoute =
  dashboardDashboardDashboardIdAutomacoesAutomacaoIdExecucoesRouteImport.update(
    {
      id: '/execucoes',
      path: '/execucoes',
      getParentRoute: () =>
        dashboardDashboardDashboardIdAutomacoesAutomacaoIdRouteRoute,
    } as any,
  )
const dashboardDashboardDashboardIdSitesSiteIdBlogRouteRoute =
  dashboardDashboardDashboardIdSitesSiteIdBlogRouteRouteImport.update({
    id: '/blog',
    path: '/blog',
    getParentRoute: () => dashboardDashboardDashboardIdSitesSiteIdRouteRoute,
  } as any)
const dashboardDashboardDashboardIdDocumentosDigitaisGeradosDocumentoIdRouteRoute =
  dashboardDashboardDashboardIdDocumentosDigitaisGeradosDocumentoIdRouteRouteImport.update(
    {
      id: '/gerados/$documentoId',
      path: '/gerados/$documentoId',
      getParentRoute: () =>
        dashboardDashboardDashboardIdDocumentosDigitaisRouteRoute,
    } as any,
  )
const dashboardDashboardDashboardIdSitesSiteIdBlogIndexRoute =
  dashboardDashboardDashboardIdSitesSiteIdBlogIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      dashboardDashboardDashboardIdSitesSiteIdBlogRouteRoute,
  } as any)
const dashboardDashboardDashboardIdOportunidadesFunilValueOportunidadeIdIndexRoute =
  dashboardDashboardDashboardIdOportunidadesFunilValueOportunidadeIdIndexRouteImport.update(
    {
      id: '/$oportunidadeId/',
      path: '/$oportunidadeId/',
      getParentRoute: () =>
        dashboardDashboardDashboardIdOportunidadesFunilValueRoute,
    } as any,
  )
const dashboardDashboardDashboardIdDocumentosDigitaisGeradosDocumentoIdIndexRoute =
  dashboardDashboardDashboardIdDocumentosDigitaisGeradosDocumentoIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        dashboardDashboardDashboardIdDocumentosDigitaisGeradosDocumentoIdRouteRoute,
    } as any,
  )
const dashboardDashboardDashboardIdConversasChannelInstanceUuidConversationIdIndexRoute =
  dashboardDashboardDashboardIdConversasChannelInstanceUuidConversationIdIndexRouteImport.update(
    {
      id: '/$conversationId/',
      path: '/$conversationId/',
      getParentRoute: () =>
        dashboardDashboardDashboardIdConversasChannelInstanceUuidRouteRoute,
    } as any,
  )
const dashboardDashboardDashboardIdSitesSiteIdBlogNovoRoute =
  dashboardDashboardDashboardIdSitesSiteIdBlogNovoRouteImport.update({
    id: '/novo',
    path: '/novo',
    getParentRoute: () =>
      dashboardDashboardDashboardIdSitesSiteIdBlogRouteRoute,
  } as any)
const dashboardDashboardDashboardIdMarketingCampanhasSegmentadasDetalheCampanhaIdRoute =
  dashboardDashboardDashboardIdMarketingCampanhasSegmentadasDetalheCampanhaIdRouteImport.update(
    {
      id: '/detalhe/$campanhaId',
      path: '/detalhe/$campanhaId',
      getParentRoute: () =>
        dashboardDashboardDashboardIdMarketingCampanhasSegmentadasRouteRoute,
    } as any,
  )
const dashboardDashboardDashboardIdDocumentosDigitaisGeradosDocumentoIdEditarRoute =
  dashboardDashboardDashboardIdDocumentosDigitaisGeradosDocumentoIdEditarRouteImport.update(
    {
      id: '/editar',
      path: '/editar',
      getParentRoute: () =>
        dashboardDashboardDashboardIdDocumentosDigitaisGeradosDocumentoIdRouteRoute,
    } as any,
  )
const dashboardDashboardDashboardIdSitesSiteIdBlogArtigoIdIndexRoute =
  dashboardDashboardDashboardIdSitesSiteIdBlogArtigoIdIndexRouteImport.update({
    id: '/$artigoId/',
    path: '/$artigoId/',
    getParentRoute: () =>
      dashboardDashboardDashboardIdSitesSiteIdBlogRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/abrir-conta': typeof authAbrirContaRoute
  '/app': typeof authAppRoute
  '/configuracao-login': typeof authConfiguracaoLoginRoute
  '/recuperar-senha': typeof authRecuperarSenhaRoute
  '/workspace': typeof authWorkspaceRoute
  '/dashboard': typeof dashboardDashboardRouteWithChildren
  '/atender/$hash': typeof AtenderHashRoute
  '/auth/handoff': typeof AuthHandoffRoute
  '/checkin/$token': typeof CheckinTokenRoute
  '/pulse/$token': typeof PulseTokenRoute
  '/': typeof authIndexRoute
  '/l/$token': typeof authLTokenRoute
  '/dashboard/$dashboardId': typeof dashboardDashboardDashboardIdRouteWithChildren
  '/pulse/preview/$token': typeof PulsePreviewTokenRoute
  '/dashboard/$dashboardId/atividades': typeof dashboardDashboardDashboardIdAtividadesRouteRouteWithChildren
  '/dashboard/$dashboardId/automacoes': typeof dashboardDashboardDashboardIdAutomacoesRouteRouteWithChildren
  '/dashboard/$dashboardId/catalogo': typeof dashboardDashboardDashboardIdCatalogoRouteRouteWithChildren
  '/dashboard/$dashboardId/chat': typeof dashboardDashboardDashboardIdChatRouteRouteWithChildren
  '/dashboard/$dashboardId/chaves': typeof dashboardDashboardDashboardIdChavesRouteRouteWithChildren
  '/dashboard/$dashboardId/colecoes': typeof dashboardDashboardDashboardIdColecoesRouteRouteWithChildren
  '/dashboard/$dashboardId/contatos': typeof dashboardDashboardDashboardIdContatosRouteRouteWithChildren
  '/dashboard/$dashboardId/documentos-digitais': typeof dashboardDashboardDashboardIdDocumentosDigitaisRouteRouteWithChildren
  '/dashboard/$dashboardId/empreendimentos': typeof dashboardDashboardDashboardIdEmpreendimentosRouteRouteWithChildren
  '/dashboard/$dashboardId/financeiro': typeof dashboardDashboardDashboardIdFinanceiroRouteRouteWithChildren
  '/dashboard/$dashboardId/imoveis': typeof dashboardDashboardDashboardIdImoveisRouteRouteWithChildren
  '/dashboard/$dashboardId/incorporadoras': typeof dashboardDashboardDashboardIdIncorporadorasRouteRouteWithChildren
  '/dashboard/$dashboardId/leads': typeof dashboardDashboardDashboardIdLeadsRouteRouteWithChildren
  '/dashboard/$dashboardId/marketing': typeof dashboardDashboardDashboardIdMarketingRouteRouteWithChildren
  '/dashboard/$dashboardId/matches': typeof dashboardDashboardDashboardIdMatchesRouteRoute
  '/dashboard/$dashboardId/oportunidades': typeof dashboardDashboardDashboardIdOportunidadesRouteRouteWithChildren
  '/dashboard/$dashboardId/portais': typeof dashboardDashboardDashboardIdPortaisRouteRouteWithChildren
  '/dashboard/$dashboardId/propostas': typeof dashboardDashboardDashboardIdPropostasRouteRouteWithChildren
  '/dashboard/$dashboardId/relatorio': typeof dashboardDashboardDashboardIdRelatorioRouteRoute
  '/dashboard/$dashboardId/sistema': typeof dashboardDashboardDashboardIdSistemaRouteRouteWithChildren
  '/dashboard/$dashboardId/sites': typeof dashboardDashboardDashboardIdSitesRouteRouteWithChildren
  '/dashboard/$dashboardId/assinar': typeof dashboardDashboardDashboardIdAssinarRoute
  '/dashboard/$dashboardId/suporte': typeof dashboardDashboardDashboardIdSuporteRoute
  '/dashboard/$dashboardId/': typeof dashboardDashboardDashboardIdIndexRoute
  '/dashboard/$dashboardId/automacoes/$automacaoId': typeof dashboardDashboardDashboardIdAutomacoesAutomacaoIdRouteRouteWithChildren
  '/dashboard/$dashboardId/colecoes/$colecaoId': typeof dashboardDashboardDashboardIdColecoesColecaoIdRouteRouteWithChildren
  '/dashboard/$dashboardId/contatos/$id': typeof dashboardDashboardDashboardIdContatosIdRouteRouteWithChildren
  '/dashboard/$dashboardId/conversas/$channelInstanceUuid': typeof dashboardDashboardDashboardIdConversasChannelInstanceUuidRouteRouteWithChildren
  '/dashboard/$dashboardId/documentos-digitais/modelos': typeof dashboardDashboardDashboardIdDocumentosDigitaisModelosRouteRouteWithChildren
  '/dashboard/$dashboardId/empreendimentos/$empreendimentoId': typeof dashboardDashboardDashboardIdEmpreendimentosEmpreendimentoIdRouteRouteWithChildren
  '/dashboard/$dashboardId/imoveis/$imovelId': typeof dashboardDashboardDashboardIdImoveisImovelIdRouteRouteWithChildren
  '/dashboard/$dashboardId/marketing/campanhas-segmentadas': typeof dashboardDashboardDashboardIdMarketingCampanhasSegmentadasRouteRouteWithChildren
  '/dashboard/$dashboardId/marketing/modelos-emails': typeof dashboardDashboardDashboardIdMarketingModelosEmailsRouteRouteWithChildren
  '/dashboard/$dashboardId/marketing/modelos-whatsapp': typeof dashboardDashboardDashboardIdMarketingModelosWhatsappRouteRouteWithChildren
  '/dashboard/$dashboardId/portais/$portalvalue': typeof dashboardDashboardDashboardIdPortaisPortalvalueRouteRouteWithChildren
  '/dashboard/$dashboardId/relatorios/imoveis': typeof dashboardDashboardDashboardIdRelatoriosImoveisRouteRoute
  '/dashboard/$dashboardId/relatorios/leads': typeof dashboardDashboardDashboardIdRelatoriosLeadsRouteRoute
  '/dashboard/$dashboardId/relatorios/oportunidades': typeof dashboardDashboardDashboardIdRelatoriosOportunidadesRouteRoute
  '/dashboard/$dashboardId/sistema/agentes': typeof dashboardDashboardDashboardIdSistemaAgentesRouteRouteWithChildren
  '/dashboard/$dashboardId/sistema/integracoes': typeof dashboardDashboardDashboardIdSistemaIntegracoesRouteRouteWithChildren
  '/dashboard/$dashboardId/sistema/whatsapp': typeof dashboardDashboardDashboardIdSistemaWhatsappRouteRouteWithChildren
  '/dashboard/$dashboardId/sites/$siteId': typeof dashboardDashboardDashboardIdSitesSiteIdRouteRouteWithChildren
  '/dashboard/$dashboardId/catalogo/mapa': typeof dashboardDashboardDashboardIdCatalogoMapaRoute
  '/dashboard/$dashboardId/chat/$chatId': typeof dashboardDashboardDashboardIdChatChatIdRoute
  '/dashboard/$dashboardId/contatos/importar': typeof dashboardDashboardDashboardIdContatosImportarRoute
  '/dashboard/$dashboardId/contatos/novo': typeof dashboardDashboardDashboardIdContatosNovoRoute
  '/dashboard/$dashboardId/financeiro/lancamentos': typeof dashboardDashboardDashboardIdFinanceiroLancamentosRoute
  '/dashboard/$dashboardId/leads/importar': typeof dashboardDashboardDashboardIdLeadsImportarRoute
  '/dashboard/$dashboardId/leads/novo': typeof dashboardDashboardDashboardIdLeadsNovoRoute
  '/dashboard/$dashboardId/marketing/segmentos': typeof dashboardDashboardDashboardIdMarketingSegmentosRoute
  '/dashboard/$dashboardId/oportunidades/$funilValue': typeof dashboardDashboardDashboardIdOportunidadesFunilValueRouteWithChildren
  '/dashboard/$dashboardId/sistema/api-keys': typeof dashboardDashboardDashboardIdSistemaApiKeysRoute
  '/dashboard/$dashboardId/sistema/campos-customizados': typeof dashboardDashboardDashboardIdSistemaCamposCustomizadosRoute
  '/dashboard/$dashboardId/sistema/comodidades': typeof dashboardDashboardDashboardIdSistemaComodidadesRoute
  '/dashboard/$dashboardId/sistema/conversas': typeof dashboardDashboardDashboardIdSistemaConversasRoute
  '/dashboard/$dashboardId/sistema/dados': typeof dashboardDashboardDashboardIdSistemaDadosRoute
  '/dashboard/$dashboardId/sistema/distribuicao-inteligente': typeof dashboardDashboardDashboardIdSistemaDistribuicaoInteligenteRoute
  '/dashboard/$dashboardId/sistema/financeiro': typeof dashboardDashboardDashboardIdSistemaFinanceiroRoute
  '/dashboard/$dashboardId/sistema/funis': typeof dashboardDashboardDashboardIdSistemaFunisRoute
  '/dashboard/$dashboardId/sistema/isa-redatora': typeof dashboardDashboardDashboardIdSistemaIsaRedatoraRoute
  '/dashboard/$dashboardId/sistema/logs': typeof dashboardDashboardDashboardIdSistemaLogsRoute
  '/dashboard/$dashboardId/sistema/meta-leads': typeof dashboardDashboardDashboardIdSistemaMetaLeadsRoute
  '/dashboard/$dashboardId/sistema/motivos-perdas': typeof dashboardDashboardDashboardIdSistemaMotivosPerdasRoute
  '/dashboard/$dashboardId/sistema/plano-faturas': typeof dashboardDashboardDashboardIdSistemaPlanoFaturasRoute
  '/dashboard/$dashboardId/sistema/portais': typeof dashboardDashboardDashboardIdSistemaPortaisRoute
  '/dashboard/$dashboardId/sistema/preview-ctas': typeof dashboardDashboardDashboardIdSistemaPreviewCtasRoute
  '/dashboard/$dashboardId/sistema/pulse-carteira': typeof dashboardDashboardDashboardIdSistemaPulseCarteiraRoute
  '/dashboard/$dashboardId/sistema/usuarios': typeof dashboardDashboardDashboardIdSistemaUsuariosRoute
  '/dashboard/$dashboardId/sistema/watermark': typeof dashboardDashboardDashboardIdSistemaWatermarkRoute
  '/dashboard/$dashboardId/sistema/webhooks': typeof dashboardDashboardDashboardIdSistemaWebhooksRoute
  '/dashboard/$dashboardId/automacoes/': typeof dashboardDashboardDashboardIdAutomacoesIndexRoute
  '/dashboard/$dashboardId/catalogo/': typeof dashboardDashboardDashboardIdCatalogoIndexRoute
  '/dashboard/$dashboardId/chat/': typeof dashboardDashboardDashboardIdChatIndexRoute
  '/dashboard/$dashboardId/colecoes/': typeof dashboardDashboardDashboardIdColecoesIndexRoute
  '/dashboard/$dashboardId/conversas/': typeof dashboardDashboardDashboardIdConversasIndexRoute
  '/dashboard/$dashboardId/documentos-digitais/': typeof dashboardDashboardDashboardIdDocumentosDigitaisIndexRoute
  '/dashboard/$dashboardId/empreendimentos/': typeof dashboardDashboardDashboardIdEmpreendimentosIndexRoute
  '/dashboard/$dashboardId/financeiro/': typeof dashboardDashboardDashboardIdFinanceiroIndexRoute
  '/dashboard/$dashboardId/imoveis/': typeof dashboardDashboardDashboardIdImoveisIndexRoute
  '/dashboard/$dashboardId/incorporadoras/': typeof dashboardDashboardDashboardIdIncorporadorasIndexRoute
  '/dashboard/$dashboardId/marketing/': typeof dashboardDashboardDashboardIdMarketingIndexRoute
  '/dashboard/$dashboardId/oportunidades/': typeof dashboardDashboardDashboardIdOportunidadesIndexRoute
  '/dashboard/$dashboardId/portais/': typeof dashboardDashboardDashboardIdPortaisIndexRoute
  '/dashboard/$dashboardId/sistema/': typeof dashboardDashboardDashboardIdSistemaIndexRoute
  '/dashboard/$dashboardId/sites/': typeof dashboardDashboardDashboardIdSitesIndexRoute
  '/dashboard/$dashboardId/documentos-digitais/gerados/$documentoId': typeof dashboardDashboardDashboardIdDocumentosDigitaisGeradosDocumentoIdRouteRouteWithChildren
  '/dashboard/$dashboardId/sites/$siteId/blog': typeof dashboardDashboardDashboardIdSitesSiteIdBlogRouteRouteWithChildren
  '/dashboard/$dashboardId/automacoes/$automacaoId/execucoes': typeof dashboardDashboardDashboardIdAutomacoesAutomacaoIdExecucoesRoute
  '/dashboard/$dashboardId/automacoes/nova/editar': typeof dashboardDashboardDashboardIdAutomacoesNovaEditarRoute
  '/dashboard/$dashboardId/contatos/$id/editar': typeof dashboardDashboardDashboardIdContatosIdEditarRoute
  '/dashboard/$dashboardId/documentos-digitais/gerados/novo': typeof dashboardDashboardDashboardIdDocumentosDigitaisGeradosNovoRoute
  '/dashboard/$dashboardId/documentos-digitais/modelos/$modeloId': typeof dashboardDashboardDashboardIdDocumentosDigitaisModelosModeloIdRoute
  '/dashboard/$dashboardId/documentos-digitais/modelos/novo': typeof dashboardDashboardDashboardIdDocumentosDigitaisModelosNovoRoute
  '/dashboard/$dashboardId/empreendimentos/$empreendimentoId/editar': typeof dashboardDashboardDashboardIdEmpreendimentosEmpreendimentoIdEditarRoute
  '/dashboard/$dashboardId/imoveis/$imovelId/editar': typeof dashboardDashboardDashboardIdImoveisImovelIdEditarRoute
  '/dashboard/$dashboardId/incorporadoras/$incorporadoraId/editar': typeof dashboardDashboardDashboardIdIncorporadorasIncorporadoraIdEditarRoute
  '/dashboard/$dashboardId/marketing/campanhas-segmentadas/$campanhaId': typeof dashboardDashboardDashboardIdMarketingCampanhasSegmentadasCampanhaIdRoute
  '/dashboard/$dashboardId/marketing/campanhas-segmentadas/novo': typeof dashboardDashboardDashboardIdMarketingCampanhasSegmentadasNovoRoute
  '/dashboard/$dashboardId/marketing/modelos-emails/$templateId': typeof dashboardDashboardDashboardIdMarketingModelosEmailsTemplateIdRoute
  '/dashboard/$dashboardId/marketing/modelos-emails/novo': typeof dashboardDashboardDashboardIdMarketingModelosEmailsNovoRoute
  '/dashboard/$dashboardId/marketing/modelos-whatsapp/$templateId': typeof dashboardDashboardDashboardIdMarketingModelosWhatsappTemplateIdRoute
  '/dashboard/$dashboardId/marketing/modelos-whatsapp/novo': typeof dashboardDashboardDashboardIdMarketingModelosWhatsappNovoRoute
  '/dashboard/$dashboardId/sistema/agentes/$agenteId': typeof dashboardDashboardDashboardIdSistemaAgentesAgenteIdRoute
  '/dashboard/$dashboardId/sistema/agentes/novo': typeof dashboardDashboardDashboardIdSistemaAgentesNovoRoute
  '/dashboard/$dashboardId/sistema/integracoes/autentique': typeof dashboardDashboardDashboardIdSistemaIntegracoesAutentiqueRoute
  '/dashboard/$dashboardId/sistema/integracoes/dwv': typeof dashboardDashboardDashboardIdSistemaIntegracoesDwvRoute
  '/dashboard/$dashboardId/sistema/integracoes/email': typeof dashboardDashboardDashboardIdSistemaIntegracoesEmailRoute
  '/dashboard/$dashboardId/sistema/whatsapp/nova': typeof dashboardDashboardDashboardIdSistemaWhatsappNovaRoute
  '/dashboard/$dashboardId/atividades/$tarefaId/': typeof dashboardDashboardDashboardIdAtividadesTarefaIdIndexRoute
  '/dashboard/$dashboardId/automacoes/$automacaoId/': typeof dashboardDashboardDashboardIdAutomacoesAutomacaoIdIndexRoute
  '/dashboard/$dashboardId/automacoes/nova/': typeof dashboardDashboardDashboardIdAutomacoesNovaIndexRoute
  '/dashboard/$dashboardId/chaves/$registroChaveId/': typeof dashboardDashboardDashboardIdChavesRegistroChaveIdIndexRoute
  '/dashboard/$dashboardId/colecoes/$colecaoId/': typeof dashboardDashboardDashboardIdColecoesColecaoIdIndexRoute
  '/dashboard/$dashboardId/contatos/$id/': typeof dashboardDashboardDashboardIdContatosIdIndexRoute
  '/dashboard/$dashboardId/conversas/$channelInstanceUuid/': typeof dashboardDashboardDashboardIdConversasChannelInstanceUuidIndexRoute
  '/dashboard/$dashboardId/documentos-digitais/assinaturas/': typeof dashboardDashboardDashboardIdDocumentosDigitaisAssinaturasIndexRoute
  '/dashboard/$dashboardId/documentos-digitais/gerados/': typeof dashboardDashboardDashboardIdDocumentosDigitaisGeradosIndexRoute
  '/dashboard/$dashboardId/documentos-digitais/modelos/': typeof dashboardDashboardDashboardIdDocumentosDigitaisModelosIndexRoute
  '/dashboard/$dashboardId/empreendimentos/$empreendimentoId/': typeof dashboardDashboardDashboardIdEmpreendimentosEmpreendimentoIdIndexRoute
  '/dashboard/$dashboardId/imoveis/$imovelId/': typeof dashboardDashboardDashboardIdImoveisImovelIdIndexRoute
  '/dashboard/$dashboardId/incorporadoras/$incorporadoraId/': typeof dashboardDashboardDashboardIdIncorporadorasIncorporadoraIdIndexRoute
  '/dashboard/$dashboardId/leads/$leadId/': typeof dashboardDashboardDashboardIdLeadsLeadIdIndexRoute
  '/dashboard/$dashboardId/marketing/campanhas-segmentadas/': typeof dashboardDashboardDashboardIdMarketingCampanhasSegmentadasIndexRoute
  '/dashboard/$dashboardId/marketing/modelos-emails/': typeof dashboardDashboardDashboardIdMarketingModelosEmailsIndexRoute
  '/dashboard/$dashboardId/marketing/modelos-whatsapp/': typeof dashboardDashboardDashboardIdMarketingModelosWhatsappIndexRoute
  '/dashboard/$dashboardId/portais/$portalvalue/': typeof dashboardDashboardDashboardIdPortaisPortalvalueIndexRoute
  '/dashboard/$dashboardId/propostas/$propostaId/': typeof dashboardDashboardDashboardIdPropostasPropostaIdIndexRoute
  '/dashboard/$dashboardId/sistema/agentes/': typeof dashboardDashboardDashboardIdSistemaAgentesIndexRoute
  '/dashboard/$dashboardId/sistema/integracoes/': typeof dashboardDashboardDashboardIdSistemaIntegracoesIndexRoute
  '/dashboard/$dashboardId/sistema/whatsapp/': typeof dashboardDashboardDashboardIdSistemaWhatsappIndexRoute
  '/dashboard/$dashboardId/sites/$siteId/': typeof dashboardDashboardDashboardIdSitesSiteIdIndexRoute
  '/dashboard/$dashboardId/documentos-digitais/gerados/$documentoId/editar': typeof dashboardDashboardDashboardIdDocumentosDigitaisGeradosDocumentoIdEditarRoute
  '/dashboard/$dashboardId/marketing/campanhas-segmentadas/detalhe/$campanhaId': typeof dashboardDashboardDashboardIdMarketingCampanhasSegmentadasDetalheCampanhaIdRoute
  '/dashboard/$dashboardId/sites/$siteId/blog/novo': typeof dashboardDashboardDashboardIdSitesSiteIdBlogNovoRoute
  '/dashboard/$dashboardId/conversas/$channelInstanceUuid/$conversationId/': typeof dashboardDashboardDashboardIdConversasChannelInstanceUuidConversationIdIndexRoute
  '/dashboard/$dashboardId/documentos-digitais/gerados/$documentoId/': typeof dashboardDashboardDashboardIdDocumentosDigitaisGeradosDocumentoIdIndexRoute
  '/dashboard/$dashboardId/oportunidades/$funilValue/$oportunidadeId/': typeof dashboardDashboardDashboardIdOportunidadesFunilValueOportunidadeIdIndexRoute
  '/dashboard/$dashboardId/sites/$siteId/blog/': typeof dashboardDashboardDashboardIdSitesSiteIdBlogIndexRoute
  '/dashboard/$dashboardId/sites/$siteId/blog/$artigoId/': typeof dashboardDashboardDashboardIdSitesSiteIdBlogArtigoIdIndexRoute
}
export interface FileRoutesByTo {
  '/abrir-conta': typeof authAbrirContaRoute
  '/app': typeof authAppRoute
  '/configuracao-login': typeof authConfiguracaoLoginRoute
  '/recuperar-senha': typeof authRecuperarSenhaRoute
  '/workspace': typeof authWorkspaceRoute
  '/dashboard': typeof dashboardDashboardRouteWithChildren
  '/atender/$hash': typeof AtenderHashRoute
  '/auth/handoff': typeof AuthHandoffRoute
  '/checkin/$token': typeof CheckinTokenRoute
  '/pulse/$token': typeof PulseTokenRoute
  '/': typeof authIndexRoute
  '/l/$token': typeof authLTokenRoute
  '/pulse/preview/$token': typeof PulsePreviewTokenRoute
  '/dashboard/$dashboardId/atividades': typeof dashboardDashboardDashboardIdAtividadesRouteRouteWithChildren
  '/dashboard/$dashboardId/chaves': typeof dashboardDashboardDashboardIdChavesRouteRouteWithChildren
  '/dashboard/$dashboardId/contatos': typeof dashboardDashboardDashboardIdContatosRouteRouteWithChildren
  '/dashboard/$dashboardId/leads': typeof dashboardDashboardDashboardIdLeadsRouteRouteWithChildren
  '/dashboard/$dashboardId/matches': typeof dashboardDashboardDashboardIdMatchesRouteRoute
  '/dashboard/$dashboardId/propostas': typeof dashboardDashboardDashboardIdPropostasRouteRouteWithChildren
  '/dashboard/$dashboardId/relatorio': typeof dashboardDashboardDashboardIdRelatorioRouteRoute
  '/dashboard/$dashboardId/assinar': typeof dashboardDashboardDashboardIdAssinarRoute
  '/dashboard/$dashboardId/suporte': typeof dashboardDashboardDashboardIdSuporteRoute
  '/dashboard/$dashboardId': typeof dashboardDashboardDashboardIdIndexRoute
  '/dashboard/$dashboardId/relatorios/imoveis': typeof dashboardDashboardDashboardIdRelatoriosImoveisRouteRoute
  '/dashboard/$dashboardId/relatorios/leads': typeof dashboardDashboardDashboardIdRelatoriosLeadsRouteRoute
  '/dashboard/$dashboardId/relatorios/oportunidades': typeof dashboardDashboardDashboardIdRelatoriosOportunidadesRouteRoute
  '/dashboard/$dashboardId/catalogo/mapa': typeof dashboardDashboardDashboardIdCatalogoMapaRoute
  '/dashboard/$dashboardId/chat/$chatId': typeof dashboardDashboardDashboardIdChatChatIdRoute
  '/dashboard/$dashboardId/contatos/importar': typeof dashboardDashboardDashboardIdContatosImportarRoute
  '/dashboard/$dashboardId/contatos/novo': typeof dashboardDashboardDashboardIdContatosNovoRoute
  '/dashboard/$dashboardId/financeiro/lancamentos': typeof dashboardDashboardDashboardIdFinanceiroLancamentosRoute
  '/dashboard/$dashboardId/leads/importar': typeof dashboardDashboardDashboardIdLeadsImportarRoute
  '/dashboard/$dashboardId/leads/novo': typeof dashboardDashboardDashboardIdLeadsNovoRoute
  '/dashboard/$dashboardId/marketing/segmentos': typeof dashboardDashboardDashboardIdMarketingSegmentosRoute
  '/dashboard/$dashboardId/oportunidades/$funilValue': typeof dashboardDashboardDashboardIdOportunidadesFunilValueRouteWithChildren
  '/dashboard/$dashboardId/sistema/api-keys': typeof dashboardDashboardDashboardIdSistemaApiKeysRoute
  '/dashboard/$dashboardId/sistema/campos-customizados': typeof dashboardDashboardDashboardIdSistemaCamposCustomizadosRoute
  '/dashboard/$dashboardId/sistema/comodidades': typeof dashboardDashboardDashboardIdSistemaComodidadesRoute
  '/dashboard/$dashboardId/sistema/conversas': typeof dashboardDashboardDashboardIdSistemaConversasRoute
  '/dashboard/$dashboardId/sistema/dados': typeof dashboardDashboardDashboardIdSistemaDadosRoute
  '/dashboard/$dashboardId/sistema/distribuicao-inteligente': typeof dashboardDashboardDashboardIdSistemaDistribuicaoInteligenteRoute
  '/dashboard/$dashboardId/sistema/financeiro': typeof dashboardDashboardDashboardIdSistemaFinanceiroRoute
  '/dashboard/$dashboardId/sistema/funis': typeof dashboardDashboardDashboardIdSistemaFunisRoute
  '/dashboard/$dashboardId/sistema/isa-redatora': typeof dashboardDashboardDashboardIdSistemaIsaRedatoraRoute
  '/dashboard/$dashboardId/sistema/logs': typeof dashboardDashboardDashboardIdSistemaLogsRoute
  '/dashboard/$dashboardId/sistema/meta-leads': typeof dashboardDashboardDashboardIdSistemaMetaLeadsRoute
  '/dashboard/$dashboardId/sistema/motivos-perdas': typeof dashboardDashboardDashboardIdSistemaMotivosPerdasRoute
  '/dashboard/$dashboardId/sistema/plano-faturas': typeof dashboardDashboardDashboardIdSistemaPlanoFaturasRoute
  '/dashboard/$dashboardId/sistema/portais': typeof dashboardDashboardDashboardIdSistemaPortaisRoute
  '/dashboard/$dashboardId/sistema/preview-ctas': typeof dashboardDashboardDashboardIdSistemaPreviewCtasRoute
  '/dashboard/$dashboardId/sistema/pulse-carteira': typeof dashboardDashboardDashboardIdSistemaPulseCarteiraRoute
  '/dashboard/$dashboardId/sistema/usuarios': typeof dashboardDashboardDashboardIdSistemaUsuariosRoute
  '/dashboard/$dashboardId/sistema/watermark': typeof dashboardDashboardDashboardIdSistemaWatermarkRoute
  '/dashboard/$dashboardId/sistema/webhooks': typeof dashboardDashboardDashboardIdSistemaWebhooksRoute
  '/dashboard/$dashboardId/automacoes': typeof dashboardDashboardDashboardIdAutomacoesIndexRoute
  '/dashboard/$dashboardId/catalogo': typeof dashboardDashboardDashboardIdCatalogoIndexRoute
  '/dashboard/$dashboardId/chat': typeof dashboardDashboardDashboardIdChatIndexRoute
  '/dashboard/$dashboardId/colecoes': typeof dashboardDashboardDashboardIdColecoesIndexRoute
  '/dashboard/$dashboardId/conversas': typeof dashboardDashboardDashboardIdConversasIndexRoute
  '/dashboard/$dashboardId/documentos-digitais': typeof dashboardDashboardDashboardIdDocumentosDigitaisIndexRoute
  '/dashboard/$dashboardId/empreendimentos': typeof dashboardDashboardDashboardIdEmpreendimentosIndexRoute
  '/dashboard/$dashboardId/financeiro': typeof dashboardDashboardDashboardIdFinanceiroIndexRoute
  '/dashboard/$dashboardId/imoveis': typeof dashboardDashboardDashboardIdImoveisIndexRoute
  '/dashboard/$dashboardId/incorporadoras': typeof dashboardDashboardDashboardIdIncorporadorasIndexRoute
  '/dashboard/$dashboardId/marketing': typeof dashboardDashboardDashboardIdMarketingIndexRoute
  '/dashboard/$dashboardId/oportunidades': typeof dashboardDashboardDashboardIdOportunidadesIndexRoute
  '/dashboard/$dashboardId/portais': typeof dashboardDashboardDashboardIdPortaisIndexRoute
  '/dashboard/$dashboardId/sistema': typeof dashboardDashboardDashboardIdSistemaIndexRoute
  '/dashboard/$dashboardId/sites': typeof dashboardDashboardDashboardIdSitesIndexRoute
  '/dashboard/$dashboardId/automacoes/$automacaoId/execucoes': typeof dashboardDashboardDashboardIdAutomacoesAutomacaoIdExecucoesRoute
  '/dashboard/$dashboardId/automacoes/nova/editar': typeof dashboardDashboardDashboardIdAutomacoesNovaEditarRoute
  '/dashboard/$dashboardId/contatos/$id/editar': typeof dashboardDashboardDashboardIdContatosIdEditarRoute
  '/dashboard/$dashboardId/documentos-digitais/gerados/novo': typeof dashboardDashboardDashboardIdDocumentosDigitaisGeradosNovoRoute
  '/dashboard/$dashboardId/documentos-digitais/modelos/$modeloId': typeof dashboardDashboardDashboardIdDocumentosDigitaisModelosModeloIdRoute
  '/dashboard/$dashboardId/documentos-digitais/modelos/novo': typeof dashboardDashboardDashboardIdDocumentosDigitaisModelosNovoRoute
  '/dashboard/$dashboardId/empreendimentos/$empreendimentoId/editar': typeof dashboardDashboardDashboardIdEmpreendimentosEmpreendimentoIdEditarRoute
  '/dashboard/$dashboardId/imoveis/$imovelId/editar': typeof dashboardDashboardDashboardIdImoveisImovelIdEditarRoute
  '/dashboard/$dashboardId/incorporadoras/$incorporadoraId/editar': typeof dashboardDashboardDashboardIdIncorporadorasIncorporadoraIdEditarRoute
  '/dashboard/$dashboardId/marketing/campanhas-segmentadas/$campanhaId': typeof dashboardDashboardDashboardIdMarketingCampanhasSegmentadasCampanhaIdRoute
  '/dashboard/$dashboardId/marketing/campanhas-segmentadas/novo': typeof dashboardDashboardDashboardIdMarketingCampanhasSegmentadasNovoRoute
  '/dashboard/$dashboardId/marketing/modelos-emails/$templateId': typeof dashboardDashboardDashboardIdMarketingModelosEmailsTemplateIdRoute
  '/dashboard/$dashboardId/marketing/modelos-emails/novo': typeof dashboardDashboardDashboardIdMarketingModelosEmailsNovoRoute
  '/dashboard/$dashboardId/marketing/modelos-whatsapp/$templateId': typeof dashboardDashboardDashboardIdMarketingModelosWhatsappTemplateIdRoute
  '/dashboard/$dashboardId/marketing/modelos-whatsapp/novo': typeof dashboardDashboardDashboardIdMarketingModelosWhatsappNovoRoute
  '/dashboard/$dashboardId/sistema/agentes/$agenteId': typeof dashboardDashboardDashboardIdSistemaAgentesAgenteIdRoute
  '/dashboard/$dashboardId/sistema/agentes/novo': typeof dashboardDashboardDashboardIdSistemaAgentesNovoRoute
  '/dashboard/$dashboardId/sistema/integracoes/autentique': typeof dashboardDashboardDashboardIdSistemaIntegracoesAutentiqueRoute
  '/dashboard/$dashboardId/sistema/integracoes/dwv': typeof dashboardDashboardDashboardIdSistemaIntegracoesDwvRoute
  '/dashboard/$dashboardId/sistema/integracoes/email': typeof dashboardDashboardDashboardIdSistemaIntegracoesEmailRoute
  '/dashboard/$dashboardId/sistema/whatsapp/nova': typeof dashboardDashboardDashboardIdSistemaWhatsappNovaRoute
  '/dashboard/$dashboardId/atividades/$tarefaId': typeof dashboardDashboardDashboardIdAtividadesTarefaIdIndexRoute
  '/dashboard/$dashboardId/automacoes/$automacaoId': typeof dashboardDashboardDashboardIdAutomacoesAutomacaoIdIndexRoute
  '/dashboard/$dashboardId/automacoes/nova': typeof dashboardDashboardDashboardIdAutomacoesNovaIndexRoute
  '/dashboard/$dashboardId/chaves/$registroChaveId': typeof dashboardDashboardDashboardIdChavesRegistroChaveIdIndexRoute
  '/dashboard/$dashboardId/colecoes/$colecaoId': typeof dashboardDashboardDashboardIdColecoesColecaoIdIndexRoute
  '/dashboard/$dashboardId/contatos/$id': typeof dashboardDashboardDashboardIdContatosIdIndexRoute
  '/dashboard/$dashboardId/conversas/$channelInstanceUuid': typeof dashboardDashboardDashboardIdConversasChannelInstanceUuidIndexRoute
  '/dashboard/$dashboardId/documentos-digitais/assinaturas': typeof dashboardDashboardDashboardIdDocumentosDigitaisAssinaturasIndexRoute
  '/dashboard/$dashboardId/documentos-digitais/gerados': typeof dashboardDashboardDashboardIdDocumentosDigitaisGeradosIndexRoute
  '/dashboard/$dashboardId/documentos-digitais/modelos': typeof dashboardDashboardDashboardIdDocumentosDigitaisModelosIndexRoute
  '/dashboard/$dashboardId/empreendimentos/$empreendimentoId': typeof dashboardDashboardDashboardIdEmpreendimentosEmpreendimentoIdIndexRoute
  '/dashboard/$dashboardId/imoveis/$imovelId': typeof dashboardDashboardDashboardIdImoveisImovelIdIndexRoute
  '/dashboard/$dashboardId/incorporadoras/$incorporadoraId': typeof dashboardDashboardDashboardIdIncorporadorasIncorporadoraIdIndexRoute
  '/dashboard/$dashboardId/leads/$leadId': typeof dashboardDashboardDashboardIdLeadsLeadIdIndexRoute
  '/dashboard/$dashboardId/marketing/campanhas-segmentadas': typeof dashboardDashboardDashboardIdMarketingCampanhasSegmentadasIndexRoute
  '/dashboard/$dashboardId/marketing/modelos-emails': typeof dashboardDashboardDashboardIdMarketingModelosEmailsIndexRoute
  '/dashboard/$dashboardId/marketing/modelos-whatsapp': typeof dashboardDashboardDashboardIdMarketingModelosWhatsappIndexRoute
  '/dashboard/$dashboardId/portais/$portalvalue': typeof dashboardDashboardDashboardIdPortaisPortalvalueIndexRoute
  '/dashboard/$dashboardId/propostas/$propostaId': typeof dashboardDashboardDashboardIdPropostasPropostaIdIndexRoute
  '/dashboard/$dashboardId/sistema/agentes': typeof dashboardDashboardDashboardIdSistemaAgentesIndexRoute
  '/dashboard/$dashboardId/sistema/integracoes': typeof dashboardDashboardDashboardIdSistemaIntegracoesIndexRoute
  '/dashboard/$dashboardId/sistema/whatsapp': typeof dashboardDashboardDashboardIdSistemaWhatsappIndexRoute
  '/dashboard/$dashboardId/sites/$siteId': typeof dashboardDashboardDashboardIdSitesSiteIdIndexRoute
  '/dashboard/$dashboardId/documentos-digitais/gerados/$documentoId/editar': typeof dashboardDashboardDashboardIdDocumentosDigitaisGeradosDocumentoIdEditarRoute
  '/dashboard/$dashboardId/marketing/campanhas-segmentadas/detalhe/$campanhaId': typeof dashboardDashboardDashboardIdMarketingCampanhasSegmentadasDetalheCampanhaIdRoute
  '/dashboard/$dashboardId/sites/$siteId/blog/novo': typeof dashboardDashboardDashboardIdSitesSiteIdBlogNovoRoute
  '/dashboard/$dashboardId/conversas/$channelInstanceUuid/$conversationId': typeof dashboardDashboardDashboardIdConversasChannelInstanceUuidConversationIdIndexRoute
  '/dashboard/$dashboardId/documentos-digitais/gerados/$documentoId': typeof dashboardDashboardDashboardIdDocumentosDigitaisGeradosDocumentoIdIndexRoute
  '/dashboard/$dashboardId/oportunidades/$funilValue/$oportunidadeId': typeof dashboardDashboardDashboardIdOportunidadesFunilValueOportunidadeIdIndexRoute
  '/dashboard/$dashboardId/sites/$siteId/blog': typeof dashboardDashboardDashboardIdSitesSiteIdBlogIndexRoute
  '/dashboard/$dashboardId/sites/$siteId/blog/$artigoId': typeof dashboardDashboardDashboardIdSitesSiteIdBlogArtigoIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/(auth)/abrir-conta': typeof authAbrirContaRoute
  '/(auth)/app': typeof authAppRoute
  '/(auth)/configuracao-login': typeof authConfiguracaoLoginRoute
  '/(auth)/recuperar-senha': typeof authRecuperarSenhaRoute
  '/(auth)/workspace': typeof authWorkspaceRoute
  '/(dashboard)/dashboard': typeof dashboardDashboardRouteWithChildren
  '/atender/$hash': typeof AtenderHashRoute
  '/auth/handoff': typeof AuthHandoffRoute
  '/checkin/$token': typeof CheckinTokenRoute
  '/pulse/$token': typeof PulseTokenRoute
  '/(auth)/': typeof authIndexRoute
  '/(auth)/l/$token': typeof authLTokenRoute
  '/(dashboard)/dashboard/$dashboardId': typeof dashboardDashboardDashboardIdRouteWithChildren
  '/pulse/preview/$token': typeof PulsePreviewTokenRoute
  '/(dashboard)/dashboard/$dashboardId/atividades': typeof dashboardDashboardDashboardIdAtividadesRouteRouteWithChildren
  '/(dashboard)/dashboard/$dashboardId/automacoes': typeof dashboardDashboardDashboardIdAutomacoesRouteRouteWithChildren
  '/(dashboard)/dashboard/$dashboardId/catalogo': typeof dashboardDashboardDashboardIdCatalogoRouteRouteWithChildren
  '/(dashboard)/dashboard/$dashboardId/chat': typeof dashboardDashboardDashboardIdChatRouteRouteWithChildren
  '/(dashboard)/dashboard/$dashboardId/chaves': typeof dashboardDashboardDashboardIdChavesRouteRouteWithChildren
  '/(dashboard)/dashboard/$dashboardId/colecoes': typeof dashboardDashboardDashboardIdColecoesRouteRouteWithChildren
  '/(dashboard)/dashboard/$dashboardId/contatos': typeof dashboardDashboardDashboardIdContatosRouteRouteWithChildren
  '/(dashboard)/dashboard/$dashboardId/documentos-digitais': typeof dashboardDashboardDashboardIdDocumentosDigitaisRouteRouteWithChildren
  '/(dashboard)/dashboard/$dashboardId/empreendimentos': typeof dashboardDashboardDashboardIdEmpreendimentosRouteRouteWithChildren
  '/(dashboard)/dashboard/$dashboardId/financeiro': typeof dashboardDashboardDashboardIdFinanceiroRouteRouteWithChildren
  '/(dashboard)/dashboard/$dashboardId/imoveis': typeof dashboardDashboardDashboardIdImoveisRouteRouteWithChildren
  '/(dashboard)/dashboard/$dashboardId/incorporadoras': typeof dashboardDashboardDashboardIdIncorporadorasRouteRouteWithChildren
  '/(dashboard)/dashboard/$dashboardId/leads': typeof dashboardDashboardDashboardIdLeadsRouteRouteWithChildren
  '/(dashboard)/dashboard/$dashboardId/marketing': typeof dashboardDashboardDashboardIdMarketingRouteRouteWithChildren
  '/(dashboard)/dashboard/$dashboardId/matches': typeof dashboardDashboardDashboardIdMatchesRouteRoute
  '/(dashboard)/dashboard/$dashboardId/oportunidades': typeof dashboardDashboardDashboardIdOportunidadesRouteRouteWithChildren
  '/(dashboard)/dashboard/$dashboardId/portais': typeof dashboardDashboardDashboardIdPortaisRouteRouteWithChildren
  '/(dashboard)/dashboard/$dashboardId/propostas': typeof dashboardDashboardDashboardIdPropostasRouteRouteWithChildren
  '/(dashboard)/dashboard/$dashboardId/relatorio': typeof dashboardDashboardDashboardIdRelatorioRouteRoute
  '/(dashboard)/dashboard/$dashboardId/sistema': typeof dashboardDashboardDashboardIdSistemaRouteRouteWithChildren
  '/(dashboard)/dashboard/$dashboardId/sites': typeof dashboardDashboardDashboardIdSitesRouteRouteWithChildren
  '/(dashboard)/dashboard/$dashboardId/assinar': typeof dashboardDashboardDashboardIdAssinarRoute
  '/(dashboard)/dashboard/$dashboardId/suporte': typeof dashboardDashboardDashboardIdSuporteRoute
  '/(dashboard)/dashboard/$dashboardId/': typeof dashboardDashboardDashboardIdIndexRoute
  '/(dashboard)/dashboard/$dashboardId/automacoes/$automacaoId': typeof dashboardDashboardDashboardIdAutomacoesAutomacaoIdRouteRouteWithChildren
  '/(dashboard)/dashboard/$dashboardId/colecoes/$colecaoId': typeof dashboardDashboardDashboardIdColecoesColecaoIdRouteRouteWithChildren
  '/(dashboard)/dashboard/$dashboardId/contatos/$id': typeof dashboardDashboardDashboardIdContatosIdRouteRouteWithChildren
  '/(dashboard)/dashboard/$dashboardId/conversas/$channelInstanceUuid': typeof dashboardDashboardDashboardIdConversasChannelInstanceUuidRouteRouteWithChildren
  '/(dashboard)/dashboard/$dashboardId/documentos-digitais/modelos': typeof dashboardDashboardDashboardIdDocumentosDigitaisModelosRouteRouteWithChildren
  '/(dashboard)/dashboard/$dashboardId/empreendimentos/$empreendimentoId': typeof dashboardDashboardDashboardIdEmpreendimentosEmpreendimentoIdRouteRouteWithChildren
  '/(dashboard)/dashboard/$dashboardId/imoveis/$imovelId': typeof dashboardDashboardDashboardIdImoveisImovelIdRouteRouteWithChildren
  '/(dashboard)/dashboard/$dashboardId/marketing/campanhas-segmentadas': typeof dashboardDashboardDashboardIdMarketingCampanhasSegmentadasRouteRouteWithChildren
  '/(dashboard)/dashboard/$dashboardId/marketing/modelos-emails': typeof dashboardDashboardDashboardIdMarketingModelosEmailsRouteRouteWithChildren
  '/(dashboard)/dashboard/$dashboardId/marketing/modelos-whatsapp': typeof dashboardDashboardDashboardIdMarketingModelosWhatsappRouteRouteWithChildren
  '/(dashboard)/dashboard/$dashboardId/portais/$portalvalue': typeof dashboardDashboardDashboardIdPortaisPortalvalueRouteRouteWithChildren
  '/(dashboard)/dashboard/$dashboardId/relatorios/imoveis': typeof dashboardDashboardDashboardIdRelatoriosImoveisRouteRoute
  '/(dashboard)/dashboard/$dashboardId/relatorios/leads': typeof dashboardDashboardDashboardIdRelatoriosLeadsRouteRoute
  '/(dashboard)/dashboard/$dashboardId/relatorios/oportunidades': typeof dashboardDashboardDashboardIdRelatoriosOportunidadesRouteRoute
  '/(dashboard)/dashboard/$dashboardId/sistema/agentes': typeof dashboardDashboardDashboardIdSistemaAgentesRouteRouteWithChildren
  '/(dashboard)/dashboard/$dashboardId/sistema/integracoes': typeof dashboardDashboardDashboardIdSistemaIntegracoesRouteRouteWithChildren
  '/(dashboard)/dashboard/$dashboardId/sistema/whatsapp': typeof dashboardDashboardDashboardIdSistemaWhatsappRouteRouteWithChildren
  '/(dashboard)/dashboard/$dashboardId/sites/$siteId': typeof dashboardDashboardDashboardIdSitesSiteIdRouteRouteWithChildren
  '/(dashboard)/dashboard/$dashboardId/catalogo/mapa': typeof dashboardDashboardDashboardIdCatalogoMapaRoute
  '/(dashboard)/dashboard/$dashboardId/chat/$chatId': typeof dashboardDashboardDashboardIdChatChatIdRoute
  '/(dashboard)/dashboard/$dashboardId/contatos/importar': typeof dashboardDashboardDashboardIdContatosImportarRoute
  '/(dashboard)/dashboard/$dashboardId/contatos/novo': typeof dashboardDashboardDashboardIdContatosNovoRoute
  '/(dashboard)/dashboard/$dashboardId/financeiro/lancamentos': typeof dashboardDashboardDashboardIdFinanceiroLancamentosRoute
  '/(dashboard)/dashboard/$dashboardId/leads/importar': typeof dashboardDashboardDashboardIdLeadsImportarRoute
  '/(dashboard)/dashboard/$dashboardId/leads/novo': typeof dashboardDashboardDashboardIdLeadsNovoRoute
  '/(dashboard)/dashboard/$dashboardId/marketing/segmentos': typeof dashboardDashboardDashboardIdMarketingSegmentosRoute
  '/(dashboard)/dashboard/$dashboardId/oportunidades/$funilValue': typeof dashboardDashboardDashboardIdOportunidadesFunilValueRouteWithChildren
  '/(dashboard)/dashboard/$dashboardId/sistema/api-keys': typeof dashboardDashboardDashboardIdSistemaApiKeysRoute
  '/(dashboard)/dashboard/$dashboardId/sistema/campos-customizados': typeof dashboardDashboardDashboardIdSistemaCamposCustomizadosRoute
  '/(dashboard)/dashboard/$dashboardId/sistema/comodidades': typeof dashboardDashboardDashboardIdSistemaComodidadesRoute
  '/(dashboard)/dashboard/$dashboardId/sistema/conversas': typeof dashboardDashboardDashboardIdSistemaConversasRoute
  '/(dashboard)/dashboard/$dashboardId/sistema/dados': typeof dashboardDashboardDashboardIdSistemaDadosRoute
  '/(dashboard)/dashboard/$dashboardId/sistema/distribuicao-inteligente': typeof dashboardDashboardDashboardIdSistemaDistribuicaoInteligenteRoute
  '/(dashboard)/dashboard/$dashboardId/sistema/financeiro': typeof dashboardDashboardDashboardIdSistemaFinanceiroRoute
  '/(dashboard)/dashboard/$dashboardId/sistema/funis': typeof dashboardDashboardDashboardIdSistemaFunisRoute
  '/(dashboard)/dashboard/$dashboardId/sistema/isa-redatora': typeof dashboardDashboardDashboardIdSistemaIsaRedatoraRoute
  '/(dashboard)/dashboard/$dashboardId/sistema/logs': typeof dashboardDashboardDashboardIdSistemaLogsRoute
  '/(dashboard)/dashboard/$dashboardId/sistema/meta-leads': typeof dashboardDashboardDashboardIdSistemaMetaLeadsRoute
  '/(dashboard)/dashboard/$dashboardId/sistema/motivos-perdas': typeof dashboardDashboardDashboardIdSistemaMotivosPerdasRoute
  '/(dashboard)/dashboard/$dashboardId/sistema/plano-faturas': typeof dashboardDashboardDashboardIdSistemaPlanoFaturasRoute
  '/(dashboard)/dashboard/$dashboardId/sistema/portais': typeof dashboardDashboardDashboardIdSistemaPortaisRoute
  '/(dashboard)/dashboard/$dashboardId/sistema/preview-ctas': typeof dashboardDashboardDashboardIdSistemaPreviewCtasRoute
  '/(dashboard)/dashboard/$dashboardId/sistema/pulse-carteira': typeof dashboardDashboardDashboardIdSistemaPulseCarteiraRoute
  '/(dashboard)/dashboard/$dashboardId/sistema/usuarios': typeof dashboardDashboardDashboardIdSistemaUsuariosRoute
  '/(dashboard)/dashboard/$dashboardId/sistema/watermark': typeof dashboardDashboardDashboardIdSistemaWatermarkRoute
  '/(dashboard)/dashboard/$dashboardId/sistema/webhooks': typeof dashboardDashboardDashboardIdSistemaWebhooksRoute
  '/(dashboard)/dashboard/$dashboardId/automacoes/': typeof dashboardDashboardDashboardIdAutomacoesIndexRoute
  '/(dashboard)/dashboard/$dashboardId/catalogo/': typeof dashboardDashboardDashboardIdCatalogoIndexRoute
  '/(dashboard)/dashboard/$dashboardId/chat/': typeof dashboardDashboardDashboardIdChatIndexRoute
  '/(dashboard)/dashboard/$dashboardId/colecoes/': typeof dashboardDashboardDashboardIdColecoesIndexRoute
  '/(dashboard)/dashboard/$dashboardId/conversas/': typeof dashboardDashboardDashboardIdConversasIndexRoute
  '/(dashboard)/dashboard/$dashboardId/documentos-digitais/': typeof dashboardDashboardDashboardIdDocumentosDigitaisIndexRoute
  '/(dashboard)/dashboard/$dashboardId/empreendimentos/': typeof dashboardDashboardDashboardIdEmpreendimentosIndexRoute
  '/(dashboard)/dashboard/$dashboardId/financeiro/': typeof dashboardDashboardDashboardIdFinanceiroIndexRoute
  '/(dashboard)/dashboard/$dashboardId/imoveis/': typeof dashboardDashboardDashboardIdImoveisIndexRoute
  '/(dashboard)/dashboard/$dashboardId/incorporadoras/': typeof dashboardDashboardDashboardIdIncorporadorasIndexRoute
  '/(dashboard)/dashboard/$dashboardId/marketing/': typeof dashboardDashboardDashboardIdMarketingIndexRoute
  '/(dashboard)/dashboard/$dashboardId/oportunidades/': typeof dashboardDashboardDashboardIdOportunidadesIndexRoute
  '/(dashboard)/dashboard/$dashboardId/portais/': typeof dashboardDashboardDashboardIdPortaisIndexRoute
  '/(dashboard)/dashboard/$dashboardId/sistema/': typeof dashboardDashboardDashboardIdSistemaIndexRoute
  '/(dashboard)/dashboard/$dashboardId/sites/': typeof dashboardDashboardDashboardIdSitesIndexRoute
  '/(dashboard)/dashboard/$dashboardId/documentos-digitais/gerados/$documentoId': typeof dashboardDashboardDashboardIdDocumentosDigitaisGeradosDocumentoIdRouteRouteWithChildren
  '/(dashboard)/dashboard/$dashboardId/sites/$siteId/blog': typeof dashboardDashboardDashboardIdSitesSiteIdBlogRouteRouteWithChildren
  '/(dashboard)/dashboard/$dashboardId/automacoes/$automacaoId/execucoes': typeof dashboardDashboardDashboardIdAutomacoesAutomacaoIdExecucoesRoute
  '/(dashboard)/dashboard/$dashboardId/automacoes/nova/editar': typeof dashboardDashboardDashboardIdAutomacoesNovaEditarRoute
  '/(dashboard)/dashboard/$dashboardId/contatos/$id/editar': typeof dashboardDashboardDashboardIdContatosIdEditarRoute
  '/(dashboard)/dashboard/$dashboardId/documentos-digitais/gerados/novo': typeof dashboardDashboardDashboardIdDocumentosDigitaisGeradosNovoRoute
  '/(dashboard)/dashboard/$dashboardId/documentos-digitais/modelos/$modeloId': typeof dashboardDashboardDashboardIdDocumentosDigitaisModelosModeloIdRoute
  '/(dashboard)/dashboard/$dashboardId/documentos-digitais/modelos/novo': typeof dashboardDashboardDashboardIdDocumentosDigitaisModelosNovoRoute
  '/(dashboard)/dashboard/$dashboardId/empreendimentos/$empreendimentoId/editar': typeof dashboardDashboardDashboardIdEmpreendimentosEmpreendimentoIdEditarRoute
  '/(dashboard)/dashboard/$dashboardId/imoveis/$imovelId/editar': typeof dashboardDashboardDashboardIdImoveisImovelIdEditarRoute
  '/(dashboard)/dashboard/$dashboardId/incorporadoras/$incorporadoraId/editar': typeof dashboardDashboardDashboardIdIncorporadorasIncorporadoraIdEditarRoute
  '/(dashboard)/dashboard/$dashboardId/marketing/campanhas-segmentadas/$campanhaId': typeof dashboardDashboardDashboardIdMarketingCampanhasSegmentadasCampanhaIdRoute
  '/(dashboard)/dashboard/$dashboardId/marketing/campanhas-segmentadas/novo': typeof dashboardDashboardDashboardIdMarketingCampanhasSegmentadasNovoRoute
  '/(dashboard)/dashboard/$dashboardId/marketing/modelos-emails/$templateId': typeof dashboardDashboardDashboardIdMarketingModelosEmailsTemplateIdRoute
  '/(dashboard)/dashboard/$dashboardId/marketing/modelos-emails/novo': typeof dashboardDashboardDashboardIdMarketingModelosEmailsNovoRoute
  '/(dashboard)/dashboard/$dashboardId/marketing/modelos-whatsapp/$templateId': typeof dashboardDashboardDashboardIdMarketingModelosWhatsappTemplateIdRoute
  '/(dashboard)/dashboard/$dashboardId/marketing/modelos-whatsapp/novo': typeof dashboardDashboardDashboardIdMarketingModelosWhatsappNovoRoute
  '/(dashboard)/dashboard/$dashboardId/sistema/agentes/$agenteId': typeof dashboardDashboardDashboardIdSistemaAgentesAgenteIdRoute
  '/(dashboard)/dashboard/$dashboardId/sistema/agentes/novo': typeof dashboardDashboardDashboardIdSistemaAgentesNovoRoute
  '/(dashboard)/dashboard/$dashboardId/sistema/integracoes/autentique': typeof dashboardDashboardDashboardIdSistemaIntegracoesAutentiqueRoute
  '/(dashboard)/dashboard/$dashboardId/sistema/integracoes/dwv': typeof dashboardDashboardDashboardIdSistemaIntegracoesDwvRoute
  '/(dashboard)/dashboard/$dashboardId/sistema/integracoes/email': typeof dashboardDashboardDashboardIdSistemaIntegracoesEmailRoute
  '/(dashboard)/dashboard/$dashboardId/sistema/whatsapp/nova': typeof dashboardDashboardDashboardIdSistemaWhatsappNovaRoute
  '/(dashboard)/dashboard/$dashboardId/atividades/$tarefaId/': typeof dashboardDashboardDashboardIdAtividadesTarefaIdIndexRoute
  '/(dashboard)/dashboard/$dashboardId/automacoes/$automacaoId/': typeof dashboardDashboardDashboardIdAutomacoesAutomacaoIdIndexRoute
  '/(dashboard)/dashboard/$dashboardId/automacoes/nova/': typeof dashboardDashboardDashboardIdAutomacoesNovaIndexRoute
  '/(dashboard)/dashboard/$dashboardId/chaves/$registroChaveId/': typeof dashboardDashboardDashboardIdChavesRegistroChaveIdIndexRoute
  '/(dashboard)/dashboard/$dashboardId/colecoes/$colecaoId/': typeof dashboardDashboardDashboardIdColecoesColecaoIdIndexRoute
  '/(dashboard)/dashboard/$dashboardId/contatos/$id/': typeof dashboardDashboardDashboardIdContatosIdIndexRoute
  '/(dashboard)/dashboard/$dashboardId/conversas/$channelInstanceUuid/': typeof dashboardDashboardDashboardIdConversasChannelInstanceUuidIndexRoute
  '/(dashboard)/dashboard/$dashboardId/documentos-digitais/assinaturas/': typeof dashboardDashboardDashboardIdDocumentosDigitaisAssinaturasIndexRoute
  '/(dashboard)/dashboard/$dashboardId/documentos-digitais/gerados/': typeof dashboardDashboardDashboardIdDocumentosDigitaisGeradosIndexRoute
  '/(dashboard)/dashboard/$dashboardId/documentos-digitais/modelos/': typeof dashboardDashboardDashboardIdDocumentosDigitaisModelosIndexRoute
  '/(dashboard)/dashboard/$dashboardId/empreendimentos/$empreendimentoId/': typeof dashboardDashboardDashboardIdEmpreendimentosEmpreendimentoIdIndexRoute
  '/(dashboard)/dashboard/$dashboardId/imoveis/$imovelId/': typeof dashboardDashboardDashboardIdImoveisImovelIdIndexRoute
  '/(dashboard)/dashboard/$dashboardId/incorporadoras/$incorporadoraId/': typeof dashboardDashboardDashboardIdIncorporadorasIncorporadoraIdIndexRoute
  '/(dashboard)/dashboard/$dashboardId/leads/$leadId/': typeof dashboardDashboardDashboardIdLeadsLeadIdIndexRoute
  '/(dashboard)/dashboard/$dashboardId/marketing/campanhas-segmentadas/': typeof dashboardDashboardDashboardIdMarketingCampanhasSegmentadasIndexRoute
  '/(dashboard)/dashboard/$dashboardId/marketing/modelos-emails/': typeof dashboardDashboardDashboardIdMarketingModelosEmailsIndexRoute
  '/(dashboard)/dashboard/$dashboardId/marketing/modelos-whatsapp/': typeof dashboardDashboardDashboardIdMarketingModelosWhatsappIndexRoute
  '/(dashboard)/dashboard/$dashboardId/portais/$portalvalue/': typeof dashboardDashboardDashboardIdPortaisPortalvalueIndexRoute
  '/(dashboard)/dashboard/$dashboardId/propostas/$propostaId/': typeof dashboardDashboardDashboardIdPropostasPropostaIdIndexRoute
  '/(dashboard)/dashboard/$dashboardId/sistema/agentes/': typeof dashboardDashboardDashboardIdSistemaAgentesIndexRoute
  '/(dashboard)/dashboard/$dashboardId/sistema/integracoes/': typeof dashboardDashboardDashboardIdSistemaIntegracoesIndexRoute
  '/(dashboard)/dashboard/$dashboardId/sistema/whatsapp/': typeof dashboardDashboardDashboardIdSistemaWhatsappIndexRoute
  '/(dashboard)/dashboard/$dashboardId/sites/$siteId/': typeof dashboardDashboardDashboardIdSitesSiteIdIndexRoute
  '/(dashboard)/dashboard/$dashboardId/documentos-digitais/gerados/$documentoId/editar': typeof dashboardDashboardDashboardIdDocumentosDigitaisGeradosDocumentoIdEditarRoute
  '/(dashboard)/dashboard/$dashboardId/marketing/campanhas-segmentadas/detalhe/$campanhaId': typeof dashboardDashboardDashboardIdMarketingCampanhasSegmentadasDetalheCampanhaIdRoute
  '/(dashboard)/dashboard/$dashboardId/sites/$siteId/blog/novo': typeof dashboardDashboardDashboardIdSitesSiteIdBlogNovoRoute
  '/(dashboard)/dashboard/$dashboardId/conversas/$channelInstanceUuid/$conversationId/': typeof dashboardDashboardDashboardIdConversasChannelInstanceUuidConversationIdIndexRoute
  '/(dashboard)/dashboard/$dashboardId/documentos-digitais/gerados/$documentoId/': typeof dashboardDashboardDashboardIdDocumentosDigitaisGeradosDocumentoIdIndexRoute
  '/(dashboard)/dashboard/$dashboardId/oportunidades/$funilValue/$oportunidadeId/': typeof dashboardDashboardDashboardIdOportunidadesFunilValueOportunidadeIdIndexRoute
  '/(dashboard)/dashboard/$dashboardId/sites/$siteId/blog/': typeof dashboardDashboardDashboardIdSitesSiteIdBlogIndexRoute
  '/(dashboard)/dashboard/$dashboardId/sites/$siteId/blog/$artigoId/': typeof dashboardDashboardDashboardIdSitesSiteIdBlogArtigoIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/abrir-conta'
    | '/app'
    | '/configuracao-login'
    | '/recuperar-senha'
    | '/workspace'
    | '/dashboard'
    | '/atender/$hash'
    | '/auth/handoff'
    | '/checkin/$token'
    | '/pulse/$token'
    | '/'
    | '/l/$token'
    | '/dashboard/$dashboardId'
    | '/pulse/preview/$token'
    | '/dashboard/$dashboardId/atividades'
    | '/dashboard/$dashboardId/automacoes'
    | '/dashboard/$dashboardId/catalogo'
    | '/dashboard/$dashboardId/chat'
    | '/dashboard/$dashboardId/chaves'
    | '/dashboard/$dashboardId/colecoes'
    | '/dashboard/$dashboardId/contatos'
    | '/dashboard/$dashboardId/documentos-digitais'
    | '/dashboard/$dashboardId/empreendimentos'
    | '/dashboard/$dashboardId/financeiro'
    | '/dashboard/$dashboardId/imoveis'
    | '/dashboard/$dashboardId/incorporadoras'
    | '/dashboard/$dashboardId/leads'
    | '/dashboard/$dashboardId/marketing'
    | '/dashboard/$dashboardId/matches'
    | '/dashboard/$dashboardId/oportunidades'
    | '/dashboard/$dashboardId/portais'
    | '/dashboard/$dashboardId/propostas'
    | '/dashboard/$dashboardId/relatorio'
    | '/dashboard/$dashboardId/sistema'
    | '/dashboard/$dashboardId/sites'
    | '/dashboard/$dashboardId/assinar'
    | '/dashboard/$dashboardId/suporte'
    | '/dashboard/$dashboardId/'
    | '/dashboard/$dashboardId/automacoes/$automacaoId'
    | '/dashboard/$dashboardId/colecoes/$colecaoId'
    | '/dashboard/$dashboardId/contatos/$id'
    | '/dashboard/$dashboardId/conversas/$channelInstanceUuid'
    | '/dashboard/$dashboardId/documentos-digitais/modelos'
    | '/dashboard/$dashboardId/empreendimentos/$empreendimentoId'
    | '/dashboard/$dashboardId/imoveis/$imovelId'
    | '/dashboard/$dashboardId/marketing/campanhas-segmentadas'
    | '/dashboard/$dashboardId/marketing/modelos-emails'
    | '/dashboard/$dashboardId/marketing/modelos-whatsapp'
    | '/dashboard/$dashboardId/portais/$portalvalue'
    | '/dashboard/$dashboardId/relatorios/imoveis'
    | '/dashboard/$dashboardId/relatorios/leads'
    | '/dashboard/$dashboardId/relatorios/oportunidades'
    | '/dashboard/$dashboardId/sistema/agentes'
    | '/dashboard/$dashboardId/sistema/integracoes'
    | '/dashboard/$dashboardId/sistema/whatsapp'
    | '/dashboard/$dashboardId/sites/$siteId'
    | '/dashboard/$dashboardId/catalogo/mapa'
    | '/dashboard/$dashboardId/chat/$chatId'
    | '/dashboard/$dashboardId/contatos/importar'
    | '/dashboard/$dashboardId/contatos/novo'
    | '/dashboard/$dashboardId/financeiro/lancamentos'
    | '/dashboard/$dashboardId/leads/importar'
    | '/dashboard/$dashboardId/leads/novo'
    | '/dashboard/$dashboardId/marketing/segmentos'
    | '/dashboard/$dashboardId/oportunidades/$funilValue'
    | '/dashboard/$dashboardId/sistema/api-keys'
    | '/dashboard/$dashboardId/sistema/campos-customizados'
    | '/dashboard/$dashboardId/sistema/comodidades'
    | '/dashboard/$dashboardId/sistema/conversas'
    | '/dashboard/$dashboardId/sistema/dados'
    | '/dashboard/$dashboardId/sistema/distribuicao-inteligente'
    | '/dashboard/$dashboardId/sistema/financeiro'
    | '/dashboard/$dashboardId/sistema/funis'
    | '/dashboard/$dashboardId/sistema/isa-redatora'
    | '/dashboard/$dashboardId/sistema/logs'
    | '/dashboard/$dashboardId/sistema/meta-leads'
    | '/dashboard/$dashboardId/sistema/motivos-perdas'
    | '/dashboard/$dashboardId/sistema/plano-faturas'
    | '/dashboard/$dashboardId/sistema/portais'
    | '/dashboard/$dashboardId/sistema/preview-ctas'
    | '/dashboard/$dashboardId/sistema/pulse-carteira'
    | '/dashboard/$dashboardId/sistema/usuarios'
    | '/dashboard/$dashboardId/sistema/watermark'
    | '/dashboard/$dashboardId/sistema/webhooks'
    | '/dashboard/$dashboardId/automacoes/'
    | '/dashboard/$dashboardId/catalogo/'
    | '/dashboard/$dashboardId/chat/'
    | '/dashboard/$dashboardId/colecoes/'
    | '/dashboard/$dashboardId/conversas/'
    | '/dashboard/$dashboardId/documentos-digitais/'
    | '/dashboard/$dashboardId/empreendimentos/'
    | '/dashboard/$dashboardId/financeiro/'
    | '/dashboard/$dashboardId/imoveis/'
    | '/dashboard/$dashboardId/incorporadoras/'
    | '/dashboard/$dashboardId/marketing/'
    | '/dashboard/$dashboardId/oportunidades/'
    | '/dashboard/$dashboardId/portais/'
    | '/dashboard/$dashboardId/sistema/'
    | '/dashboard/$dashboardId/sites/'
    | '/dashboard/$dashboardId/documentos-digitais/gerados/$documentoId'
    | '/dashboard/$dashboardId/sites/$siteId/blog'
    | '/dashboard/$dashboardId/automacoes/$automacaoId/execucoes'
    | '/dashboard/$dashboardId/automacoes/nova/editar'
    | '/dashboard/$dashboardId/contatos/$id/editar'
    | '/dashboard/$dashboardId/documentos-digitais/gerados/novo'
    | '/dashboard/$dashboardId/documentos-digitais/modelos/$modeloId'
    | '/dashboard/$dashboardId/documentos-digitais/modelos/novo'
    | '/dashboard/$dashboardId/empreendimentos/$empreendimentoId/editar'
    | '/dashboard/$dashboardId/imoveis/$imovelId/editar'
    | '/dashboard/$dashboardId/incorporadoras/$incorporadoraId/editar'
    | '/dashboard/$dashboardId/marketing/campanhas-segmentadas/$campanhaId'
    | '/dashboard/$dashboardId/marketing/campanhas-segmentadas/novo'
    | '/dashboard/$dashboardId/marketing/modelos-emails/$templateId'
    | '/dashboard/$dashboardId/marketing/modelos-emails/novo'
    | '/dashboard/$dashboardId/marketing/modelos-whatsapp/$templateId'
    | '/dashboard/$dashboardId/marketing/modelos-whatsapp/novo'
    | '/dashboard/$dashboardId/sistema/agentes/$agenteId'
    | '/dashboard/$dashboardId/sistema/agentes/novo'
    | '/dashboard/$dashboardId/sistema/integracoes/autentique'
    | '/dashboard/$dashboardId/sistema/integracoes/dwv'
    | '/dashboard/$dashboardId/sistema/integracoes/email'
    | '/dashboard/$dashboardId/sistema/whatsapp/nova'
    | '/dashboard/$dashboardId/atividades/$tarefaId/'
    | '/dashboard/$dashboardId/automacoes/$automacaoId/'
    | '/dashboard/$dashboardId/automacoes/nova/'
    | '/dashboard/$dashboardId/chaves/$registroChaveId/'
    | '/dashboard/$dashboardId/colecoes/$colecaoId/'
    | '/dashboard/$dashboardId/contatos/$id/'
    | '/dashboard/$dashboardId/conversas/$channelInstanceUuid/'
    | '/dashboard/$dashboardId/documentos-digitais/assinaturas/'
    | '/dashboard/$dashboardId/documentos-digitais/gerados/'
    | '/dashboard/$dashboardId/documentos-digitais/modelos/'
    | '/dashboard/$dashboardId/empreendimentos/$empreendimentoId/'
    | '/dashboard/$dashboardId/imoveis/$imovelId/'
    | '/dashboard/$dashboardId/incorporadoras/$incorporadoraId/'
    | '/dashboard/$dashboardId/leads/$leadId/'
    | '/dashboard/$dashboardId/marketing/campanhas-segmentadas/'
    | '/dashboard/$dashboardId/marketing/modelos-emails/'
    | '/dashboard/$dashboardId/marketing/modelos-whatsapp/'
    | '/dashboard/$dashboardId/portais/$portalvalue/'
    | '/dashboard/$dashboardId/propostas/$propostaId/'
    | '/dashboard/$dashboardId/sistema/agentes/'
    | '/dashboard/$dashboardId/sistema/integracoes/'
    | '/dashboard/$dashboardId/sistema/whatsapp/'
    | '/dashboard/$dashboardId/sites/$siteId/'
    | '/dashboard/$dashboardId/documentos-digitais/gerados/$documentoId/editar'
    | '/dashboard/$dashboardId/marketing/campanhas-segmentadas/detalhe/$campanhaId'
    | '/dashboard/$dashboardId/sites/$siteId/blog/novo'
    | '/dashboard/$dashboardId/conversas/$channelInstanceUuid/$conversationId/'
    | '/dashboard/$dashboardId/documentos-digitais/gerados/$documentoId/'
    | '/dashboard/$dashboardId/oportunidades/$funilValue/$oportunidadeId/'
    | '/dashboard/$dashboardId/sites/$siteId/blog/'
    | '/dashboard/$dashboardId/sites/$siteId/blog/$artigoId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/abrir-conta'
    | '/app'
    | '/configuracao-login'
    | '/recuperar-senha'
    | '/workspace'
    | '/dashboard'
    | '/atender/$hash'
    | '/auth/handoff'
    | '/checkin/$token'
    | '/pulse/$token'
    | '/'
    | '/l/$token'
    | '/pulse/preview/$token'
    | '/dashboard/$dashboardId/atividades'
    | '/dashboard/$dashboardId/chaves'
    | '/dashboard/$dashboardId/contatos'
    | '/dashboard/$dashboardId/leads'
    | '/dashboard/$dashboardId/matches'
    | '/dashboard/$dashboardId/propostas'
    | '/dashboard/$dashboardId/relatorio'
    | '/dashboard/$dashboardId/assinar'
    | '/dashboard/$dashboardId/suporte'
    | '/dashboard/$dashboardId'
    | '/dashboard/$dashboardId/relatorios/imoveis'
    | '/dashboard/$dashboardId/relatorios/leads'
    | '/dashboard/$dashboardId/relatorios/oportunidades'
    | '/dashboard/$dashboardId/catalogo/mapa'
    | '/dashboard/$dashboardId/chat/$chatId'
    | '/dashboard/$dashboardId/contatos/importar'
    | '/dashboard/$dashboardId/contatos/novo'
    | '/dashboard/$dashboardId/financeiro/lancamentos'
    | '/dashboard/$dashboardId/leads/importar'
    | '/dashboard/$dashboardId/leads/novo'
    | '/dashboard/$dashboardId/marketing/segmentos'
    | '/dashboard/$dashboardId/oportunidades/$funilValue'
    | '/dashboard/$dashboardId/sistema/api-keys'
    | '/dashboard/$dashboardId/sistema/campos-customizados'
    | '/dashboard/$dashboardId/sistema/comodidades'
    | '/dashboard/$dashboardId/sistema/conversas'
    | '/dashboard/$dashboardId/sistema/dados'
    | '/dashboard/$dashboardId/sistema/distribuicao-inteligente'
    | '/dashboard/$dashboardId/sistema/financeiro'
    | '/dashboard/$dashboardId/sistema/funis'
    | '/dashboard/$dashboardId/sistema/isa-redatora'
    | '/dashboard/$dashboardId/sistema/logs'
    | '/dashboard/$dashboardId/sistema/meta-leads'
    | '/dashboard/$dashboardId/sistema/motivos-perdas'
    | '/dashboard/$dashboardId/sistema/plano-faturas'
    | '/dashboard/$dashboardId/sistema/portais'
    | '/dashboard/$dashboardId/sistema/preview-ctas'
    | '/dashboard/$dashboardId/sistema/pulse-carteira'
    | '/dashboard/$dashboardId/sistema/usuarios'
    | '/dashboard/$dashboardId/sistema/watermark'
    | '/dashboard/$dashboardId/sistema/webhooks'
    | '/dashboard/$dashboardId/automacoes'
    | '/dashboard/$dashboardId/catalogo'
    | '/dashboard/$dashboardId/chat'
    | '/dashboard/$dashboardId/colecoes'
    | '/dashboard/$dashboardId/conversas'
    | '/dashboard/$dashboardId/documentos-digitais'
    | '/dashboard/$dashboardId/empreendimentos'
    | '/dashboard/$dashboardId/financeiro'
    | '/dashboard/$dashboardId/imoveis'
    | '/dashboard/$dashboardId/incorporadoras'
    | '/dashboard/$dashboardId/marketing'
    | '/dashboard/$dashboardId/oportunidades'
    | '/dashboard/$dashboardId/portais'
    | '/dashboard/$dashboardId/sistema'
    | '/dashboard/$dashboardId/sites'
    | '/dashboard/$dashboardId/automacoes/$automacaoId/execucoes'
    | '/dashboard/$dashboardId/automacoes/nova/editar'
    | '/dashboard/$dashboardId/contatos/$id/editar'
    | '/dashboard/$dashboardId/documentos-digitais/gerados/novo'
    | '/dashboard/$dashboardId/documentos-digitais/modelos/$modeloId'
    | '/dashboard/$dashboardId/documentos-digitais/modelos/novo'
    | '/dashboard/$dashboardId/empreendimentos/$empreendimentoId/editar'
    | '/dashboard/$dashboardId/imoveis/$imovelId/editar'
    | '/dashboard/$dashboardId/incorporadoras/$incorporadoraId/editar'
    | '/dashboard/$dashboardId/marketing/campanhas-segmentadas/$campanhaId'
    | '/dashboard/$dashboardId/marketing/campanhas-segmentadas/novo'
    | '/dashboard/$dashboardId/marketing/modelos-emails/$templateId'
    | '/dashboard/$dashboardId/marketing/modelos-emails/novo'
    | '/dashboard/$dashboardId/marketing/modelos-whatsapp/$templateId'
    | '/dashboard/$dashboardId/marketing/modelos-whatsapp/novo'
    | '/dashboard/$dashboardId/sistema/agentes/$agenteId'
    | '/dashboard/$dashboardId/sistema/agentes/novo'
    | '/dashboard/$dashboardId/sistema/integracoes/autentique'
    | '/dashboard/$dashboardId/sistema/integracoes/dwv'
    | '/dashboard/$dashboardId/sistema/integracoes/email'
    | '/dashboard/$dashboardId/sistema/whatsapp/nova'
    | '/dashboard/$dashboardId/atividades/$tarefaId'
    | '/dashboard/$dashboardId/automacoes/$automacaoId'
    | '/dashboard/$dashboardId/automacoes/nova'
    | '/dashboard/$dashboardId/chaves/$registroChaveId'
    | '/dashboard/$dashboardId/colecoes/$colecaoId'
    | '/dashboard/$dashboardId/contatos/$id'
    | '/dashboard/$dashboardId/conversas/$channelInstanceUuid'
    | '/dashboard/$dashboardId/documentos-digitais/assinaturas'
    | '/dashboard/$dashboardId/documentos-digitais/gerados'
    | '/dashboard/$dashboardId/documentos-digitais/modelos'
    | '/dashboard/$dashboardId/empreendimentos/$empreendimentoId'
    | '/dashboard/$dashboardId/imoveis/$imovelId'
    | '/dashboard/$dashboardId/incorporadoras/$incorporadoraId'
    | '/dashboard/$dashboardId/leads/$leadId'
    | '/dashboard/$dashboardId/marketing/campanhas-segmentadas'
    | '/dashboard/$dashboardId/marketing/modelos-emails'
    | '/dashboard/$dashboardId/marketing/modelos-whatsapp'
    | '/dashboard/$dashboardId/portais/$portalvalue'
    | '/dashboard/$dashboardId/propostas/$propostaId'
    | '/dashboard/$dashboardId/sistema/agentes'
    | '/dashboard/$dashboardId/sistema/integracoes'
    | '/dashboard/$dashboardId/sistema/whatsapp'
    | '/dashboard/$dashboardId/sites/$siteId'
    | '/dashboard/$dashboardId/documentos-digitais/gerados/$documentoId/editar'
    | '/dashboard/$dashboardId/marketing/campanhas-segmentadas/detalhe/$campanhaId'
    | '/dashboard/$dashboardId/sites/$siteId/blog/novo'
    | '/dashboard/$dashboardId/conversas/$channelInstanceUuid/$conversationId'
    | '/dashboard/$dashboardId/documentos-digitais/gerados/$documentoId'
    | '/dashboard/$dashboardId/oportunidades/$funilValue/$oportunidadeId'
    | '/dashboard/$dashboardId/sites/$siteId/blog'
    | '/dashboard/$dashboardId/sites/$siteId/blog/$artigoId'
  id:
    | '__root__'
    | '/(auth)/abrir-conta'
    | '/(auth)/app'
    | '/(auth)/configuracao-login'
    | '/(auth)/recuperar-senha'
    | '/(auth)/workspace'
    | '/(dashboard)/dashboard'
    | '/atender/$hash'
    | '/auth/handoff'
    | '/checkin/$token'
    | '/pulse/$token'
    | '/(auth)/'
    | '/(auth)/l/$token'
    | '/(dashboard)/dashboard/$dashboardId'
    | '/pulse/preview/$token'
    | '/(dashboard)/dashboard/$dashboardId/atividades'
    | '/(dashboard)/dashboard/$dashboardId/automacoes'
    | '/(dashboard)/dashboard/$dashboardId/catalogo'
    | '/(dashboard)/dashboard/$dashboardId/chat'
    | '/(dashboard)/dashboard/$dashboardId/chaves'
    | '/(dashboard)/dashboard/$dashboardId/colecoes'
    | '/(dashboard)/dashboard/$dashboardId/contatos'
    | '/(dashboard)/dashboard/$dashboardId/documentos-digitais'
    | '/(dashboard)/dashboard/$dashboardId/empreendimentos'
    | '/(dashboard)/dashboard/$dashboardId/financeiro'
    | '/(dashboard)/dashboard/$dashboardId/imoveis'
    | '/(dashboard)/dashboard/$dashboardId/incorporadoras'
    | '/(dashboard)/dashboard/$dashboardId/leads'
    | '/(dashboard)/dashboard/$dashboardId/marketing'
    | '/(dashboard)/dashboard/$dashboardId/matches'
    | '/(dashboard)/dashboard/$dashboardId/oportunidades'
    | '/(dashboard)/dashboard/$dashboardId/portais'
    | '/(dashboard)/dashboard/$dashboardId/propostas'
    | '/(dashboard)/dashboard/$dashboardId/relatorio'
    | '/(dashboard)/dashboard/$dashboardId/sistema'
    | '/(dashboard)/dashboard/$dashboardId/sites'
    | '/(dashboard)/dashboard/$dashboardId/assinar'
    | '/(dashboard)/dashboard/$dashboardId/suporte'
    | '/(dashboard)/dashboard/$dashboardId/'
    | '/(dashboard)/dashboard/$dashboardId/automacoes/$automacaoId'
    | '/(dashboard)/dashboard/$dashboardId/colecoes/$colecaoId'
    | '/(dashboard)/dashboard/$dashboardId/contatos/$id'
    | '/(dashboard)/dashboard/$dashboardId/conversas/$channelInstanceUuid'
    | '/(dashboard)/dashboard/$dashboardId/documentos-digitais/modelos'
    | '/(dashboard)/dashboard/$dashboardId/empreendimentos/$empreendimentoId'
    | '/(dashboard)/dashboard/$dashboardId/imoveis/$imovelId'
    | '/(dashboard)/dashboard/$dashboardId/marketing/campanhas-segmentadas'
    | '/(dashboard)/dashboard/$dashboardId/marketing/modelos-emails'
    | '/(dashboard)/dashboard/$dashboardId/marketing/modelos-whatsapp'
    | '/(dashboard)/dashboard/$dashboardId/portais/$portalvalue'
    | '/(dashboard)/dashboard/$dashboardId/relatorios/imoveis'
    | '/(dashboard)/dashboard/$dashboardId/relatorios/leads'
    | '/(dashboard)/dashboard/$dashboardId/relatorios/oportunidades'
    | '/(dashboard)/dashboard/$dashboardId/sistema/agentes'
    | '/(dashboard)/dashboard/$dashboardId/sistema/integracoes'
    | '/(dashboard)/dashboard/$dashboardId/sistema/whatsapp'
    | '/(dashboard)/dashboard/$dashboardId/sites/$siteId'
    | '/(dashboard)/dashboard/$dashboardId/catalogo/mapa'
    | '/(dashboard)/dashboard/$dashboardId/chat/$chatId'
    | '/(dashboard)/dashboard/$dashboardId/contatos/importar'
    | '/(dashboard)/dashboard/$dashboardId/contatos/novo'
    | '/(dashboard)/dashboard/$dashboardId/financeiro/lancamentos'
    | '/(dashboard)/dashboard/$dashboardId/leads/importar'
    | '/(dashboard)/dashboard/$dashboardId/leads/novo'
    | '/(dashboard)/dashboard/$dashboardId/marketing/segmentos'
    | '/(dashboard)/dashboard/$dashboardId/oportunidades/$funilValue'
    | '/(dashboard)/dashboard/$dashboardId/sistema/api-keys'
    | '/(dashboard)/dashboard/$dashboardId/sistema/campos-customizados'
    | '/(dashboard)/dashboard/$dashboardId/sistema/comodidades'
    | '/(dashboard)/dashboard/$dashboardId/sistema/conversas'
    | '/(dashboard)/dashboard/$dashboardId/sistema/dados'
    | '/(dashboard)/dashboard/$dashboardId/sistema/distribuicao-inteligente'
    | '/(dashboard)/dashboard/$dashboardId/sistema/financeiro'
    | '/(dashboard)/dashboard/$dashboardId/sistema/funis'
    | '/(dashboard)/dashboard/$dashboardId/sistema/isa-redatora'
    | '/(dashboard)/dashboard/$dashboardId/sistema/logs'
    | '/(dashboard)/dashboard/$dashboardId/sistema/meta-leads'
    | '/(dashboard)/dashboard/$dashboardId/sistema/motivos-perdas'
    | '/(dashboard)/dashboard/$dashboardId/sistema/plano-faturas'
    | '/(dashboard)/dashboard/$dashboardId/sistema/portais'
    | '/(dashboard)/dashboard/$dashboardId/sistema/preview-ctas'
    | '/(dashboard)/dashboard/$dashboardId/sistema/pulse-carteira'
    | '/(dashboard)/dashboard/$dashboardId/sistema/usuarios'
    | '/(dashboard)/dashboard/$dashboardId/sistema/watermark'
    | '/(dashboard)/dashboard/$dashboardId/sistema/webhooks'
    | '/(dashboard)/dashboard/$dashboardId/automacoes/'
    | '/(dashboard)/dashboard/$dashboardId/catalogo/'
    | '/(dashboard)/dashboard/$dashboardId/chat/'
    | '/(dashboard)/dashboard/$dashboardId/colecoes/'
    | '/(dashboard)/dashboard/$dashboardId/conversas/'
    | '/(dashboard)/dashboard/$dashboardId/documentos-digitais/'
    | '/(dashboard)/dashboard/$dashboardId/empreendimentos/'
    | '/(dashboard)/dashboard/$dashboardId/financeiro/'
    | '/(dashboard)/dashboard/$dashboardId/imoveis/'
    | '/(dashboard)/dashboard/$dashboardId/incorporadoras/'
    | '/(dashboard)/dashboard/$dashboardId/marketing/'
    | '/(dashboard)/dashboard/$dashboardId/oportunidades/'
    | '/(dashboard)/dashboard/$dashboardId/portais/'
    | '/(dashboard)/dashboard/$dashboardId/sistema/'
    | '/(dashboard)/dashboard/$dashboardId/sites/'
    | '/(dashboard)/dashboard/$dashboardId/documentos-digitais/gerados/$documentoId'
    | '/(dashboard)/dashboard/$dashboardId/sites/$siteId/blog'
    | '/(dashboard)/dashboard/$dashboardId/automacoes/$automacaoId/execucoes'
    | '/(dashboard)/dashboard/$dashboardId/automacoes/nova/editar'
    | '/(dashboard)/dashboard/$dashboardId/contatos/$id/editar'
    | '/(dashboard)/dashboard/$dashboardId/documentos-digitais/gerados/novo'
    | '/(dashboard)/dashboard/$dashboardId/documentos-digitais/modelos/$modeloId'
    | '/(dashboard)/dashboard/$dashboardId/documentos-digitais/modelos/novo'
    | '/(dashboard)/dashboard/$dashboardId/empreendimentos/$empreendimentoId/editar'
    | '/(dashboard)/dashboard/$dashboardId/imoveis/$imovelId/editar'
    | '/(dashboard)/dashboard/$dashboardId/incorporadoras/$incorporadoraId/editar'
    | '/(dashboard)/dashboard/$dashboardId/marketing/campanhas-segmentadas/$campanhaId'
    | '/(dashboard)/dashboard/$dashboardId/marketing/campanhas-segmentadas/novo'
    | '/(dashboard)/dashboard/$dashboardId/marketing/modelos-emails/$templateId'
    | '/(dashboard)/dashboard/$dashboardId/marketing/modelos-emails/novo'
    | '/(dashboard)/dashboard/$dashboardId/marketing/modelos-whatsapp/$templateId'
    | '/(dashboard)/dashboard/$dashboardId/marketing/modelos-whatsapp/novo'
    | '/(dashboard)/dashboard/$dashboardId/sistema/agentes/$agenteId'
    | '/(dashboard)/dashboard/$dashboardId/sistema/agentes/novo'
    | '/(dashboard)/dashboard/$dashboardId/sistema/integracoes/autentique'
    | '/(dashboard)/dashboard/$dashboardId/sistema/integracoes/dwv'
    | '/(dashboard)/dashboard/$dashboardId/sistema/integracoes/email'
    | '/(dashboard)/dashboard/$dashboardId/sistema/whatsapp/nova'
    | '/(dashboard)/dashboard/$dashboardId/atividades/$tarefaId/'
    | '/(dashboard)/dashboard/$dashboardId/automacoes/$automacaoId/'
    | '/(dashboard)/dashboard/$dashboardId/automacoes/nova/'
    | '/(dashboard)/dashboard/$dashboardId/chaves/$registroChaveId/'
    | '/(dashboard)/dashboard/$dashboardId/colecoes/$colecaoId/'
    | '/(dashboard)/dashboard/$dashboardId/contatos/$id/'
    | '/(dashboard)/dashboard/$dashboardId/conversas/$channelInstanceUuid/'
    | '/(dashboard)/dashboard/$dashboardId/documentos-digitais/assinaturas/'
    | '/(dashboard)/dashboard/$dashboardId/documentos-digitais/gerados/'
    | '/(dashboard)/dashboard/$dashboardId/documentos-digitais/modelos/'
    | '/(dashboard)/dashboard/$dashboardId/empreendimentos/$empreendimentoId/'
    | '/(dashboard)/dashboard/$dashboardId/imoveis/$imovelId/'
    | '/(dashboard)/dashboard/$dashboardId/incorporadoras/$incorporadoraId/'
    | '/(dashboard)/dashboard/$dashboardId/leads/$leadId/'
    | '/(dashboard)/dashboard/$dashboardId/marketing/campanhas-segmentadas/'
    | '/(dashboard)/dashboard/$dashboardId/marketing/modelos-emails/'
    | '/(dashboard)/dashboard/$dashboardId/marketing/modelos-whatsapp/'
    | '/(dashboard)/dashboard/$dashboardId/portais/$portalvalue/'
    | '/(dashboard)/dashboard/$dashboardId/propostas/$propostaId/'
    | '/(dashboard)/dashboard/$dashboardId/sistema/agentes/'
    | '/(dashboard)/dashboard/$dashboardId/sistema/integracoes/'
    | '/(dashboard)/dashboard/$dashboardId/sistema/whatsapp/'
    | '/(dashboard)/dashboard/$dashboardId/sites/$siteId/'
    | '/(dashboard)/dashboard/$dashboardId/documentos-digitais/gerados/$documentoId/editar'
    | '/(dashboard)/dashboard/$dashboardId/marketing/campanhas-segmentadas/detalhe/$campanhaId'
    | '/(dashboard)/dashboard/$dashboardId/sites/$siteId/blog/novo'
    | '/(dashboard)/dashboard/$dashboardId/conversas/$channelInstanceUuid/$conversationId/'
    | '/(dashboard)/dashboard/$dashboardId/documentos-digitais/gerados/$documentoId/'
    | '/(dashboard)/dashboard/$dashboardId/oportunidades/$funilValue/$oportunidadeId/'
    | '/(dashboard)/dashboard/$dashboardId/sites/$siteId/blog/'
    | '/(dashboard)/dashboard/$dashboardId/sites/$siteId/blog/$artigoId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  authAbrirContaRoute: typeof authAbrirContaRoute
  authAppRoute: typeof authAppRoute
  authConfiguracaoLoginRoute: typeof authConfiguracaoLoginRoute
  authRecuperarSenhaRoute: typeof authRecuperarSenhaRoute
  authWorkspaceRoute: typeof authWorkspaceRoute
  dashboardDashboardRoute: typeof dashboardDashboardRouteWithChildren
  AtenderHashRoute: typeof AtenderHashRoute
  AuthHandoffRoute: typeof AuthHandoffRoute
  CheckinTokenRoute: typeof CheckinTokenRoute
  PulseTokenRoute: typeof PulseTokenRoute
  authIndexRoute: typeof authIndexRoute
  authLTokenRoute: typeof authLTokenRoute
  PulsePreviewTokenRoute: typeof PulsePreviewTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/(auth)/': {
      id: '/(auth)/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof authIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pulse/$token': {
      id: '/pulse/$token'
      path: '/pulse/$token'
      fullPath: '/pulse/$token'
      preLoaderRoute: typeof PulseTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkin/$token': {
      id: '/checkin/$token'
      path: '/checkin/$token'
      fullPath: '/checkin/$token'
      preLoaderRoute: typeof CheckinTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/handoff': {
      id: '/auth/handoff'
      path: '/auth/handoff'
      fullPath: '/auth/handoff'
      preLoaderRoute: typeof AuthHandoffRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/atender/$hash': {
      id: '/atender/$hash'
      path: '/atender/$hash'
      fullPath: '/atender/$hash'
      preLoaderRoute: typeof AtenderHashRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(dashboard)/dashboard': {
      id: '/(dashboard)/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof dashboardDashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/workspace': {
      id: '/(auth)/workspace'
      path: '/workspace'
      fullPath: '/workspace'
      preLoaderRoute: typeof authWorkspaceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/recuperar-senha': {
      id: '/(auth)/recuperar-senha'
      path: '/recuperar-senha'
      fullPath: '/recuperar-senha'
      preLoaderRoute: typeof authRecuperarSenhaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/configuracao-login': {
      id: '/(auth)/configuracao-login'
      path: '/configuracao-login'
      fullPath: '/configuracao-login'
      preLoaderRoute: typeof authConfiguracaoLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/app': {
      id: '/(auth)/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof authAppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/abrir-conta': {
      id: '/(auth)/abrir-conta'
      path: '/abrir-conta'
      fullPath: '/abrir-conta'
      preLoaderRoute: typeof authAbrirContaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pulse/preview/$token': {
      id: '/pulse/preview/$token'
      path: '/pulse/preview/$token'
      fullPath: '/pulse/preview/$token'
      preLoaderRoute: typeof PulsePreviewTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(dashboard)/dashboard/$dashboardId': {
      id: '/(dashboard)/dashboard/$dashboardId'
      path: '/$dashboardId'
      fullPath: '/dashboard/$dashboardId'
      preLoaderRoute: typeof dashboardDashboardDashboardIdRouteImport
      parentRoute: typeof dashboardDashboardRoute
    }
    '/(auth)/l/$token': {
      id: '/(auth)/l/$token'
      path: '/l/$token'
      fullPath: '/l/$token'
      preLoaderRoute: typeof authLTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(dashboard)/dashboard/$dashboardId/': {
      id: '/(dashboard)/dashboard/$dashboardId/'
      path: '/'
      fullPath: '/dashboard/$dashboardId/'
      preLoaderRoute: typeof dashboardDashboardDashboardIdIndexRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdRoute
    }
    '/(dashboard)/dashboard/$dashboardId/suporte': {
      id: '/(dashboard)/dashboard/$dashboardId/suporte'
      path: '/suporte'
      fullPath: '/dashboard/$dashboardId/suporte'
      preLoaderRoute: typeof dashboardDashboardDashboardIdSuporteRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdRoute
    }
    '/(dashboard)/dashboard/$dashboardId/assinar': {
      id: '/(dashboard)/dashboard/$dashboardId/assinar'
      path: '/assinar'
      fullPath: '/dashboard/$dashboardId/assinar'
      preLoaderRoute: typeof dashboardDashboardDashboardIdAssinarRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdRoute
    }
    '/(dashboard)/dashboard/$dashboardId/sites': {
      id: '/(dashboard)/dashboard/$dashboardId/sites'
      path: '/sites'
      fullPath: '/dashboard/$dashboardId/sites'
      preLoaderRoute: typeof dashboardDashboardDashboardIdSitesRouteRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdRoute
    }
    '/(dashboard)/dashboard/$dashboardId/sistema': {
      id: '/(dashboard)/dashboard/$dashboardId/sistema'
      path: '/sistema'
      fullPath: '/dashboard/$dashboardId/sistema'
      preLoaderRoute: typeof dashboardDashboardDashboardIdSistemaRouteRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdRoute
    }
    '/(dashboard)/dashboard/$dashboardId/relatorio': {
      id: '/(dashboard)/dashboard/$dashboardId/relatorio'
      path: '/relatorio'
      fullPath: '/dashboard/$dashboardId/relatorio'
      preLoaderRoute: typeof dashboardDashboardDashboardIdRelatorioRouteRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdRoute
    }
    '/(dashboard)/dashboard/$dashboardId/propostas': {
      id: '/(dashboard)/dashboard/$dashboardId/propostas'
      path: '/propostas'
      fullPath: '/dashboard/$dashboardId/propostas'
      preLoaderRoute: typeof dashboardDashboardDashboardIdPropostasRouteRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdRoute
    }
    '/(dashboard)/dashboard/$dashboardId/portais': {
      id: '/(dashboard)/dashboard/$dashboardId/portais'
      path: '/portais'
      fullPath: '/dashboard/$dashboardId/portais'
      preLoaderRoute: typeof dashboardDashboardDashboardIdPortaisRouteRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdRoute
    }
    '/(dashboard)/dashboard/$dashboardId/oportunidades': {
      id: '/(dashboard)/dashboard/$dashboardId/oportunidades'
      path: '/oportunidades'
      fullPath: '/dashboard/$dashboardId/oportunidades'
      preLoaderRoute: typeof dashboardDashboardDashboardIdOportunidadesRouteRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdRoute
    }
    '/(dashboard)/dashboard/$dashboardId/matches': {
      id: '/(dashboard)/dashboard/$dashboardId/matches'
      path: '/matches'
      fullPath: '/dashboard/$dashboardId/matches'
      preLoaderRoute: typeof dashboardDashboardDashboardIdMatchesRouteRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdRoute
    }
    '/(dashboard)/dashboard/$dashboardId/marketing': {
      id: '/(dashboard)/dashboard/$dashboardId/marketing'
      path: '/marketing'
      fullPath: '/dashboard/$dashboardId/marketing'
      preLoaderRoute: typeof dashboardDashboardDashboardIdMarketingRouteRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdRoute
    }
    '/(dashboard)/dashboard/$dashboardId/leads': {
      id: '/(dashboard)/dashboard/$dashboardId/leads'
      path: '/leads'
      fullPath: '/dashboard/$dashboardId/leads'
      preLoaderRoute: typeof dashboardDashboardDashboardIdLeadsRouteRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdRoute
    }
    '/(dashboard)/dashboard/$dashboardId/incorporadoras': {
      id: '/(dashboard)/dashboard/$dashboardId/incorporadoras'
      path: '/incorporadoras'
      fullPath: '/dashboard/$dashboardId/incorporadoras'
      preLoaderRoute: typeof dashboardDashboardDashboardIdIncorporadorasRouteRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdRoute
    }
    '/(dashboard)/dashboard/$dashboardId/imoveis': {
      id: '/(dashboard)/dashboard/$dashboardId/imoveis'
      path: '/imoveis'
      fullPath: '/dashboard/$dashboardId/imoveis'
      preLoaderRoute: typeof dashboardDashboardDashboardIdImoveisRouteRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdRoute
    }
    '/(dashboard)/dashboard/$dashboardId/financeiro': {
      id: '/(dashboard)/dashboard/$dashboardId/financeiro'
      path: '/financeiro'
      fullPath: '/dashboard/$dashboardId/financeiro'
      preLoaderRoute: typeof dashboardDashboardDashboardIdFinanceiroRouteRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdRoute
    }
    '/(dashboard)/dashboard/$dashboardId/empreendimentos': {
      id: '/(dashboard)/dashboard/$dashboardId/empreendimentos'
      path: '/empreendimentos'
      fullPath: '/dashboard/$dashboardId/empreendimentos'
      preLoaderRoute: typeof dashboardDashboardDashboardIdEmpreendimentosRouteRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdRoute
    }
    '/(dashboard)/dashboard/$dashboardId/documentos-digitais': {
      id: '/(dashboard)/dashboard/$dashboardId/documentos-digitais'
      path: '/documentos-digitais'
      fullPath: '/dashboard/$dashboardId/documentos-digitais'
      preLoaderRoute: typeof dashboardDashboardDashboardIdDocumentosDigitaisRouteRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdRoute
    }
    '/(dashboard)/dashboard/$dashboardId/contatos': {
      id: '/(dashboard)/dashboard/$dashboardId/contatos'
      path: '/contatos'
      fullPath: '/dashboard/$dashboardId/contatos'
      preLoaderRoute: typeof dashboardDashboardDashboardIdContatosRouteRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdRoute
    }
    '/(dashboard)/dashboard/$dashboardId/colecoes': {
      id: '/(dashboard)/dashboard/$dashboardId/colecoes'
      path: '/colecoes'
      fullPath: '/dashboard/$dashboardId/colecoes'
      preLoaderRoute: typeof dashboardDashboardDashboardIdColecoesRouteRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdRoute
    }
    '/(dashboard)/dashboard/$dashboardId/chaves': {
      id: '/(dashboard)/dashboard/$dashboardId/chaves'
      path: '/chaves'
      fullPath: '/dashboard/$dashboardId/chaves'
      preLoaderRoute: typeof dashboardDashboardDashboardIdChavesRouteRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdRoute
    }
    '/(dashboard)/dashboard/$dashboardId/chat': {
      id: '/(dashboard)/dashboard/$dashboardId/chat'
      path: '/chat'
      fullPath: '/dashboard/$dashboardId/chat'
      preLoaderRoute: typeof dashboardDashboardDashboardIdChatRouteRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdRoute
    }
    '/(dashboard)/dashboard/$dashboardId/catalogo': {
      id: '/(dashboard)/dashboard/$dashboardId/catalogo'
      path: '/catalogo'
      fullPath: '/dashboard/$dashboardId/catalogo'
      preLoaderRoute: typeof dashboardDashboardDashboardIdCatalogoRouteRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdRoute
    }
    '/(dashboard)/dashboard/$dashboardId/automacoes': {
      id: '/(dashboard)/dashboard/$dashboardId/automacoes'
      path: '/automacoes'
      fullPath: '/dashboard/$dashboardId/automacoes'
      preLoaderRoute: typeof dashboardDashboardDashboardIdAutomacoesRouteRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdRoute
    }
    '/(dashboard)/dashboard/$dashboardId/atividades': {
      id: '/(dashboard)/dashboard/$dashboardId/atividades'
      path: '/atividades'
      fullPath: '/dashboard/$dashboardId/atividades'
      preLoaderRoute: typeof dashboardDashboardDashboardIdAtividadesRouteRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdRoute
    }
    '/(dashboard)/dashboard/$dashboardId/sites/': {
      id: '/(dashboard)/dashboard/$dashboardId/sites/'
      path: '/'
      fullPath: '/dashboard/$dashboardId/sites/'
      preLoaderRoute: typeof dashboardDashboardDashboardIdSitesIndexRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdSitesRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/sistema/': {
      id: '/(dashboard)/dashboard/$dashboardId/sistema/'
      path: '/'
      fullPath: '/dashboard/$dashboardId/sistema/'
      preLoaderRoute: typeof dashboardDashboardDashboardIdSistemaIndexRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdSistemaRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/portais/': {
      id: '/(dashboard)/dashboard/$dashboardId/portais/'
      path: '/'
      fullPath: '/dashboard/$dashboardId/portais/'
      preLoaderRoute: typeof dashboardDashboardDashboardIdPortaisIndexRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdPortaisRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/oportunidades/': {
      id: '/(dashboard)/dashboard/$dashboardId/oportunidades/'
      path: '/'
      fullPath: '/dashboard/$dashboardId/oportunidades/'
      preLoaderRoute: typeof dashboardDashboardDashboardIdOportunidadesIndexRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdOportunidadesRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/marketing/': {
      id: '/(dashboard)/dashboard/$dashboardId/marketing/'
      path: '/'
      fullPath: '/dashboard/$dashboardId/marketing/'
      preLoaderRoute: typeof dashboardDashboardDashboardIdMarketingIndexRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdMarketingRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/incorporadoras/': {
      id: '/(dashboard)/dashboard/$dashboardId/incorporadoras/'
      path: '/'
      fullPath: '/dashboard/$dashboardId/incorporadoras/'
      preLoaderRoute: typeof dashboardDashboardDashboardIdIncorporadorasIndexRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdIncorporadorasRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/imoveis/': {
      id: '/(dashboard)/dashboard/$dashboardId/imoveis/'
      path: '/'
      fullPath: '/dashboard/$dashboardId/imoveis/'
      preLoaderRoute: typeof dashboardDashboardDashboardIdImoveisIndexRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdImoveisRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/financeiro/': {
      id: '/(dashboard)/dashboard/$dashboardId/financeiro/'
      path: '/'
      fullPath: '/dashboard/$dashboardId/financeiro/'
      preLoaderRoute: typeof dashboardDashboardDashboardIdFinanceiroIndexRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdFinanceiroRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/empreendimentos/': {
      id: '/(dashboard)/dashboard/$dashboardId/empreendimentos/'
      path: '/'
      fullPath: '/dashboard/$dashboardId/empreendimentos/'
      preLoaderRoute: typeof dashboardDashboardDashboardIdEmpreendimentosIndexRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdEmpreendimentosRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/documentos-digitais/': {
      id: '/(dashboard)/dashboard/$dashboardId/documentos-digitais/'
      path: '/'
      fullPath: '/dashboard/$dashboardId/documentos-digitais/'
      preLoaderRoute: typeof dashboardDashboardDashboardIdDocumentosDigitaisIndexRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdDocumentosDigitaisRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/conversas/': {
      id: '/(dashboard)/dashboard/$dashboardId/conversas/'
      path: '/conversas'
      fullPath: '/dashboard/$dashboardId/conversas/'
      preLoaderRoute: typeof dashboardDashboardDashboardIdConversasIndexRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdRoute
    }
    '/(dashboard)/dashboard/$dashboardId/colecoes/': {
      id: '/(dashboard)/dashboard/$dashboardId/colecoes/'
      path: '/'
      fullPath: '/dashboard/$dashboardId/colecoes/'
      preLoaderRoute: typeof dashboardDashboardDashboardIdColecoesIndexRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdColecoesRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/chat/': {
      id: '/(dashboard)/dashboard/$dashboardId/chat/'
      path: '/'
      fullPath: '/dashboard/$dashboardId/chat/'
      preLoaderRoute: typeof dashboardDashboardDashboardIdChatIndexRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdChatRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/catalogo/': {
      id: '/(dashboard)/dashboard/$dashboardId/catalogo/'
      path: '/'
      fullPath: '/dashboard/$dashboardId/catalogo/'
      preLoaderRoute: typeof dashboardDashboardDashboardIdCatalogoIndexRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdCatalogoRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/automacoes/': {
      id: '/(dashboard)/dashboard/$dashboardId/automacoes/'
      path: '/'
      fullPath: '/dashboard/$dashboardId/automacoes/'
      preLoaderRoute: typeof dashboardDashboardDashboardIdAutomacoesIndexRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdAutomacoesRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/sistema/webhooks': {
      id: '/(dashboard)/dashboard/$dashboardId/sistema/webhooks'
      path: '/webhooks'
      fullPath: '/dashboard/$dashboardId/sistema/webhooks'
      preLoaderRoute: typeof dashboardDashboardDashboardIdSistemaWebhooksRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdSistemaRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/sistema/watermark': {
      id: '/(dashboard)/dashboard/$dashboardId/sistema/watermark'
      path: '/watermark'
      fullPath: '/dashboard/$dashboardId/sistema/watermark'
      preLoaderRoute: typeof dashboardDashboardDashboardIdSistemaWatermarkRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdSistemaRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/sistema/usuarios': {
      id: '/(dashboard)/dashboard/$dashboardId/sistema/usuarios'
      path: '/usuarios'
      fullPath: '/dashboard/$dashboardId/sistema/usuarios'
      preLoaderRoute: typeof dashboardDashboardDashboardIdSistemaUsuariosRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdSistemaRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/sistema/pulse-carteira': {
      id: '/(dashboard)/dashboard/$dashboardId/sistema/pulse-carteira'
      path: '/pulse-carteira'
      fullPath: '/dashboard/$dashboardId/sistema/pulse-carteira'
      preLoaderRoute: typeof dashboardDashboardDashboardIdSistemaPulseCarteiraRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdSistemaRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/sistema/preview-ctas': {
      id: '/(dashboard)/dashboard/$dashboardId/sistema/preview-ctas'
      path: '/preview-ctas'
      fullPath: '/dashboard/$dashboardId/sistema/preview-ctas'
      preLoaderRoute: typeof dashboardDashboardDashboardIdSistemaPreviewCtasRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdSistemaRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/sistema/portais': {
      id: '/(dashboard)/dashboard/$dashboardId/sistema/portais'
      path: '/portais'
      fullPath: '/dashboard/$dashboardId/sistema/portais'
      preLoaderRoute: typeof dashboardDashboardDashboardIdSistemaPortaisRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdSistemaRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/sistema/plano-faturas': {
      id: '/(dashboard)/dashboard/$dashboardId/sistema/plano-faturas'
      path: '/plano-faturas'
      fullPath: '/dashboard/$dashboardId/sistema/plano-faturas'
      preLoaderRoute: typeof dashboardDashboardDashboardIdSistemaPlanoFaturasRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdSistemaRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/sistema/motivos-perdas': {
      id: '/(dashboard)/dashboard/$dashboardId/sistema/motivos-perdas'
      path: '/motivos-perdas'
      fullPath: '/dashboard/$dashboardId/sistema/motivos-perdas'
      preLoaderRoute: typeof dashboardDashboardDashboardIdSistemaMotivosPerdasRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdSistemaRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/sistema/meta-leads': {
      id: '/(dashboard)/dashboard/$dashboardId/sistema/meta-leads'
      path: '/meta-leads'
      fullPath: '/dashboard/$dashboardId/sistema/meta-leads'
      preLoaderRoute: typeof dashboardDashboardDashboardIdSistemaMetaLeadsRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdSistemaRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/sistema/logs': {
      id: '/(dashboard)/dashboard/$dashboardId/sistema/logs'
      path: '/logs'
      fullPath: '/dashboard/$dashboardId/sistema/logs'
      preLoaderRoute: typeof dashboardDashboardDashboardIdSistemaLogsRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdSistemaRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/sistema/isa-redatora': {
      id: '/(dashboard)/dashboard/$dashboardId/sistema/isa-redatora'
      path: '/isa-redatora'
      fullPath: '/dashboard/$dashboardId/sistema/isa-redatora'
      preLoaderRoute: typeof dashboardDashboardDashboardIdSistemaIsaRedatoraRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdSistemaRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/sistema/funis': {
      id: '/(dashboard)/dashboard/$dashboardId/sistema/funis'
      path: '/funis'
      fullPath: '/dashboard/$dashboardId/sistema/funis'
      preLoaderRoute: typeof dashboardDashboardDashboardIdSistemaFunisRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdSistemaRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/sistema/financeiro': {
      id: '/(dashboard)/dashboard/$dashboardId/sistema/financeiro'
      path: '/financeiro'
      fullPath: '/dashboard/$dashboardId/sistema/financeiro'
      preLoaderRoute: typeof dashboardDashboardDashboardIdSistemaFinanceiroRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdSistemaRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/sistema/distribuicao-inteligente': {
      id: '/(dashboard)/dashboard/$dashboardId/sistema/distribuicao-inteligente'
      path: '/distribuicao-inteligente'
      fullPath: '/dashboard/$dashboardId/sistema/distribuicao-inteligente'
      preLoaderRoute: typeof dashboardDashboardDashboardIdSistemaDistribuicaoInteligenteRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdSistemaRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/sistema/dados': {
      id: '/(dashboard)/dashboard/$dashboardId/sistema/dados'
      path: '/dados'
      fullPath: '/dashboard/$dashboardId/sistema/dados'
      preLoaderRoute: typeof dashboardDashboardDashboardIdSistemaDadosRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdSistemaRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/sistema/conversas': {
      id: '/(dashboard)/dashboard/$dashboardId/sistema/conversas'
      path: '/conversas'
      fullPath: '/dashboard/$dashboardId/sistema/conversas'
      preLoaderRoute: typeof dashboardDashboardDashboardIdSistemaConversasRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdSistemaRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/sistema/comodidades': {
      id: '/(dashboard)/dashboard/$dashboardId/sistema/comodidades'
      path: '/comodidades'
      fullPath: '/dashboard/$dashboardId/sistema/comodidades'
      preLoaderRoute: typeof dashboardDashboardDashboardIdSistemaComodidadesRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdSistemaRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/sistema/campos-customizados': {
      id: '/(dashboard)/dashboard/$dashboardId/sistema/campos-customizados'
      path: '/campos-customizados'
      fullPath: '/dashboard/$dashboardId/sistema/campos-customizados'
      preLoaderRoute: typeof dashboardDashboardDashboardIdSistemaCamposCustomizadosRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdSistemaRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/sistema/api-keys': {
      id: '/(dashboard)/dashboard/$dashboardId/sistema/api-keys'
      path: '/api-keys'
      fullPath: '/dashboard/$dashboardId/sistema/api-keys'
      preLoaderRoute: typeof dashboardDashboardDashboardIdSistemaApiKeysRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdSistemaRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/oportunidades/$funilValue': {
      id: '/(dashboard)/dashboard/$dashboardId/oportunidades/$funilValue'
      path: '/$funilValue'
      fullPath: '/dashboard/$dashboardId/oportunidades/$funilValue'
      preLoaderRoute: typeof dashboardDashboardDashboardIdOportunidadesFunilValueRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdOportunidadesRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/marketing/segmentos': {
      id: '/(dashboard)/dashboard/$dashboardId/marketing/segmentos'
      path: '/segmentos'
      fullPath: '/dashboard/$dashboardId/marketing/segmentos'
      preLoaderRoute: typeof dashboardDashboardDashboardIdMarketingSegmentosRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdMarketingRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/leads/novo': {
      id: '/(dashboard)/dashboard/$dashboardId/leads/novo'
      path: '/novo'
      fullPath: '/dashboard/$dashboardId/leads/novo'
      preLoaderRoute: typeof dashboardDashboardDashboardIdLeadsNovoRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdLeadsRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/leads/importar': {
      id: '/(dashboard)/dashboard/$dashboardId/leads/importar'
      path: '/importar'
      fullPath: '/dashboard/$dashboardId/leads/importar'
      preLoaderRoute: typeof dashboardDashboardDashboardIdLeadsImportarRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdLeadsRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/financeiro/lancamentos': {
      id: '/(dashboard)/dashboard/$dashboardId/financeiro/lancamentos'
      path: '/lancamentos'
      fullPath: '/dashboard/$dashboardId/financeiro/lancamentos'
      preLoaderRoute: typeof dashboardDashboardDashboardIdFinanceiroLancamentosRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdFinanceiroRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/contatos/novo': {
      id: '/(dashboard)/dashboard/$dashboardId/contatos/novo'
      path: '/novo'
      fullPath: '/dashboard/$dashboardId/contatos/novo'
      preLoaderRoute: typeof dashboardDashboardDashboardIdContatosNovoRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdContatosRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/contatos/importar': {
      id: '/(dashboard)/dashboard/$dashboardId/contatos/importar'
      path: '/importar'
      fullPath: '/dashboard/$dashboardId/contatos/importar'
      preLoaderRoute: typeof dashboardDashboardDashboardIdContatosImportarRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdContatosRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/chat/$chatId': {
      id: '/(dashboard)/dashboard/$dashboardId/chat/$chatId'
      path: '/$chatId'
      fullPath: '/dashboard/$dashboardId/chat/$chatId'
      preLoaderRoute: typeof dashboardDashboardDashboardIdChatChatIdRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdChatRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/catalogo/mapa': {
      id: '/(dashboard)/dashboard/$dashboardId/catalogo/mapa'
      path: '/mapa'
      fullPath: '/dashboard/$dashboardId/catalogo/mapa'
      preLoaderRoute: typeof dashboardDashboardDashboardIdCatalogoMapaRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdCatalogoRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/sites/$siteId': {
      id: '/(dashboard)/dashboard/$dashboardId/sites/$siteId'
      path: '/$siteId'
      fullPath: '/dashboard/$dashboardId/sites/$siteId'
      preLoaderRoute: typeof dashboardDashboardDashboardIdSitesSiteIdRouteRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdSitesRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/sistema/whatsapp': {
      id: '/(dashboard)/dashboard/$dashboardId/sistema/whatsapp'
      path: '/whatsapp'
      fullPath: '/dashboard/$dashboardId/sistema/whatsapp'
      preLoaderRoute: typeof dashboardDashboardDashboardIdSistemaWhatsappRouteRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdSistemaRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/sistema/integracoes': {
      id: '/(dashboard)/dashboard/$dashboardId/sistema/integracoes'
      path: '/integracoes'
      fullPath: '/dashboard/$dashboardId/sistema/integracoes'
      preLoaderRoute: typeof dashboardDashboardDashboardIdSistemaIntegracoesRouteRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdSistemaRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/sistema/agentes': {
      id: '/(dashboard)/dashboard/$dashboardId/sistema/agentes'
      path: '/agentes'
      fullPath: '/dashboard/$dashboardId/sistema/agentes'
      preLoaderRoute: typeof dashboardDashboardDashboardIdSistemaAgentesRouteRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdSistemaRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/relatorios/oportunidades': {
      id: '/(dashboard)/dashboard/$dashboardId/relatorios/oportunidades'
      path: '/relatorios/oportunidades'
      fullPath: '/dashboard/$dashboardId/relatorios/oportunidades'
      preLoaderRoute: typeof dashboardDashboardDashboardIdRelatoriosOportunidadesRouteRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdRoute
    }
    '/(dashboard)/dashboard/$dashboardId/relatorios/leads': {
      id: '/(dashboard)/dashboard/$dashboardId/relatorios/leads'
      path: '/relatorios/leads'
      fullPath: '/dashboard/$dashboardId/relatorios/leads'
      preLoaderRoute: typeof dashboardDashboardDashboardIdRelatoriosLeadsRouteRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdRoute
    }
    '/(dashboard)/dashboard/$dashboardId/relatorios/imoveis': {
      id: '/(dashboard)/dashboard/$dashboardId/relatorios/imoveis'
      path: '/relatorios/imoveis'
      fullPath: '/dashboard/$dashboardId/relatorios/imoveis'
      preLoaderRoute: typeof dashboardDashboardDashboardIdRelatoriosImoveisRouteRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdRoute
    }
    '/(dashboard)/dashboard/$dashboardId/portais/$portalvalue': {
      id: '/(dashboard)/dashboard/$dashboardId/portais/$portalvalue'
      path: '/$portalvalue'
      fullPath: '/dashboard/$dashboardId/portais/$portalvalue'
      preLoaderRoute: typeof dashboardDashboardDashboardIdPortaisPortalvalueRouteRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdPortaisRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/marketing/modelos-whatsapp': {
      id: '/(dashboard)/dashboard/$dashboardId/marketing/modelos-whatsapp'
      path: '/modelos-whatsapp'
      fullPath: '/dashboard/$dashboardId/marketing/modelos-whatsapp'
      preLoaderRoute: typeof dashboardDashboardDashboardIdMarketingModelosWhatsappRouteRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdMarketingRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/marketing/modelos-emails': {
      id: '/(dashboard)/dashboard/$dashboardId/marketing/modelos-emails'
      path: '/modelos-emails'
      fullPath: '/dashboard/$dashboardId/marketing/modelos-emails'
      preLoaderRoute: typeof dashboardDashboardDashboardIdMarketingModelosEmailsRouteRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdMarketingRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/marketing/campanhas-segmentadas': {
      id: '/(dashboard)/dashboard/$dashboardId/marketing/campanhas-segmentadas'
      path: '/campanhas-segmentadas'
      fullPath: '/dashboard/$dashboardId/marketing/campanhas-segmentadas'
      preLoaderRoute: typeof dashboardDashboardDashboardIdMarketingCampanhasSegmentadasRouteRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdMarketingRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/imoveis/$imovelId': {
      id: '/(dashboard)/dashboard/$dashboardId/imoveis/$imovelId'
      path: '/$imovelId'
      fullPath: '/dashboard/$dashboardId/imoveis/$imovelId'
      preLoaderRoute: typeof dashboardDashboardDashboardIdImoveisImovelIdRouteRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdImoveisRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/empreendimentos/$empreendimentoId': {
      id: '/(dashboard)/dashboard/$dashboardId/empreendimentos/$empreendimentoId'
      path: '/$empreendimentoId'
      fullPath: '/dashboard/$dashboardId/empreendimentos/$empreendimentoId'
      preLoaderRoute: typeof dashboardDashboardDashboardIdEmpreendimentosEmpreendimentoIdRouteRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdEmpreendimentosRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/documentos-digitais/modelos': {
      id: '/(dashboard)/dashboard/$dashboardId/documentos-digitais/modelos'
      path: '/modelos'
      fullPath: '/dashboard/$dashboardId/documentos-digitais/modelos'
      preLoaderRoute: typeof dashboardDashboardDashboardIdDocumentosDigitaisModelosRouteRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdDocumentosDigitaisRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/conversas/$channelInstanceUuid': {
      id: '/(dashboard)/dashboard/$dashboardId/conversas/$channelInstanceUuid'
      path: '/conversas/$channelInstanceUuid'
      fullPath: '/dashboard/$dashboardId/conversas/$channelInstanceUuid'
      preLoaderRoute: typeof dashboardDashboardDashboardIdConversasChannelInstanceUuidRouteRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdRoute
    }
    '/(dashboard)/dashboard/$dashboardId/contatos/$id': {
      id: '/(dashboard)/dashboard/$dashboardId/contatos/$id'
      path: '/$id'
      fullPath: '/dashboard/$dashboardId/contatos/$id'
      preLoaderRoute: typeof dashboardDashboardDashboardIdContatosIdRouteRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdContatosRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/colecoes/$colecaoId': {
      id: '/(dashboard)/dashboard/$dashboardId/colecoes/$colecaoId'
      path: '/$colecaoId'
      fullPath: '/dashboard/$dashboardId/colecoes/$colecaoId'
      preLoaderRoute: typeof dashboardDashboardDashboardIdColecoesColecaoIdRouteRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdColecoesRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/automacoes/$automacaoId': {
      id: '/(dashboard)/dashboard/$dashboardId/automacoes/$automacaoId'
      path: '/$automacaoId'
      fullPath: '/dashboard/$dashboardId/automacoes/$automacaoId'
      preLoaderRoute: typeof dashboardDashboardDashboardIdAutomacoesAutomacaoIdRouteRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdAutomacoesRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/sites/$siteId/': {
      id: '/(dashboard)/dashboard/$dashboardId/sites/$siteId/'
      path: '/'
      fullPath: '/dashboard/$dashboardId/sites/$siteId/'
      preLoaderRoute: typeof dashboardDashboardDashboardIdSitesSiteIdIndexRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdSitesSiteIdRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/sistema/whatsapp/': {
      id: '/(dashboard)/dashboard/$dashboardId/sistema/whatsapp/'
      path: '/'
      fullPath: '/dashboard/$dashboardId/sistema/whatsapp/'
      preLoaderRoute: typeof dashboardDashboardDashboardIdSistemaWhatsappIndexRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdSistemaWhatsappRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/sistema/integracoes/': {
      id: '/(dashboard)/dashboard/$dashboardId/sistema/integracoes/'
      path: '/'
      fullPath: '/dashboard/$dashboardId/sistema/integracoes/'
      preLoaderRoute: typeof dashboardDashboardDashboardIdSistemaIntegracoesIndexRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdSistemaIntegracoesRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/sistema/agentes/': {
      id: '/(dashboard)/dashboard/$dashboardId/sistema/agentes/'
      path: '/'
      fullPath: '/dashboard/$dashboardId/sistema/agentes/'
      preLoaderRoute: typeof dashboardDashboardDashboardIdSistemaAgentesIndexRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdSistemaAgentesRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/propostas/$propostaId/': {
      id: '/(dashboard)/dashboard/$dashboardId/propostas/$propostaId/'
      path: '/$propostaId'
      fullPath: '/dashboard/$dashboardId/propostas/$propostaId/'
      preLoaderRoute: typeof dashboardDashboardDashboardIdPropostasPropostaIdIndexRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdPropostasRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/portais/$portalvalue/': {
      id: '/(dashboard)/dashboard/$dashboardId/portais/$portalvalue/'
      path: '/'
      fullPath: '/dashboard/$dashboardId/portais/$portalvalue/'
      preLoaderRoute: typeof dashboardDashboardDashboardIdPortaisPortalvalueIndexRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdPortaisPortalvalueRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/marketing/modelos-whatsapp/': {
      id: '/(dashboard)/dashboard/$dashboardId/marketing/modelos-whatsapp/'
      path: '/'
      fullPath: '/dashboard/$dashboardId/marketing/modelos-whatsapp/'
      preLoaderRoute: typeof dashboardDashboardDashboardIdMarketingModelosWhatsappIndexRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdMarketingModelosWhatsappRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/marketing/modelos-emails/': {
      id: '/(dashboard)/dashboard/$dashboardId/marketing/modelos-emails/'
      path: '/'
      fullPath: '/dashboard/$dashboardId/marketing/modelos-emails/'
      preLoaderRoute: typeof dashboardDashboardDashboardIdMarketingModelosEmailsIndexRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdMarketingModelosEmailsRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/marketing/campanhas-segmentadas/': {
      id: '/(dashboard)/dashboard/$dashboardId/marketing/campanhas-segmentadas/'
      path: '/'
      fullPath: '/dashboard/$dashboardId/marketing/campanhas-segmentadas/'
      preLoaderRoute: typeof dashboardDashboardDashboardIdMarketingCampanhasSegmentadasIndexRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdMarketingCampanhasSegmentadasRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/leads/$leadId/': {
      id: '/(dashboard)/dashboard/$dashboardId/leads/$leadId/'
      path: '/$leadId'
      fullPath: '/dashboard/$dashboardId/leads/$leadId/'
      preLoaderRoute: typeof dashboardDashboardDashboardIdLeadsLeadIdIndexRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdLeadsRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/incorporadoras/$incorporadoraId/': {
      id: '/(dashboard)/dashboard/$dashboardId/incorporadoras/$incorporadoraId/'
      path: '/$incorporadoraId'
      fullPath: '/dashboard/$dashboardId/incorporadoras/$incorporadoraId/'
      preLoaderRoute: typeof dashboardDashboardDashboardIdIncorporadorasIncorporadoraIdIndexRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdIncorporadorasRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/imoveis/$imovelId/': {
      id: '/(dashboard)/dashboard/$dashboardId/imoveis/$imovelId/'
      path: '/'
      fullPath: '/dashboard/$dashboardId/imoveis/$imovelId/'
      preLoaderRoute: typeof dashboardDashboardDashboardIdImoveisImovelIdIndexRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdImoveisImovelIdRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/empreendimentos/$empreendimentoId/': {
      id: '/(dashboard)/dashboard/$dashboardId/empreendimentos/$empreendimentoId/'
      path: '/'
      fullPath: '/dashboard/$dashboardId/empreendimentos/$empreendimentoId/'
      preLoaderRoute: typeof dashboardDashboardDashboardIdEmpreendimentosEmpreendimentoIdIndexRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdEmpreendimentosEmpreendimentoIdRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/documentos-digitais/modelos/': {
      id: '/(dashboard)/dashboard/$dashboardId/documentos-digitais/modelos/'
      path: '/'
      fullPath: '/dashboard/$dashboardId/documentos-digitais/modelos/'
      preLoaderRoute: typeof dashboardDashboardDashboardIdDocumentosDigitaisModelosIndexRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdDocumentosDigitaisModelosRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/documentos-digitais/gerados/': {
      id: '/(dashboard)/dashboard/$dashboardId/documentos-digitais/gerados/'
      path: '/gerados'
      fullPath: '/dashboard/$dashboardId/documentos-digitais/gerados/'
      preLoaderRoute: typeof dashboardDashboardDashboardIdDocumentosDigitaisGeradosIndexRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdDocumentosDigitaisRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/documentos-digitais/assinaturas/': {
      id: '/(dashboard)/dashboard/$dashboardId/documentos-digitais/assinaturas/'
      path: '/assinaturas'
      fullPath: '/dashboard/$dashboardId/documentos-digitais/assinaturas/'
      preLoaderRoute: typeof dashboardDashboardDashboardIdDocumentosDigitaisAssinaturasIndexRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdDocumentosDigitaisRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/conversas/$channelInstanceUuid/': {
      id: '/(dashboard)/dashboard/$dashboardId/conversas/$channelInstanceUuid/'
      path: '/'
      fullPath: '/dashboard/$dashboardId/conversas/$channelInstanceUuid/'
      preLoaderRoute: typeof dashboardDashboardDashboardIdConversasChannelInstanceUuidIndexRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdConversasChannelInstanceUuidRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/contatos/$id/': {
      id: '/(dashboard)/dashboard/$dashboardId/contatos/$id/'
      path: '/'
      fullPath: '/dashboard/$dashboardId/contatos/$id/'
      preLoaderRoute: typeof dashboardDashboardDashboardIdContatosIdIndexRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdContatosIdRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/colecoes/$colecaoId/': {
      id: '/(dashboard)/dashboard/$dashboardId/colecoes/$colecaoId/'
      path: '/'
      fullPath: '/dashboard/$dashboardId/colecoes/$colecaoId/'
      preLoaderRoute: typeof dashboardDashboardDashboardIdColecoesColecaoIdIndexRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdColecoesColecaoIdRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/chaves/$registroChaveId/': {
      id: '/(dashboard)/dashboard/$dashboardId/chaves/$registroChaveId/'
      path: '/$registroChaveId'
      fullPath: '/dashboard/$dashboardId/chaves/$registroChaveId/'
      preLoaderRoute: typeof dashboardDashboardDashboardIdChavesRegistroChaveIdIndexRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdChavesRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/automacoes/nova/': {
      id: '/(dashboard)/dashboard/$dashboardId/automacoes/nova/'
      path: '/nova'
      fullPath: '/dashboard/$dashboardId/automacoes/nova/'
      preLoaderRoute: typeof dashboardDashboardDashboardIdAutomacoesNovaIndexRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdAutomacoesRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/automacoes/$automacaoId/': {
      id: '/(dashboard)/dashboard/$dashboardId/automacoes/$automacaoId/'
      path: '/'
      fullPath: '/dashboard/$dashboardId/automacoes/$automacaoId/'
      preLoaderRoute: typeof dashboardDashboardDashboardIdAutomacoesAutomacaoIdIndexRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdAutomacoesAutomacaoIdRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/atividades/$tarefaId/': {
      id: '/(dashboard)/dashboard/$dashboardId/atividades/$tarefaId/'
      path: '/$tarefaId'
      fullPath: '/dashboard/$dashboardId/atividades/$tarefaId/'
      preLoaderRoute: typeof dashboardDashboardDashboardIdAtividadesTarefaIdIndexRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdAtividadesRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/sistema/whatsapp/nova': {
      id: '/(dashboard)/dashboard/$dashboardId/sistema/whatsapp/nova'
      path: '/nova'
      fullPath: '/dashboard/$dashboardId/sistema/whatsapp/nova'
      preLoaderRoute: typeof dashboardDashboardDashboardIdSistemaWhatsappNovaRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdSistemaWhatsappRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/sistema/integracoes/email': {
      id: '/(dashboard)/dashboard/$dashboardId/sistema/integracoes/email'
      path: '/email'
      fullPath: '/dashboard/$dashboardId/sistema/integracoes/email'
      preLoaderRoute: typeof dashboardDashboardDashboardIdSistemaIntegracoesEmailRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdSistemaIntegracoesRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/sistema/integracoes/dwv': {
      id: '/(dashboard)/dashboard/$dashboardId/sistema/integracoes/dwv'
      path: '/dwv'
      fullPath: '/dashboard/$dashboardId/sistema/integracoes/dwv'
      preLoaderRoute: typeof dashboardDashboardDashboardIdSistemaIntegracoesDwvRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdSistemaIntegracoesRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/sistema/integracoes/autentique': {
      id: '/(dashboard)/dashboard/$dashboardId/sistema/integracoes/autentique'
      path: '/autentique'
      fullPath: '/dashboard/$dashboardId/sistema/integracoes/autentique'
      preLoaderRoute: typeof dashboardDashboardDashboardIdSistemaIntegracoesAutentiqueRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdSistemaIntegracoesRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/sistema/agentes/novo': {
      id: '/(dashboard)/dashboard/$dashboardId/sistema/agentes/novo'
      path: '/novo'
      fullPath: '/dashboard/$dashboardId/sistema/agentes/novo'
      preLoaderRoute: typeof dashboardDashboardDashboardIdSistemaAgentesNovoRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdSistemaAgentesRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/sistema/agentes/$agenteId': {
      id: '/(dashboard)/dashboard/$dashboardId/sistema/agentes/$agenteId'
      path: '/$agenteId'
      fullPath: '/dashboard/$dashboardId/sistema/agentes/$agenteId'
      preLoaderRoute: typeof dashboardDashboardDashboardIdSistemaAgentesAgenteIdRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdSistemaAgentesRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/marketing/modelos-whatsapp/novo': {
      id: '/(dashboard)/dashboard/$dashboardId/marketing/modelos-whatsapp/novo'
      path: '/novo'
      fullPath: '/dashboard/$dashboardId/marketing/modelos-whatsapp/novo'
      preLoaderRoute: typeof dashboardDashboardDashboardIdMarketingModelosWhatsappNovoRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdMarketingModelosWhatsappRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/marketing/modelos-whatsapp/$templateId': {
      id: '/(dashboard)/dashboard/$dashboardId/marketing/modelos-whatsapp/$templateId'
      path: '/$templateId'
      fullPath: '/dashboard/$dashboardId/marketing/modelos-whatsapp/$templateId'
      preLoaderRoute: typeof dashboardDashboardDashboardIdMarketingModelosWhatsappTemplateIdRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdMarketingModelosWhatsappRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/marketing/modelos-emails/novo': {
      id: '/(dashboard)/dashboard/$dashboardId/marketing/modelos-emails/novo'
      path: '/novo'
      fullPath: '/dashboard/$dashboardId/marketing/modelos-emails/novo'
      preLoaderRoute: typeof dashboardDashboardDashboardIdMarketingModelosEmailsNovoRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdMarketingModelosEmailsRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/marketing/modelos-emails/$templateId': {
      id: '/(dashboard)/dashboard/$dashboardId/marketing/modelos-emails/$templateId'
      path: '/$templateId'
      fullPath: '/dashboard/$dashboardId/marketing/modelos-emails/$templateId'
      preLoaderRoute: typeof dashboardDashboardDashboardIdMarketingModelosEmailsTemplateIdRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdMarketingModelosEmailsRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/marketing/campanhas-segmentadas/novo': {
      id: '/(dashboard)/dashboard/$dashboardId/marketing/campanhas-segmentadas/novo'
      path: '/novo'
      fullPath: '/dashboard/$dashboardId/marketing/campanhas-segmentadas/novo'
      preLoaderRoute: typeof dashboardDashboardDashboardIdMarketingCampanhasSegmentadasNovoRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdMarketingCampanhasSegmentadasRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/marketing/campanhas-segmentadas/$campanhaId': {
      id: '/(dashboard)/dashboard/$dashboardId/marketing/campanhas-segmentadas/$campanhaId'
      path: '/$campanhaId'
      fullPath: '/dashboard/$dashboardId/marketing/campanhas-segmentadas/$campanhaId'
      preLoaderRoute: typeof dashboardDashboardDashboardIdMarketingCampanhasSegmentadasCampanhaIdRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdMarketingCampanhasSegmentadasRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/incorporadoras/$incorporadoraId/editar': {
      id: '/(dashboard)/dashboard/$dashboardId/incorporadoras/$incorporadoraId/editar'
      path: '/$incorporadoraId/editar'
      fullPath: '/dashboard/$dashboardId/incorporadoras/$incorporadoraId/editar'
      preLoaderRoute: typeof dashboardDashboardDashboardIdIncorporadorasIncorporadoraIdEditarRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdIncorporadorasRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/imoveis/$imovelId/editar': {
      id: '/(dashboard)/dashboard/$dashboardId/imoveis/$imovelId/editar'
      path: '/editar'
      fullPath: '/dashboard/$dashboardId/imoveis/$imovelId/editar'
      preLoaderRoute: typeof dashboardDashboardDashboardIdImoveisImovelIdEditarRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdImoveisImovelIdRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/empreendimentos/$empreendimentoId/editar': {
      id: '/(dashboard)/dashboard/$dashboardId/empreendimentos/$empreendimentoId/editar'
      path: '/editar'
      fullPath: '/dashboard/$dashboardId/empreendimentos/$empreendimentoId/editar'
      preLoaderRoute: typeof dashboardDashboardDashboardIdEmpreendimentosEmpreendimentoIdEditarRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdEmpreendimentosEmpreendimentoIdRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/documentos-digitais/modelos/novo': {
      id: '/(dashboard)/dashboard/$dashboardId/documentos-digitais/modelos/novo'
      path: '/novo'
      fullPath: '/dashboard/$dashboardId/documentos-digitais/modelos/novo'
      preLoaderRoute: typeof dashboardDashboardDashboardIdDocumentosDigitaisModelosNovoRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdDocumentosDigitaisModelosRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/documentos-digitais/modelos/$modeloId': {
      id: '/(dashboard)/dashboard/$dashboardId/documentos-digitais/modelos/$modeloId'
      path: '/$modeloId'
      fullPath: '/dashboard/$dashboardId/documentos-digitais/modelos/$modeloId'
      preLoaderRoute: typeof dashboardDashboardDashboardIdDocumentosDigitaisModelosModeloIdRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdDocumentosDigitaisModelosRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/documentos-digitais/gerados/novo': {
      id: '/(dashboard)/dashboard/$dashboardId/documentos-digitais/gerados/novo'
      path: '/gerados/novo'
      fullPath: '/dashboard/$dashboardId/documentos-digitais/gerados/novo'
      preLoaderRoute: typeof dashboardDashboardDashboardIdDocumentosDigitaisGeradosNovoRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdDocumentosDigitaisRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/contatos/$id/editar': {
      id: '/(dashboard)/dashboard/$dashboardId/contatos/$id/editar'
      path: '/editar'
      fullPath: '/dashboard/$dashboardId/contatos/$id/editar'
      preLoaderRoute: typeof dashboardDashboardDashboardIdContatosIdEditarRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdContatosIdRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/automacoes/nova/editar': {
      id: '/(dashboard)/dashboard/$dashboardId/automacoes/nova/editar'
      path: '/nova/editar'
      fullPath: '/dashboard/$dashboardId/automacoes/nova/editar'
      preLoaderRoute: typeof dashboardDashboardDashboardIdAutomacoesNovaEditarRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdAutomacoesRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/automacoes/$automacaoId/execucoes': {
      id: '/(dashboard)/dashboard/$dashboardId/automacoes/$automacaoId/execucoes'
      path: '/execucoes'
      fullPath: '/dashboard/$dashboardId/automacoes/$automacaoId/execucoes'
      preLoaderRoute: typeof dashboardDashboardDashboardIdAutomacoesAutomacaoIdExecucoesRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdAutomacoesAutomacaoIdRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/sites/$siteId/blog': {
      id: '/(dashboard)/dashboard/$dashboardId/sites/$siteId/blog'
      path: '/blog'
      fullPath: '/dashboard/$dashboardId/sites/$siteId/blog'
      preLoaderRoute: typeof dashboardDashboardDashboardIdSitesSiteIdBlogRouteRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdSitesSiteIdRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/documentos-digitais/gerados/$documentoId': {
      id: '/(dashboard)/dashboard/$dashboardId/documentos-digitais/gerados/$documentoId'
      path: '/gerados/$documentoId'
      fullPath: '/dashboard/$dashboardId/documentos-digitais/gerados/$documentoId'
      preLoaderRoute: typeof dashboardDashboardDashboardIdDocumentosDigitaisGeradosDocumentoIdRouteRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdDocumentosDigitaisRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/sites/$siteId/blog/': {
      id: '/(dashboard)/dashboard/$dashboardId/sites/$siteId/blog/'
      path: '/'
      fullPath: '/dashboard/$dashboardId/sites/$siteId/blog/'
      preLoaderRoute: typeof dashboardDashboardDashboardIdSitesSiteIdBlogIndexRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdSitesSiteIdBlogRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/oportunidades/$funilValue/$oportunidadeId/': {
      id: '/(dashboard)/dashboard/$dashboardId/oportunidades/$funilValue/$oportunidadeId/'
      path: '/$oportunidadeId'
      fullPath: '/dashboard/$dashboardId/oportunidades/$funilValue/$oportunidadeId/'
      preLoaderRoute: typeof dashboardDashboardDashboardIdOportunidadesFunilValueOportunidadeIdIndexRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdOportunidadesFunilValueRoute
    }
    '/(dashboard)/dashboard/$dashboardId/documentos-digitais/gerados/$documentoId/': {
      id: '/(dashboard)/dashboard/$dashboardId/documentos-digitais/gerados/$documentoId/'
      path: '/'
      fullPath: '/dashboard/$dashboardId/documentos-digitais/gerados/$documentoId/'
      preLoaderRoute: typeof dashboardDashboardDashboardIdDocumentosDigitaisGeradosDocumentoIdIndexRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdDocumentosDigitaisGeradosDocumentoIdRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/conversas/$channelInstanceUuid/$conversationId/': {
      id: '/(dashboard)/dashboard/$dashboardId/conversas/$channelInstanceUuid/$conversationId/'
      path: '/$conversationId'
      fullPath: '/dashboard/$dashboardId/conversas/$channelInstanceUuid/$conversationId/'
      preLoaderRoute: typeof dashboardDashboardDashboardIdConversasChannelInstanceUuidConversationIdIndexRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdConversasChannelInstanceUuidRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/sites/$siteId/blog/novo': {
      id: '/(dashboard)/dashboard/$dashboardId/sites/$siteId/blog/novo'
      path: '/novo'
      fullPath: '/dashboard/$dashboardId/sites/$siteId/blog/novo'
      preLoaderRoute: typeof dashboardDashboardDashboardIdSitesSiteIdBlogNovoRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdSitesSiteIdBlogRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/marketing/campanhas-segmentadas/detalhe/$campanhaId': {
      id: '/(dashboard)/dashboard/$dashboardId/marketing/campanhas-segmentadas/detalhe/$campanhaId'
      path: '/detalhe/$campanhaId'
      fullPath: '/dashboard/$dashboardId/marketing/campanhas-segmentadas/detalhe/$campanhaId'
      preLoaderRoute: typeof dashboardDashboardDashboardIdMarketingCampanhasSegmentadasDetalheCampanhaIdRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdMarketingCampanhasSegmentadasRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/documentos-digitais/gerados/$documentoId/editar': {
      id: '/(dashboard)/dashboard/$dashboardId/documentos-digitais/gerados/$documentoId/editar'
      path: '/editar'
      fullPath: '/dashboard/$dashboardId/documentos-digitais/gerados/$documentoId/editar'
      preLoaderRoute: typeof dashboardDashboardDashboardIdDocumentosDigitaisGeradosDocumentoIdEditarRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdDocumentosDigitaisGeradosDocumentoIdRouteRoute
    }
    '/(dashboard)/dashboard/$dashboardId/sites/$siteId/blog/$artigoId/': {
      id: '/(dashboard)/dashboard/$dashboardId/sites/$siteId/blog/$artigoId/'
      path: '/$artigoId'
      fullPath: '/dashboard/$dashboardId/sites/$siteId/blog/$artigoId/'
      preLoaderRoute: typeof dashboardDashboardDashboardIdSitesSiteIdBlogArtigoIdIndexRouteImport
      parentRoute: typeof dashboardDashboardDashboardIdSitesSiteIdBlogRouteRoute
    }
  }
}

interface dashboardDashboardDashboardIdAtividadesRouteRouteChildren {
  dashboardDashboardDashboardIdAtividadesTarefaIdIndexRoute: typeof dashboardDashboardDashboardIdAtividadesTarefaIdIndexRoute
}

const dashboardDashboardDashboardIdAtividadesRouteRouteChildren: dashboardDashboardDashboardIdAtividadesRouteRouteChildren =
  {
    dashboardDashboardDashboardIdAtividadesTarefaIdIndexRoute:
      dashboardDashboardDashboardIdAtividadesTarefaIdIndexRoute,
  }

const dashboardDashboardDashboardIdAtividadesRouteRouteWithChildren =
  dashboardDashboardDashboardIdAtividadesRouteRoute._addFileChildren(
    dashboardDashboardDashboardIdAtividadesRouteRouteChildren,
  )

interface dashboardDashboardDashboardIdAutomacoesAutomacaoIdRouteRouteChildren {
  dashboardDashboardDashboardIdAutomacoesAutomacaoIdExecucoesRoute: typeof dashboardDashboardDashboardIdAutomacoesAutomacaoIdExecucoesRoute
  dashboardDashboardDashboardIdAutomacoesAutomacaoIdIndexRoute: typeof dashboardDashboardDashboardIdAutomacoesAutomacaoIdIndexRoute
}

const dashboardDashboardDashboardIdAutomacoesAutomacaoIdRouteRouteChildren: dashboardDashboardDashboardIdAutomacoesAutomacaoIdRouteRouteChildren =
  {
    dashboardDashboardDashboardIdAutomacoesAutomacaoIdExecucoesRoute:
      dashboardDashboardDashboardIdAutomacoesAutomacaoIdExecucoesRoute,
    dashboardDashboardDashboardIdAutomacoesAutomacaoIdIndexRoute:
      dashboardDashboardDashboardIdAutomacoesAutomacaoIdIndexRoute,
  }

const dashboardDashboardDashboardIdAutomacoesAutomacaoIdRouteRouteWithChildren =
  dashboardDashboardDashboardIdAutomacoesAutomacaoIdRouteRoute._addFileChildren(
    dashboardDashboardDashboardIdAutomacoesAutomacaoIdRouteRouteChildren,
  )

interface dashboardDashboardDashboardIdAutomacoesRouteRouteChildren {
  dashboardDashboardDashboardIdAutomacoesAutomacaoIdRouteRoute: typeof dashboardDashboardDashboardIdAutomacoesAutomacaoIdRouteRouteWithChildren
  dashboardDashboardDashboardIdAutomacoesIndexRoute: typeof dashboardDashboardDashboardIdAutomacoesIndexRoute
  dashboardDashboardDashboardIdAutomacoesNovaEditarRoute: typeof dashboardDashboardDashboardIdAutomacoesNovaEditarRoute
  dashboardDashboardDashboardIdAutomacoesNovaIndexRoute: typeof dashboardDashboardDashboardIdAutomacoesNovaIndexRoute
}

const dashboardDashboardDashboardIdAutomacoesRouteRouteChildren: dashboardDashboardDashboardIdAutomacoesRouteRouteChildren =
  {
    dashboardDashboardDashboardIdAutomacoesAutomacaoIdRouteRoute:
      dashboardDashboardDashboardIdAutomacoesAutomacaoIdRouteRouteWithChildren,
    dashboardDashboardDashboardIdAutomacoesIndexRoute:
      dashboardDashboardDashboardIdAutomacoesIndexRoute,
    dashboardDashboardDashboardIdAutomacoesNovaEditarRoute:
      dashboardDashboardDashboardIdAutomacoesNovaEditarRoute,
    dashboardDashboardDashboardIdAutomacoesNovaIndexRoute:
      dashboardDashboardDashboardIdAutomacoesNovaIndexRoute,
  }

const dashboardDashboardDashboardIdAutomacoesRouteRouteWithChildren =
  dashboardDashboardDashboardIdAutomacoesRouteRoute._addFileChildren(
    dashboardDashboardDashboardIdAutomacoesRouteRouteChildren,
  )

interface dashboardDashboardDashboardIdCatalogoRouteRouteChildren {
  dashboardDashboardDashboardIdCatalogoMapaRoute: typeof dashboardDashboardDashboardIdCatalogoMapaRoute
  dashboardDashboardDashboardIdCatalogoIndexRoute: typeof dashboardDashboardDashboardIdCatalogoIndexRoute
}

const dashboardDashboardDashboardIdCatalogoRouteRouteChildren: dashboardDashboardDashboardIdCatalogoRouteRouteChildren =
  {
    dashboardDashboardDashboardIdCatalogoMapaRoute:
      dashboardDashboardDashboardIdCatalogoMapaRoute,
    dashboardDashboardDashboardIdCatalogoIndexRoute:
      dashboardDashboardDashboardIdCatalogoIndexRoute,
  }

const dashboardDashboardDashboardIdCatalogoRouteRouteWithChildren =
  dashboardDashboardDashboardIdCatalogoRouteRoute._addFileChildren(
    dashboardDashboardDashboardIdCatalogoRouteRouteChildren,
  )

interface dashboardDashboardDashboardIdChatRouteRouteChildren {
  dashboardDashboardDashboardIdChatChatIdRoute: typeof dashboardDashboardDashboardIdChatChatIdRoute
  dashboardDashboardDashboardIdChatIndexRoute: typeof dashboardDashboardDashboardIdChatIndexRoute
}

const dashboardDashboardDashboardIdChatRouteRouteChildren: dashboardDashboardDashboardIdChatRouteRouteChildren =
  {
    dashboardDashboardDashboardIdChatChatIdRoute:
      dashboardDashboardDashboardIdChatChatIdRoute,
    dashboardDashboardDashboardIdChatIndexRoute:
      dashboardDashboardDashboardIdChatIndexRoute,
  }

const dashboardDashboardDashboardIdChatRouteRouteWithChildren =
  dashboardDashboardDashboardIdChatRouteRoute._addFileChildren(
    dashboardDashboardDashboardIdChatRouteRouteChildren,
  )

interface dashboardDashboardDashboardIdChavesRouteRouteChildren {
  dashboardDashboardDashboardIdChavesRegistroChaveIdIndexRoute: typeof dashboardDashboardDashboardIdChavesRegistroChaveIdIndexRoute
}

const dashboardDashboardDashboardIdChavesRouteRouteChildren: dashboardDashboardDashboardIdChavesRouteRouteChildren =
  {
    dashboardDashboardDashboardIdChavesRegistroChaveIdIndexRoute:
      dashboardDashboardDashboardIdChavesRegistroChaveIdIndexRoute,
  }

const dashboardDashboardDashboardIdChavesRouteRouteWithChildren =
  dashboardDashboardDashboardIdChavesRouteRoute._addFileChildren(
    dashboardDashboardDashboardIdChavesRouteRouteChildren,
  )

interface dashboardDashboardDashboardIdColecoesColecaoIdRouteRouteChildren {
  dashboardDashboardDashboardIdColecoesColecaoIdIndexRoute: typeof dashboardDashboardDashboardIdColecoesColecaoIdIndexRoute
}

const dashboardDashboardDashboardIdColecoesColecaoIdRouteRouteChildren: dashboardDashboardDashboardIdColecoesColecaoIdRouteRouteChildren =
  {
    dashboardDashboardDashboardIdColecoesColecaoIdIndexRoute:
      dashboardDashboardDashboardIdColecoesColecaoIdIndexRoute,
  }

const dashboardDashboardDashboardIdColecoesColecaoIdRouteRouteWithChildren =
  dashboardDashboardDashboardIdColecoesColecaoIdRouteRoute._addFileChildren(
    dashboardDashboardDashboardIdColecoesColecaoIdRouteRouteChildren,
  )

interface dashboardDashboardDashboardIdColecoesRouteRouteChildren {
  dashboardDashboardDashboardIdColecoesColecaoIdRouteRoute: typeof dashboardDashboardDashboardIdColecoesColecaoIdRouteRouteWithChildren
  dashboardDashboardDashboardIdColecoesIndexRoute: typeof dashboardDashboardDashboardIdColecoesIndexRoute
}

const dashboardDashboardDashboardIdColecoesRouteRouteChildren: dashboardDashboardDashboardIdColecoesRouteRouteChildren =
  {
    dashboardDashboardDashboardIdColecoesColecaoIdRouteRoute:
      dashboardDashboardDashboardIdColecoesColecaoIdRouteRouteWithChildren,
    dashboardDashboardDashboardIdColecoesIndexRoute:
      dashboardDashboardDashboardIdColecoesIndexRoute,
  }

const dashboardDashboardDashboardIdColecoesRouteRouteWithChildren =
  dashboardDashboardDashboardIdColecoesRouteRoute._addFileChildren(
    dashboardDashboardDashboardIdColecoesRouteRouteChildren,
  )

interface dashboardDashboardDashboardIdContatosIdRouteRouteChildren {
  dashboardDashboardDashboardIdContatosIdEditarRoute: typeof dashboardDashboardDashboardIdContatosIdEditarRoute
  dashboardDashboardDashboardIdContatosIdIndexRoute: typeof dashboardDashboardDashboardIdContatosIdIndexRoute
}

const dashboardDashboardDashboardIdContatosIdRouteRouteChildren: dashboardDashboardDashboardIdContatosIdRouteRouteChildren =
  {
    dashboardDashboardDashboardIdContatosIdEditarRoute:
      dashboardDashboardDashboardIdContatosIdEditarRoute,
    dashboardDashboardDashboardIdContatosIdIndexRoute:
      dashboardDashboardDashboardIdContatosIdIndexRoute,
  }

const dashboardDashboardDashboardIdContatosIdRouteRouteWithChildren =
  dashboardDashboardDashboardIdContatosIdRouteRoute._addFileChildren(
    dashboardDashboardDashboardIdContatosIdRouteRouteChildren,
  )

interface dashboardDashboardDashboardIdContatosRouteRouteChildren {
  dashboardDashboardDashboardIdContatosIdRouteRoute: typeof dashboardDashboardDashboardIdContatosIdRouteRouteWithChildren
  dashboardDashboardDashboardIdContatosImportarRoute: typeof dashboardDashboardDashboardIdContatosImportarRoute
  dashboardDashboardDashboardIdContatosNovoRoute: typeof dashboardDashboardDashboardIdContatosNovoRoute
}

const dashboardDashboardDashboardIdContatosRouteRouteChildren: dashboardDashboardDashboardIdContatosRouteRouteChildren =
  {
    dashboardDashboardDashboardIdContatosIdRouteRoute:
      dashboardDashboardDashboardIdContatosIdRouteRouteWithChildren,
    dashboardDashboardDashboardIdContatosImportarRoute:
      dashboardDashboardDashboardIdContatosImportarRoute,
    dashboardDashboardDashboardIdContatosNovoRoute:
      dashboardDashboardDashboardIdContatosNovoRoute,
  }

const dashboardDashboardDashboardIdContatosRouteRouteWithChildren =
  dashboardDashboardDashboardIdContatosRouteRoute._addFileChildren(
    dashboardDashboardDashboardIdContatosRouteRouteChildren,
  )

interface dashboardDashboardDashboardIdDocumentosDigitaisModelosRouteRouteChildren {
  dashboardDashboardDashboardIdDocumentosDigitaisModelosModeloIdRoute: typeof dashboardDashboardDashboardIdDocumentosDigitaisModelosModeloIdRoute
  dashboardDashboardDashboardIdDocumentosDigitaisModelosNovoRoute: typeof dashboardDashboardDashboardIdDocumentosDigitaisModelosNovoRoute
  dashboardDashboardDashboardIdDocumentosDigitaisModelosIndexRoute: typeof dashboardDashboardDashboardIdDocumentosDigitaisModelosIndexRoute
}

const dashboardDashboardDashboardIdDocumentosDigitaisModelosRouteRouteChildren: dashboardDashboardDashboardIdDocumentosDigitaisModelosRouteRouteChildren =
  {
    dashboardDashboardDashboardIdDocumentosDigitaisModelosModeloIdRoute:
      dashboardDashboardDashboardIdDocumentosDigitaisModelosModeloIdRoute,
    dashboardDashboardDashboardIdDocumentosDigitaisModelosNovoRoute:
      dashboardDashboardDashboardIdDocumentosDigitaisModelosNovoRoute,
    dashboardDashboardDashboardIdDocumentosDigitaisModelosIndexRoute:
      dashboardDashboardDashboardIdDocumentosDigitaisModelosIndexRoute,
  }

const dashboardDashboardDashboardIdDocumentosDigitaisModelosRouteRouteWithChildren =
  dashboardDashboardDashboardIdDocumentosDigitaisModelosRouteRoute._addFileChildren(
    dashboardDashboardDashboardIdDocumentosDigitaisModelosRouteRouteChildren,
  )

interface dashboardDashboardDashboardIdDocumentosDigitaisGeradosDocumentoIdRouteRouteChildren {
  dashboardDashboardDashboardIdDocumentosDigitaisGeradosDocumentoIdEditarRoute: typeof dashboardDashboardDashboardIdDocumentosDigitaisGeradosDocumentoIdEditarRoute
  dashboardDashboardDashboardIdDocumentosDigitaisGeradosDocumentoIdIndexRoute: typeof dashboardDashboardDashboardIdDocumentosDigitaisGeradosDocumentoIdIndexRoute
}

const dashboardDashboardDashboardIdDocumentosDigitaisGeradosDocumentoIdRouteRouteChildren: dashboardDashboardDashboardIdDocumentosDigitaisGeradosDocumentoIdRouteRouteChildren =
  {
    dashboardDashboardDashboardIdDocumentosDigitaisGeradosDocumentoIdEditarRoute:
      dashboardDashboardDashboardIdDocumentosDigitaisGeradosDocumentoIdEditarRoute,
    dashboardDashboardDashboardIdDocumentosDigitaisGeradosDocumentoIdIndexRoute:
      dashboardDashboardDashboardIdDocumentosDigitaisGeradosDocumentoIdIndexRoute,
  }

const dashboardDashboardDashboardIdDocumentosDigitaisGeradosDocumentoIdRouteRouteWithChildren =
  dashboardDashboardDashboardIdDocumentosDigitaisGeradosDocumentoIdRouteRoute._addFileChildren(
    dashboardDashboardDashboardIdDocumentosDigitaisGeradosDocumentoIdRouteRouteChildren,
  )

interface dashboardDashboardDashboardIdDocumentosDigitaisRouteRouteChildren {
  dashboardDashboardDashboardIdDocumentosDigitaisModelosRouteRoute: typeof dashboardDashboardDashboardIdDocumentosDigitaisModelosRouteRouteWithChildren
  dashboardDashboardDashboardIdDocumentosDigitaisIndexRoute: typeof dashboardDashboardDashboardIdDocumentosDigitaisIndexRoute
  dashboardDashboardDashboardIdDocumentosDigitaisGeradosDocumentoIdRouteRoute: typeof dashboardDashboardDashboardIdDocumentosDigitaisGeradosDocumentoIdRouteRouteWithChildren
  dashboardDashboardDashboardIdDocumentosDigitaisGeradosNovoRoute: typeof dashboardDashboardDashboardIdDocumentosDigitaisGeradosNovoRoute
  dashboardDashboardDashboardIdDocumentosDigitaisAssinaturasIndexRoute: typeof dashboardDashboardDashboardIdDocumentosDigitaisAssinaturasIndexRoute
  dashboardDashboardDashboardIdDocumentosDigitaisGeradosIndexRoute: typeof dashboardDashboardDashboardIdDocumentosDigitaisGeradosIndexRoute
}

const dashboardDashboardDashboardIdDocumentosDigitaisRouteRouteChildren: dashboardDashboardDashboardIdDocumentosDigitaisRouteRouteChildren =
  {
    dashboardDashboardDashboardIdDocumentosDigitaisModelosRouteRoute:
      dashboardDashboardDashboardIdDocumentosDigitaisModelosRouteRouteWithChildren,
    dashboardDashboardDashboardIdDocumentosDigitaisIndexRoute:
      dashboardDashboardDashboardIdDocumentosDigitaisIndexRoute,
    dashboardDashboardDashboardIdDocumentosDigitaisGeradosDocumentoIdRouteRoute:
      dashboardDashboardDashboardIdDocumentosDigitaisGeradosDocumentoIdRouteRouteWithChildren,
    dashboardDashboardDashboardIdDocumentosDigitaisGeradosNovoRoute:
      dashboardDashboardDashboardIdDocumentosDigitaisGeradosNovoRoute,
    dashboardDashboardDashboardIdDocumentosDigitaisAssinaturasIndexRoute:
      dashboardDashboardDashboardIdDocumentosDigitaisAssinaturasIndexRoute,
    dashboardDashboardDashboardIdDocumentosDigitaisGeradosIndexRoute:
      dashboardDashboardDashboardIdDocumentosDigitaisGeradosIndexRoute,
  }

const dashboardDashboardDashboardIdDocumentosDigitaisRouteRouteWithChildren =
  dashboardDashboardDashboardIdDocumentosDigitaisRouteRoute._addFileChildren(
    dashboardDashboardDashboardIdDocumentosDigitaisRouteRouteChildren,
  )

interface dashboardDashboardDashboardIdEmpreendimentosEmpreendimentoIdRouteRouteChildren {
  dashboardDashboardDashboardIdEmpreendimentosEmpreendimentoIdEditarRoute: typeof dashboardDashboardDashboardIdEmpreendimentosEmpreendimentoIdEditarRoute
  dashboardDashboardDashboardIdEmpreendimentosEmpreendimentoIdIndexRoute: typeof dashboardDashboardDashboardIdEmpreendimentosEmpreendimentoIdIndexRoute
}

const dashboardDashboardDashboardIdEmpreendimentosEmpreendimentoIdRouteRouteChildren: dashboardDashboardDashboardIdEmpreendimentosEmpreendimentoIdRouteRouteChildren =
  {
    dashboardDashboardDashboardIdEmpreendimentosEmpreendimentoIdEditarRoute:
      dashboardDashboardDashboardIdEmpreendimentosEmpreendimentoIdEditarRoute,
    dashboardDashboardDashboardIdEmpreendimentosEmpreendimentoIdIndexRoute:
      dashboardDashboardDashboardIdEmpreendimentosEmpreendimentoIdIndexRoute,
  }

const dashboardDashboardDashboardIdEmpreendimentosEmpreendimentoIdRouteRouteWithChildren =
  dashboardDashboardDashboardIdEmpreendimentosEmpreendimentoIdRouteRoute._addFileChildren(
    dashboardDashboardDashboardIdEmpreendimentosEmpreendimentoIdRouteRouteChildren,
  )

interface dashboardDashboardDashboardIdEmpreendimentosRouteRouteChildren {
  dashboardDashboardDashboardIdEmpreendimentosEmpreendimentoIdRouteRoute: typeof dashboardDashboardDashboardIdEmpreendimentosEmpreendimentoIdRouteRouteWithChildren
  dashboardDashboardDashboardIdEmpreendimentosIndexRoute: typeof dashboardDashboardDashboardIdEmpreendimentosIndexRoute
}

const dashboardDashboardDashboardIdEmpreendimentosRouteRouteChildren: dashboardDashboardDashboardIdEmpreendimentosRouteRouteChildren =
  {
    dashboardDashboardDashboardIdEmpreendimentosEmpreendimentoIdRouteRoute:
      dashboardDashboardDashboardIdEmpreendimentosEmpreendimentoIdRouteRouteWithChildren,
    dashboardDashboardDashboardIdEmpreendimentosIndexRoute:
      dashboardDashboardDashboardIdEmpreendimentosIndexRoute,
  }

const dashboardDashboardDashboardIdEmpreendimentosRouteRouteWithChildren =
  dashboardDashboardDashboardIdEmpreendimentosRouteRoute._addFileChildren(
    dashboardDashboardDashboardIdEmpreendimentosRouteRouteChildren,
  )

interface dashboardDashboardDashboardIdFinanceiroRouteRouteChildren {
  dashboardDashboardDashboardIdFinanceiroLancamentosRoute: typeof dashboardDashboardDashboardIdFinanceiroLancamentosRoute
  dashboardDashboardDashboardIdFinanceiroIndexRoute: typeof dashboardDashboardDashboardIdFinanceiroIndexRoute
}

const dashboardDashboardDashboardIdFinanceiroRouteRouteChildren: dashboardDashboardDashboardIdFinanceiroRouteRouteChildren =
  {
    dashboardDashboardDashboardIdFinanceiroLancamentosRoute:
      dashboardDashboardDashboardIdFinanceiroLancamentosRoute,
    dashboardDashboardDashboardIdFinanceiroIndexRoute:
      dashboardDashboardDashboardIdFinanceiroIndexRoute,
  }

const dashboardDashboardDashboardIdFinanceiroRouteRouteWithChildren =
  dashboardDashboardDashboardIdFinanceiroRouteRoute._addFileChildren(
    dashboardDashboardDashboardIdFinanceiroRouteRouteChildren,
  )

interface dashboardDashboardDashboardIdImoveisImovelIdRouteRouteChildren {
  dashboardDashboardDashboardIdImoveisImovelIdEditarRoute: typeof dashboardDashboardDashboardIdImoveisImovelIdEditarRoute
  dashboardDashboardDashboardIdImoveisImovelIdIndexRoute: typeof dashboardDashboardDashboardIdImoveisImovelIdIndexRoute
}

const dashboardDashboardDashboardIdImoveisImovelIdRouteRouteChildren: dashboardDashboardDashboardIdImoveisImovelIdRouteRouteChildren =
  {
    dashboardDashboardDashboardIdImoveisImovelIdEditarRoute:
      dashboardDashboardDashboardIdImoveisImovelIdEditarRoute,
    dashboardDashboardDashboardIdImoveisImovelIdIndexRoute:
      dashboardDashboardDashboardIdImoveisImovelIdIndexRoute,
  }

const dashboardDashboardDashboardIdImoveisImovelIdRouteRouteWithChildren =
  dashboardDashboardDashboardIdImoveisImovelIdRouteRoute._addFileChildren(
    dashboardDashboardDashboardIdImoveisImovelIdRouteRouteChildren,
  )

interface dashboardDashboardDashboardIdImoveisRouteRouteChildren {
  dashboardDashboardDashboardIdImoveisImovelIdRouteRoute: typeof dashboardDashboardDashboardIdImoveisImovelIdRouteRouteWithChildren
  dashboardDashboardDashboardIdImoveisIndexRoute: typeof dashboardDashboardDashboardIdImoveisIndexRoute
}

const dashboardDashboardDashboardIdImoveisRouteRouteChildren: dashboardDashboardDashboardIdImoveisRouteRouteChildren =
  {
    dashboardDashboardDashboardIdImoveisImovelIdRouteRoute:
      dashboardDashboardDashboardIdImoveisImovelIdRouteRouteWithChildren,
    dashboardDashboardDashboardIdImoveisIndexRoute:
      dashboardDashboardDashboardIdImoveisIndexRoute,
  }

const dashboardDashboardDashboardIdImoveisRouteRouteWithChildren =
  dashboardDashboardDashboardIdImoveisRouteRoute._addFileChildren(
    dashboardDashboardDashboardIdImoveisRouteRouteChildren,
  )

interface dashboardDashboardDashboardIdIncorporadorasRouteRouteChildren {
  dashboardDashboardDashboardIdIncorporadorasIndexRoute: typeof dashboardDashboardDashboardIdIncorporadorasIndexRoute
  dashboardDashboardDashboardIdIncorporadorasIncorporadoraIdEditarRoute: typeof dashboardDashboardDashboardIdIncorporadorasIncorporadoraIdEditarRoute
  dashboardDashboardDashboardIdIncorporadorasIncorporadoraIdIndexRoute: typeof dashboardDashboardDashboardIdIncorporadorasIncorporadoraIdIndexRoute
}

const dashboardDashboardDashboardIdIncorporadorasRouteRouteChildren: dashboardDashboardDashboardIdIncorporadorasRouteRouteChildren =
  {
    dashboardDashboardDashboardIdIncorporadorasIndexRoute:
      dashboardDashboardDashboardIdIncorporadorasIndexRoute,
    dashboardDashboardDashboardIdIncorporadorasIncorporadoraIdEditarRoute:
      dashboardDashboardDashboardIdIncorporadorasIncorporadoraIdEditarRoute,
    dashboardDashboardDashboardIdIncorporadorasIncorporadoraIdIndexRoute:
      dashboardDashboardDashboardIdIncorporadorasIncorporadoraIdIndexRoute,
  }

const dashboardDashboardDashboardIdIncorporadorasRouteRouteWithChildren =
  dashboardDashboardDashboardIdIncorporadorasRouteRoute._addFileChildren(
    dashboardDashboardDashboardIdIncorporadorasRouteRouteChildren,
  )

interface dashboardDashboardDashboardIdLeadsRouteRouteChildren {
  dashboardDashboardDashboardIdLeadsImportarRoute: typeof dashboardDashboardDashboardIdLeadsImportarRoute
  dashboardDashboardDashboardIdLeadsNovoRoute: typeof dashboardDashboardDashboardIdLeadsNovoRoute
  dashboardDashboardDashboardIdLeadsLeadIdIndexRoute: typeof dashboardDashboardDashboardIdLeadsLeadIdIndexRoute
}

const dashboardDashboardDashboardIdLeadsRouteRouteChildren: dashboardDashboardDashboardIdLeadsRouteRouteChildren =
  {
    dashboardDashboardDashboardIdLeadsImportarRoute:
      dashboardDashboardDashboardIdLeadsImportarRoute,
    dashboardDashboardDashboardIdLeadsNovoRoute:
      dashboardDashboardDashboardIdLeadsNovoRoute,
    dashboardDashboardDashboardIdLeadsLeadIdIndexRoute:
      dashboardDashboardDashboardIdLeadsLeadIdIndexRoute,
  }

const dashboardDashboardDashboardIdLeadsRouteRouteWithChildren =
  dashboardDashboardDashboardIdLeadsRouteRoute._addFileChildren(
    dashboardDashboardDashboardIdLeadsRouteRouteChildren,
  )

interface dashboardDashboardDashboardIdMarketingCampanhasSegmentadasRouteRouteChildren {
  dashboardDashboardDashboardIdMarketingCampanhasSegmentadasCampanhaIdRoute: typeof dashboardDashboardDashboardIdMarketingCampanhasSegmentadasCampanhaIdRoute
  dashboardDashboardDashboardIdMarketingCampanhasSegmentadasNovoRoute: typeof dashboardDashboardDashboardIdMarketingCampanhasSegmentadasNovoRoute
  dashboardDashboardDashboardIdMarketingCampanhasSegmentadasIndexRoute: typeof dashboardDashboardDashboardIdMarketingCampanhasSegmentadasIndexRoute
  dashboardDashboardDashboardIdMarketingCampanhasSegmentadasDetalheCampanhaIdRoute: typeof dashboardDashboardDashboardIdMarketingCampanhasSegmentadasDetalheCampanhaIdRoute
}

const dashboardDashboardDashboardIdMarketingCampanhasSegmentadasRouteRouteChildren: dashboardDashboardDashboardIdMarketingCampanhasSegmentadasRouteRouteChildren =
  {
    dashboardDashboardDashboardIdMarketingCampanhasSegmentadasCampanhaIdRoute:
      dashboardDashboardDashboardIdMarketingCampanhasSegmentadasCampanhaIdRoute,
    dashboardDashboardDashboardIdMarketingCampanhasSegmentadasNovoRoute:
      dashboardDashboardDashboardIdMarketingCampanhasSegmentadasNovoRoute,
    dashboardDashboardDashboardIdMarketingCampanhasSegmentadasIndexRoute:
      dashboardDashboardDashboardIdMarketingCampanhasSegmentadasIndexRoute,
    dashboardDashboardDashboardIdMarketingCampanhasSegmentadasDetalheCampanhaIdRoute:
      dashboardDashboardDashboardIdMarketingCampanhasSegmentadasDetalheCampanhaIdRoute,
  }

const dashboardDashboardDashboardIdMarketingCampanhasSegmentadasRouteRouteWithChildren =
  dashboardDashboardDashboardIdMarketingCampanhasSegmentadasRouteRoute._addFileChildren(
    dashboardDashboardDashboardIdMarketingCampanhasSegmentadasRouteRouteChildren,
  )

interface dashboardDashboardDashboardIdMarketingModelosEmailsRouteRouteChildren {
  dashboardDashboardDashboardIdMarketingModelosEmailsTemplateIdRoute: typeof dashboardDashboardDashboardIdMarketingModelosEmailsTemplateIdRoute
  dashboardDashboardDashboardIdMarketingModelosEmailsNovoRoute: typeof dashboardDashboardDashboardIdMarketingModelosEmailsNovoRoute
  dashboardDashboardDashboardIdMarketingModelosEmailsIndexRoute: typeof dashboardDashboardDashboardIdMarketingModelosEmailsIndexRoute
}

const dashboardDashboardDashboardIdMarketingModelosEmailsRouteRouteChildren: dashboardDashboardDashboardIdMarketingModelosEmailsRouteRouteChildren =
  {
    dashboardDashboardDashboardIdMarketingModelosEmailsTemplateIdRoute:
      dashboardDashboardDashboardIdMarketingModelosEmailsTemplateIdRoute,
    dashboardDashboardDashboardIdMarketingModelosEmailsNovoRoute:
      dashboardDashboardDashboardIdMarketingModelosEmailsNovoRoute,
    dashboardDashboardDashboardIdMarketingModelosEmailsIndexRoute:
      dashboardDashboardDashboardIdMarketingModelosEmailsIndexRoute,
  }

const dashboardDashboardDashboardIdMarketingModelosEmailsRouteRouteWithChildren =
  dashboardDashboardDashboardIdMarketingModelosEmailsRouteRoute._addFileChildren(
    dashboardDashboardDashboardIdMarketingModelosEmailsRouteRouteChildren,
  )

interface dashboardDashboardDashboardIdMarketingModelosWhatsappRouteRouteChildren {
  dashboardDashboardDashboardIdMarketingModelosWhatsappTemplateIdRoute: typeof dashboardDashboardDashboardIdMarketingModelosWhatsappTemplateIdRoute
  dashboardDashboardDashboardIdMarketingModelosWhatsappNovoRoute: typeof dashboardDashboardDashboardIdMarketingModelosWhatsappNovoRoute
  dashboardDashboardDashboardIdMarketingModelosWhatsappIndexRoute: typeof dashboardDashboardDashboardIdMarketingModelosWhatsappIndexRoute
}

const dashboardDashboardDashboardIdMarketingModelosWhatsappRouteRouteChildren: dashboardDashboardDashboardIdMarketingModelosWhatsappRouteRouteChildren =
  {
    dashboardDashboardDashboardIdMarketingModelosWhatsappTemplateIdRoute:
      dashboardDashboardDashboardIdMarketingModelosWhatsappTemplateIdRoute,
    dashboardDashboardDashboardIdMarketingModelosWhatsappNovoRoute:
      dashboardDashboardDashboardIdMarketingModelosWhatsappNovoRoute,
    dashboardDashboardDashboardIdMarketingModelosWhatsappIndexRoute:
      dashboardDashboardDashboardIdMarketingModelosWhatsappIndexRoute,
  }

const dashboardDashboardDashboardIdMarketingModelosWhatsappRouteRouteWithChildren =
  dashboardDashboardDashboardIdMarketingModelosWhatsappRouteRoute._addFileChildren(
    dashboardDashboardDashboardIdMarketingModelosWhatsappRouteRouteChildren,
  )

interface dashboardDashboardDashboardIdMarketingRouteRouteChildren {
  dashboardDashboardDashboardIdMarketingCampanhasSegmentadasRouteRoute: typeof dashboardDashboardDashboardIdMarketingCampanhasSegmentadasRouteRouteWithChildren
  dashboardDashboardDashboardIdMarketingModelosEmailsRouteRoute: typeof dashboardDashboardDashboardIdMarketingModelosEmailsRouteRouteWithChildren
  dashboardDashboardDashboardIdMarketingModelosWhatsappRouteRoute: typeof dashboardDashboardDashboardIdMarketingModelosWhatsappRouteRouteWithChildren
  dashboardDashboardDashboardIdMarketingSegmentosRoute: typeof dashboardDashboardDashboardIdMarketingSegmentosRoute
  dashboardDashboardDashboardIdMarketingIndexRoute: typeof dashboardDashboardDashboardIdMarketingIndexRoute
}

const dashboardDashboardDashboardIdMarketingRouteRouteChildren: dashboardDashboardDashboardIdMarketingRouteRouteChildren =
  {
    dashboardDashboardDashboardIdMarketingCampanhasSegmentadasRouteRoute:
      dashboardDashboardDashboardIdMarketingCampanhasSegmentadasRouteRouteWithChildren,
    dashboardDashboardDashboardIdMarketingModelosEmailsRouteRoute:
      dashboardDashboardDashboardIdMarketingModelosEmailsRouteRouteWithChildren,
    dashboardDashboardDashboardIdMarketingModelosWhatsappRouteRoute:
      dashboardDashboardDashboardIdMarketingModelosWhatsappRouteRouteWithChildren,
    dashboardDashboardDashboardIdMarketingSegmentosRoute:
      dashboardDashboardDashboardIdMarketingSegmentosRoute,
    dashboardDashboardDashboardIdMarketingIndexRoute:
      dashboardDashboardDashboardIdMarketingIndexRoute,
  }

const dashboardDashboardDashboardIdMarketingRouteRouteWithChildren =
  dashboardDashboardDashboardIdMarketingRouteRoute._addFileChildren(
    dashboardDashboardDashboardIdMarketingRouteRouteChildren,
  )

interface dashboardDashboardDashboardIdOportunidadesFunilValueRouteChildren {
  dashboardDashboardDashboardIdOportunidadesFunilValueOportunidadeIdIndexRoute: typeof dashboardDashboardDashboardIdOportunidadesFunilValueOportunidadeIdIndexRoute
}

const dashboardDashboardDashboardIdOportunidadesFunilValueRouteChildren: dashboardDashboardDashboardIdOportunidadesFunilValueRouteChildren =
  {
    dashboardDashboardDashboardIdOportunidadesFunilValueOportunidadeIdIndexRoute:
      dashboardDashboardDashboardIdOportunidadesFunilValueOportunidadeIdIndexRoute,
  }

const dashboardDashboardDashboardIdOportunidadesFunilValueRouteWithChildren =
  dashboardDashboardDashboardIdOportunidadesFunilValueRoute._addFileChildren(
    dashboardDashboardDashboardIdOportunidadesFunilValueRouteChildren,
  )

interface dashboardDashboardDashboardIdOportunidadesRouteRouteChildren {
  dashboardDashboardDashboardIdOportunidadesFunilValueRoute: typeof dashboardDashboardDashboardIdOportunidadesFunilValueRouteWithChildren
  dashboardDashboardDashboardIdOportunidadesIndexRoute: typeof dashboardDashboardDashboardIdOportunidadesIndexRoute
}

const dashboardDashboardDashboardIdOportunidadesRouteRouteChildren: dashboardDashboardDashboardIdOportunidadesRouteRouteChildren =
  {
    dashboardDashboardDashboardIdOportunidadesFunilValueRoute:
      dashboardDashboardDashboardIdOportunidadesFunilValueRouteWithChildren,
    dashboardDashboardDashboardIdOportunidadesIndexRoute:
      dashboardDashboardDashboardIdOportunidadesIndexRoute,
  }

const dashboardDashboardDashboardIdOportunidadesRouteRouteWithChildren =
  dashboardDashboardDashboardIdOportunidadesRouteRoute._addFileChildren(
    dashboardDashboardDashboardIdOportunidadesRouteRouteChildren,
  )

interface dashboardDashboardDashboardIdPortaisPortalvalueRouteRouteChildren {
  dashboardDashboardDashboardIdPortaisPortalvalueIndexRoute: typeof dashboardDashboardDashboardIdPortaisPortalvalueIndexRoute
}

const dashboardDashboardDashboardIdPortaisPortalvalueRouteRouteChildren: dashboardDashboardDashboardIdPortaisPortalvalueRouteRouteChildren =
  {
    dashboardDashboardDashboardIdPortaisPortalvalueIndexRoute:
      dashboardDashboardDashboardIdPortaisPortalvalueIndexRoute,
  }

const dashboardDashboardDashboardIdPortaisPortalvalueRouteRouteWithChildren =
  dashboardDashboardDashboardIdPortaisPortalvalueRouteRoute._addFileChildren(
    dashboardDashboardDashboardIdPortaisPortalvalueRouteRouteChildren,
  )

interface dashboardDashboardDashboardIdPortaisRouteRouteChildren {
  dashboardDashboardDashboardIdPortaisPortalvalueRouteRoute: typeof dashboardDashboardDashboardIdPortaisPortalvalueRouteRouteWithChildren
  dashboardDashboardDashboardIdPortaisIndexRoute: typeof dashboardDashboardDashboardIdPortaisIndexRoute
}

const dashboardDashboardDashboardIdPortaisRouteRouteChildren: dashboardDashboardDashboardIdPortaisRouteRouteChildren =
  {
    dashboardDashboardDashboardIdPortaisPortalvalueRouteRoute:
      dashboardDashboardDashboardIdPortaisPortalvalueRouteRouteWithChildren,
    dashboardDashboardDashboardIdPortaisIndexRoute:
      dashboardDashboardDashboardIdPortaisIndexRoute,
  }

const dashboardDashboardDashboardIdPortaisRouteRouteWithChildren =
  dashboardDashboardDashboardIdPortaisRouteRoute._addFileChildren(
    dashboardDashboardDashboardIdPortaisRouteRouteChildren,
  )

interface dashboardDashboardDashboardIdPropostasRouteRouteChildren {
  dashboardDashboardDashboardIdPropostasPropostaIdIndexRoute: typeof dashboardDashboardDashboardIdPropostasPropostaIdIndexRoute
}

const dashboardDashboardDashboardIdPropostasRouteRouteChildren: dashboardDashboardDashboardIdPropostasRouteRouteChildren =
  {
    dashboardDashboardDashboardIdPropostasPropostaIdIndexRoute:
      dashboardDashboardDashboardIdPropostasPropostaIdIndexRoute,
  }

const dashboardDashboardDashboardIdPropostasRouteRouteWithChildren =
  dashboardDashboardDashboardIdPropostasRouteRoute._addFileChildren(
    dashboardDashboardDashboardIdPropostasRouteRouteChildren,
  )

interface dashboardDashboardDashboardIdSistemaAgentesRouteRouteChildren {
  dashboardDashboardDashboardIdSistemaAgentesAgenteIdRoute: typeof dashboardDashboardDashboardIdSistemaAgentesAgenteIdRoute
  dashboardDashboardDashboardIdSistemaAgentesNovoRoute: typeof dashboardDashboardDashboardIdSistemaAgentesNovoRoute
  dashboardDashboardDashboardIdSistemaAgentesIndexRoute: typeof dashboardDashboardDashboardIdSistemaAgentesIndexRoute
}

const dashboardDashboardDashboardIdSistemaAgentesRouteRouteChildren: dashboardDashboardDashboardIdSistemaAgentesRouteRouteChildren =
  {
    dashboardDashboardDashboardIdSistemaAgentesAgenteIdRoute:
      dashboardDashboardDashboardIdSistemaAgentesAgenteIdRoute,
    dashboardDashboardDashboardIdSistemaAgentesNovoRoute:
      dashboardDashboardDashboardIdSistemaAgentesNovoRoute,
    dashboardDashboardDashboardIdSistemaAgentesIndexRoute:
      dashboardDashboardDashboardIdSistemaAgentesIndexRoute,
  }

const dashboardDashboardDashboardIdSistemaAgentesRouteRouteWithChildren =
  dashboardDashboardDashboardIdSistemaAgentesRouteRoute._addFileChildren(
    dashboardDashboardDashboardIdSistemaAgentesRouteRouteChildren,
  )

interface dashboardDashboardDashboardIdSistemaIntegracoesRouteRouteChildren {
  dashboardDashboardDashboardIdSistemaIntegracoesAutentiqueRoute: typeof dashboardDashboardDashboardIdSistemaIntegracoesAutentiqueRoute
  dashboardDashboardDashboardIdSistemaIntegracoesDwvRoute: typeof dashboardDashboardDashboardIdSistemaIntegracoesDwvRoute
  dashboardDashboardDashboardIdSistemaIntegracoesEmailRoute: typeof dashboardDashboardDashboardIdSistemaIntegracoesEmailRoute
  dashboardDashboardDashboardIdSistemaIntegracoesIndexRoute: typeof dashboardDashboardDashboardIdSistemaIntegracoesIndexRoute
}

const dashboardDashboardDashboardIdSistemaIntegracoesRouteRouteChildren: dashboardDashboardDashboardIdSistemaIntegracoesRouteRouteChildren =
  {
    dashboardDashboardDashboardIdSistemaIntegracoesAutentiqueRoute:
      dashboardDashboardDashboardIdSistemaIntegracoesAutentiqueRoute,
    dashboardDashboardDashboardIdSistemaIntegracoesDwvRoute:
      dashboardDashboardDashboardIdSistemaIntegracoesDwvRoute,
    dashboardDashboardDashboardIdSistemaIntegracoesEmailRoute:
      dashboardDashboardDashboardIdSistemaIntegracoesEmailRoute,
    dashboardDashboardDashboardIdSistemaIntegracoesIndexRoute:
      dashboardDashboardDashboardIdSistemaIntegracoesIndexRoute,
  }

const dashboardDashboardDashboardIdSistemaIntegracoesRouteRouteWithChildren =
  dashboardDashboardDashboardIdSistemaIntegracoesRouteRoute._addFileChildren(
    dashboardDashboardDashboardIdSistemaIntegracoesRouteRouteChildren,
  )

interface dashboardDashboardDashboardIdSistemaWhatsappRouteRouteChildren {
  dashboardDashboardDashboardIdSistemaWhatsappNovaRoute: typeof dashboardDashboardDashboardIdSistemaWhatsappNovaRoute
  dashboardDashboardDashboardIdSistemaWhatsappIndexRoute: typeof dashboardDashboardDashboardIdSistemaWhatsappIndexRoute
}

const dashboardDashboardDashboardIdSistemaWhatsappRouteRouteChildren: dashboardDashboardDashboardIdSistemaWhatsappRouteRouteChildren =
  {
    dashboardDashboardDashboardIdSistemaWhatsappNovaRoute:
      dashboardDashboardDashboardIdSistemaWhatsappNovaRoute,
    dashboardDashboardDashboardIdSistemaWhatsappIndexRoute:
      dashboardDashboardDashboardIdSistemaWhatsappIndexRoute,
  }

const dashboardDashboardDashboardIdSistemaWhatsappRouteRouteWithChildren =
  dashboardDashboardDashboardIdSistemaWhatsappRouteRoute._addFileChildren(
    dashboardDashboardDashboardIdSistemaWhatsappRouteRouteChildren,
  )

interface dashboardDashboardDashboardIdSistemaRouteRouteChildren {
  dashboardDashboardDashboardIdSistemaAgentesRouteRoute: typeof dashboardDashboardDashboardIdSistemaAgentesRouteRouteWithChildren
  dashboardDashboardDashboardIdSistemaIntegracoesRouteRoute: typeof dashboardDashboardDashboardIdSistemaIntegracoesRouteRouteWithChildren
  dashboardDashboardDashboardIdSistemaWhatsappRouteRoute: typeof dashboardDashboardDashboardIdSistemaWhatsappRouteRouteWithChildren
  dashboardDashboardDashboardIdSistemaApiKeysRoute: typeof dashboardDashboardDashboardIdSistemaApiKeysRoute
  dashboardDashboardDashboardIdSistemaCamposCustomizadosRoute: typeof dashboardDashboardDashboardIdSistemaCamposCustomizadosRoute
  dashboardDashboardDashboardIdSistemaComodidadesRoute: typeof dashboardDashboardDashboardIdSistemaComodidadesRoute
  dashboardDashboardDashboardIdSistemaConversasRoute: typeof dashboardDashboardDashboardIdSistemaConversasRoute
  dashboardDashboardDashboardIdSistemaDadosRoute: typeof dashboardDashboardDashboardIdSistemaDadosRoute
  dashboardDashboardDashboardIdSistemaDistribuicaoInteligenteRoute: typeof dashboardDashboardDashboardIdSistemaDistribuicaoInteligenteRoute
  dashboardDashboardDashboardIdSistemaFinanceiroRoute: typeof dashboardDashboardDashboardIdSistemaFinanceiroRoute
  dashboardDashboardDashboardIdSistemaFunisRoute: typeof dashboardDashboardDashboardIdSistemaFunisRoute
  dashboardDashboardDashboardIdSistemaIsaRedatoraRoute: typeof dashboardDashboardDashboardIdSistemaIsaRedatoraRoute
  dashboardDashboardDashboardIdSistemaLogsRoute: typeof dashboardDashboardDashboardIdSistemaLogsRoute
  dashboardDashboardDashboardIdSistemaMetaLeadsRoute: typeof dashboardDashboardDashboardIdSistemaMetaLeadsRoute
  dashboardDashboardDashboardIdSistemaMotivosPerdasRoute: typeof dashboardDashboardDashboardIdSistemaMotivosPerdasRoute
  dashboardDashboardDashboardIdSistemaPlanoFaturasRoute: typeof dashboardDashboardDashboardIdSistemaPlanoFaturasRoute
  dashboardDashboardDashboardIdSistemaPortaisRoute: typeof dashboardDashboardDashboardIdSistemaPortaisRoute
  dashboardDashboardDashboardIdSistemaPreviewCtasRoute: typeof dashboardDashboardDashboardIdSistemaPreviewCtasRoute
  dashboardDashboardDashboardIdSistemaPulseCarteiraRoute: typeof dashboardDashboardDashboardIdSistemaPulseCarteiraRoute
  dashboardDashboardDashboardIdSistemaUsuariosRoute: typeof dashboardDashboardDashboardIdSistemaUsuariosRoute
  dashboardDashboardDashboardIdSistemaWatermarkRoute: typeof dashboardDashboardDashboardIdSistemaWatermarkRoute
  dashboardDashboardDashboardIdSistemaWebhooksRoute: typeof dashboardDashboardDashboardIdSistemaWebhooksRoute
  dashboardDashboardDashboardIdSistemaIndexRoute: typeof dashboardDashboardDashboardIdSistemaIndexRoute
}

const dashboardDashboardDashboardIdSistemaRouteRouteChildren: dashboardDashboardDashboardIdSistemaRouteRouteChildren =
  {
    dashboardDashboardDashboardIdSistemaAgentesRouteRoute:
      dashboardDashboardDashboardIdSistemaAgentesRouteRouteWithChildren,
    dashboardDashboardDashboardIdSistemaIntegracoesRouteRoute:
      dashboardDashboardDashboardIdSistemaIntegracoesRouteRouteWithChildren,
    dashboardDashboardDashboardIdSistemaWhatsappRouteRoute:
      dashboardDashboardDashboardIdSistemaWhatsappRouteRouteWithChildren,
    dashboardDashboardDashboardIdSistemaApiKeysRoute:
      dashboardDashboardDashboardIdSistemaApiKeysRoute,
    dashboardDashboardDashboardIdSistemaCamposCustomizadosRoute:
      dashboardDashboardDashboardIdSistemaCamposCustomizadosRoute,
    dashboardDashboardDashboardIdSistemaComodidadesRoute:
      dashboardDashboardDashboardIdSistemaComodidadesRoute,
    dashboardDashboardDashboardIdSistemaConversasRoute:
      dashboardDashboardDashboardIdSistemaConversasRoute,
    dashboardDashboardDashboardIdSistemaDadosRoute:
      dashboardDashboardDashboardIdSistemaDadosRoute,
    dashboardDashboardDashboardIdSistemaDistribuicaoInteligenteRoute:
      dashboardDashboardDashboardIdSistemaDistribuicaoInteligenteRoute,
    dashboardDashboardDashboardIdSistemaFinanceiroRoute:
      dashboardDashboardDashboardIdSistemaFinanceiroRoute,
    dashboardDashboardDashboardIdSistemaFunisRoute:
      dashboardDashboardDashboardIdSistemaFunisRoute,
    dashboardDashboardDashboardIdSistemaIsaRedatoraRoute:
      dashboardDashboardDashboardIdSistemaIsaRedatoraRoute,
    dashboardDashboardDashboardIdSistemaLogsRoute:
      dashboardDashboardDashboardIdSistemaLogsRoute,
    dashboardDashboardDashboardIdSistemaMetaLeadsRoute:
      dashboardDashboardDashboardIdSistemaMetaLeadsRoute,
    dashboardDashboardDashboardIdSistemaMotivosPerdasRoute:
      dashboardDashboardDashboardIdSistemaMotivosPerdasRoute,
    dashboardDashboardDashboardIdSistemaPlanoFaturasRoute:
      dashboardDashboardDashboardIdSistemaPlanoFaturasRoute,
    dashboardDashboardDashboardIdSistemaPortaisRoute:
      dashboardDashboardDashboardIdSistemaPortaisRoute,
    dashboardDashboardDashboardIdSistemaPreviewCtasRoute:
      dashboardDashboardDashboardIdSistemaPreviewCtasRoute,
    dashboardDashboardDashboardIdSistemaPulseCarteiraRoute:
      dashboardDashboardDashboardIdSistemaPulseCarteiraRoute,
    dashboardDashboardDashboardIdSistemaUsuariosRoute:
      dashboardDashboardDashboardIdSistemaUsuariosRoute,
    dashboardDashboardDashboardIdSistemaWatermarkRoute:
      dashboardDashboardDashboardIdSistemaWatermarkRoute,
    dashboardDashboardDashboardIdSistemaWebhooksRoute:
      dashboardDashboardDashboardIdSistemaWebhooksRoute,
    dashboardDashboardDashboardIdSistemaIndexRoute:
      dashboardDashboardDashboardIdSistemaIndexRoute,
  }

const dashboardDashboardDashboardIdSistemaRouteRouteWithChildren =
  dashboardDashboardDashboardIdSistemaRouteRoute._addFileChildren(
    dashboardDashboardDashboardIdSistemaRouteRouteChildren,
  )

interface dashboardDashboardDashboardIdSitesSiteIdBlogRouteRouteChildren {
  dashboardDashboardDashboardIdSitesSiteIdBlogNovoRoute: typeof dashboardDashboardDashboardIdSitesSiteIdBlogNovoRoute
  dashboardDashboardDashboardIdSitesSiteIdBlogIndexRoute: typeof dashboardDashboardDashboardIdSitesSiteIdBlogIndexRoute
  dashboardDashboardDashboardIdSitesSiteIdBlogArtigoIdIndexRoute: typeof dashboardDashboardDashboardIdSitesSiteIdBlogArtigoIdIndexRoute
}

const dashboardDashboardDashboardIdSitesSiteIdBlogRouteRouteChildren: dashboardDashboardDashboardIdSitesSiteIdBlogRouteRouteChildren =
  {
    dashboardDashboardDashboardIdSitesSiteIdBlogNovoRoute:
      dashboardDashboardDashboardIdSitesSiteIdBlogNovoRoute,
    dashboardDashboardDashboardIdSitesSiteIdBlogIndexRoute:
      dashboardDashboardDashboardIdSitesSiteIdBlogIndexRoute,
    dashboardDashboardDashboardIdSitesSiteIdBlogArtigoIdIndexRoute:
      dashboardDashboardDashboardIdSitesSiteIdBlogArtigoIdIndexRoute,
  }

const dashboardDashboardDashboardIdSitesSiteIdBlogRouteRouteWithChildren =
  dashboardDashboardDashboardIdSitesSiteIdBlogRouteRoute._addFileChildren(
    dashboardDashboardDashboardIdSitesSiteIdBlogRouteRouteChildren,
  )

interface dashboardDashboardDashboardIdSitesSiteIdRouteRouteChildren {
  dashboardDashboardDashboardIdSitesSiteIdBlogRouteRoute: typeof dashboardDashboardDashboardIdSitesSiteIdBlogRouteRouteWithChildren
  dashboardDashboardDashboardIdSitesSiteIdIndexRoute: typeof dashboardDashboardDashboardIdSitesSiteIdIndexRoute
}

const dashboardDashboardDashboardIdSitesSiteIdRouteRouteChildren: dashboardDashboardDashboardIdSitesSiteIdRouteRouteChildren =
  {
    dashboardDashboardDashboardIdSitesSiteIdBlogRouteRoute:
      dashboardDashboardDashboardIdSitesSiteIdBlogRouteRouteWithChildren,
    dashboardDashboardDashboardIdSitesSiteIdIndexRoute:
      dashboardDashboardDashboardIdSitesSiteIdIndexRoute,
  }

const dashboardDashboardDashboardIdSitesSiteIdRouteRouteWithChildren =
  dashboardDashboardDashboardIdSitesSiteIdRouteRoute._addFileChildren(
    dashboardDashboardDashboardIdSitesSiteIdRouteRouteChildren,
  )

interface dashboardDashboardDashboardIdSitesRouteRouteChildren {
  dashboardDashboardDashboardIdSitesSiteIdRouteRoute: typeof dashboardDashboardDashboardIdSitesSiteIdRouteRouteWithChildren
  dashboardDashboardDashboardIdSitesIndexRoute: typeof dashboardDashboardDashboardIdSitesIndexRoute
}

const dashboardDashboardDashboardIdSitesRouteRouteChildren: dashboardDashboardDashboardIdSitesRouteRouteChildren =
  {
    dashboardDashboardDashboardIdSitesSiteIdRouteRoute:
      dashboardDashboardDashboardIdSitesSiteIdRouteRouteWithChildren,
    dashboardDashboardDashboardIdSitesIndexRoute:
      dashboardDashboardDashboardIdSitesIndexRoute,
  }

const dashboardDashboardDashboardIdSitesRouteRouteWithChildren =
  dashboardDashboardDashboardIdSitesRouteRoute._addFileChildren(
    dashboardDashboardDashboardIdSitesRouteRouteChildren,
  )

interface dashboardDashboardDashboardIdConversasChannelInstanceUuidRouteRouteChildren {
  dashboardDashboardDashboardIdConversasChannelInstanceUuidIndexRoute: typeof dashboardDashboardDashboardIdConversasChannelInstanceUuidIndexRoute
  dashboardDashboardDashboardIdConversasChannelInstanceUuidConversationIdIndexRoute: typeof dashboardDashboardDashboardIdConversasChannelInstanceUuidConversationIdIndexRoute
}

const dashboardDashboardDashboardIdConversasChannelInstanceUuidRouteRouteChildren: dashboardDashboardDashboardIdConversasChannelInstanceUuidRouteRouteChildren =
  {
    dashboardDashboardDashboardIdConversasChannelInstanceUuidIndexRoute:
      dashboardDashboardDashboardIdConversasChannelInstanceUuidIndexRoute,
    dashboardDashboardDashboardIdConversasChannelInstanceUuidConversationIdIndexRoute:
      dashboardDashboardDashboardIdConversasChannelInstanceUuidConversationIdIndexRoute,
  }

const dashboardDashboardDashboardIdConversasChannelInstanceUuidRouteRouteWithChildren =
  dashboardDashboardDashboardIdConversasChannelInstanceUuidRouteRoute._addFileChildren(
    dashboardDashboardDashboardIdConversasChannelInstanceUuidRouteRouteChildren,
  )

interface dashboardDashboardDashboardIdRouteChildren {
  dashboardDashboardDashboardIdAtividadesRouteRoute: typeof dashboardDashboardDashboardIdAtividadesRouteRouteWithChildren
  dashboardDashboardDashboardIdAutomacoesRouteRoute: typeof dashboardDashboardDashboardIdAutomacoesRouteRouteWithChildren
  dashboardDashboardDashboardIdCatalogoRouteRoute: typeof dashboardDashboardDashboardIdCatalogoRouteRouteWithChildren
  dashboardDashboardDashboardIdChatRouteRoute: typeof dashboardDashboardDashboardIdChatRouteRouteWithChildren
  dashboardDashboardDashboardIdChavesRouteRoute: typeof dashboardDashboardDashboardIdChavesRouteRouteWithChildren
  dashboardDashboardDashboardIdColecoesRouteRoute: typeof dashboardDashboardDashboardIdColecoesRouteRouteWithChildren
  dashboardDashboardDashboardIdContatosRouteRoute: typeof dashboardDashboardDashboardIdContatosRouteRouteWithChildren
  dashboardDashboardDashboardIdDocumentosDigitaisRouteRoute: typeof dashboardDashboardDashboardIdDocumentosDigitaisRouteRouteWithChildren
  dashboardDashboardDashboardIdEmpreendimentosRouteRoute: typeof dashboardDashboardDashboardIdEmpreendimentosRouteRouteWithChildren
  dashboardDashboardDashboardIdFinanceiroRouteRoute: typeof dashboardDashboardDashboardIdFinanceiroRouteRouteWithChildren
  dashboardDashboardDashboardIdImoveisRouteRoute: typeof dashboardDashboardDashboardIdImoveisRouteRouteWithChildren
  dashboardDashboardDashboardIdIncorporadorasRouteRoute: typeof dashboardDashboardDashboardIdIncorporadorasRouteRouteWithChildren
  dashboardDashboardDashboardIdLeadsRouteRoute: typeof dashboardDashboardDashboardIdLeadsRouteRouteWithChildren
  dashboardDashboardDashboardIdMarketingRouteRoute: typeof dashboardDashboardDashboardIdMarketingRouteRouteWithChildren
  dashboardDashboardDashboardIdMatchesRouteRoute: typeof dashboardDashboardDashboardIdMatchesRouteRoute
  dashboardDashboardDashboardIdOportunidadesRouteRoute: typeof dashboardDashboardDashboardIdOportunidadesRouteRouteWithChildren
  dashboardDashboardDashboardIdPortaisRouteRoute: typeof dashboardDashboardDashboardIdPortaisRouteRouteWithChildren
  dashboardDashboardDashboardIdPropostasRouteRoute: typeof dashboardDashboardDashboardIdPropostasRouteRouteWithChildren
  dashboardDashboardDashboardIdRelatorioRouteRoute: typeof dashboardDashboardDashboardIdRelatorioRouteRoute
  dashboardDashboardDashboardIdSistemaRouteRoute: typeof dashboardDashboardDashboardIdSistemaRouteRouteWithChildren
  dashboardDashboardDashboardIdSitesRouteRoute: typeof dashboardDashboardDashboardIdSitesRouteRouteWithChildren
  dashboardDashboardDashboardIdAssinarRoute: typeof dashboardDashboardDashboardIdAssinarRoute
  dashboardDashboardDashboardIdSuporteRoute: typeof dashboardDashboardDashboardIdSuporteRoute
  dashboardDashboardDashboardIdIndexRoute: typeof dashboardDashboardDashboardIdIndexRoute
  dashboardDashboardDashboardIdConversasChannelInstanceUuidRouteRoute: typeof dashboardDashboardDashboardIdConversasChannelInstanceUuidRouteRouteWithChildren
  dashboardDashboardDashboardIdRelatoriosImoveisRouteRoute: typeof dashboardDashboardDashboardIdRelatoriosImoveisRouteRoute
  dashboardDashboardDashboardIdRelatoriosLeadsRouteRoute: typeof dashboardDashboardDashboardIdRelatoriosLeadsRouteRoute
  dashboardDashboardDashboardIdRelatoriosOportunidadesRouteRoute: typeof dashboardDashboardDashboardIdRelatoriosOportunidadesRouteRoute
  dashboardDashboardDashboardIdConversasIndexRoute: typeof dashboardDashboardDashboardIdConversasIndexRoute
}

const dashboardDashboardDashboardIdRouteChildren: dashboardDashboardDashboardIdRouteChildren =
  {
    dashboardDashboardDashboardIdAtividadesRouteRoute:
      dashboardDashboardDashboardIdAtividadesRouteRouteWithChildren,
    dashboardDashboardDashboardIdAutomacoesRouteRoute:
      dashboardDashboardDashboardIdAutomacoesRouteRouteWithChildren,
    dashboardDashboardDashboardIdCatalogoRouteRoute:
      dashboardDashboardDashboardIdCatalogoRouteRouteWithChildren,
    dashboardDashboardDashboardIdChatRouteRoute:
      dashboardDashboardDashboardIdChatRouteRouteWithChildren,
    dashboardDashboardDashboardIdChavesRouteRoute:
      dashboardDashboardDashboardIdChavesRouteRouteWithChildren,
    dashboardDashboardDashboardIdColecoesRouteRoute:
      dashboardDashboardDashboardIdColecoesRouteRouteWithChildren,
    dashboardDashboardDashboardIdContatosRouteRoute:
      dashboardDashboardDashboardIdContatosRouteRouteWithChildren,
    dashboardDashboardDashboardIdDocumentosDigitaisRouteRoute:
      dashboardDashboardDashboardIdDocumentosDigitaisRouteRouteWithChildren,
    dashboardDashboardDashboardIdEmpreendimentosRouteRoute:
      dashboardDashboardDashboardIdEmpreendimentosRouteRouteWithChildren,
    dashboardDashboardDashboardIdFinanceiroRouteRoute:
      dashboardDashboardDashboardIdFinanceiroRouteRouteWithChildren,
    dashboardDashboardDashboardIdImoveisRouteRoute:
      dashboardDashboardDashboardIdImoveisRouteRouteWithChildren,
    dashboardDashboardDashboardIdIncorporadorasRouteRoute:
      dashboardDashboardDashboardIdIncorporadorasRouteRouteWithChildren,
    dashboardDashboardDashboardIdLeadsRouteRoute:
      dashboardDashboardDashboardIdLeadsRouteRouteWithChildren,
    dashboardDashboardDashboardIdMarketingRouteRoute:
      dashboardDashboardDashboardIdMarketingRouteRouteWithChildren,
    dashboardDashboardDashboardIdMatchesRouteRoute:
      dashboardDashboardDashboardIdMatchesRouteRoute,
    dashboardDashboardDashboardIdOportunidadesRouteRoute:
      dashboardDashboardDashboardIdOportunidadesRouteRouteWithChildren,
    dashboardDashboardDashboardIdPortaisRouteRoute:
      dashboardDashboardDashboardIdPortaisRouteRouteWithChildren,
    dashboardDashboardDashboardIdPropostasRouteRoute:
      dashboardDashboardDashboardIdPropostasRouteRouteWithChildren,
    dashboardDashboardDashboardIdRelatorioRouteRoute:
      dashboardDashboardDashboardIdRelatorioRouteRoute,
    dashboardDashboardDashboardIdSistemaRouteRoute:
      dashboardDashboardDashboardIdSistemaRouteRouteWithChildren,
    dashboardDashboardDashboardIdSitesRouteRoute:
      dashboardDashboardDashboardIdSitesRouteRouteWithChildren,
    dashboardDashboardDashboardIdAssinarRoute:
      dashboardDashboardDashboardIdAssinarRoute,
    dashboardDashboardDashboardIdSuporteRoute:
      dashboardDashboardDashboardIdSuporteRoute,
    dashboardDashboardDashboardIdIndexRoute:
      dashboardDashboardDashboardIdIndexRoute,
    dashboardDashboardDashboardIdConversasChannelInstanceUuidRouteRoute:
      dashboardDashboardDashboardIdConversasChannelInstanceUuidRouteRouteWithChildren,
    dashboardDashboardDashboardIdRelatoriosImoveisRouteRoute:
      dashboardDashboardDashboardIdRelatoriosImoveisRouteRoute,
    dashboardDashboardDashboardIdRelatoriosLeadsRouteRoute:
      dashboardDashboardDashboardIdRelatoriosLeadsRouteRoute,
    dashboardDashboardDashboardIdRelatoriosOportunidadesRouteRoute:
      dashboardDashboardDashboardIdRelatoriosOportunidadesRouteRoute,
    dashboardDashboardDashboardIdConversasIndexRoute:
      dashboardDashboardDashboardIdConversasIndexRoute,
  }

const dashboardDashboardDashboardIdRouteWithChildren =
  dashboardDashboardDashboardIdRoute._addFileChildren(
    dashboardDashboardDashboardIdRouteChildren,
  )

interface dashboardDashboardRouteChildren {
  dashboardDashboardDashboardIdRoute: typeof dashboardDashboardDashboardIdRouteWithChildren
}

const dashboardDashboardRouteChildren: dashboardDashboardRouteChildren = {
  dashboardDashboardDashboardIdRoute:
    dashboardDashboardDashboardIdRouteWithChildren,
}

const dashboardDashboardRouteWithChildren =
  dashboardDashboardRoute._addFileChildren(dashboardDashboardRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  authAbrirContaRoute: authAbrirContaRoute,
  authAppRoute: authAppRoute,
  authConfiguracaoLoginRoute: authConfiguracaoLoginRoute,
  authRecuperarSenhaRoute: authRecuperarSenhaRoute,
  authWorkspaceRoute: authWorkspaceRoute,
  dashboardDashboardRoute: dashboardDashboardRouteWithChildren,
  AtenderHashRoute: AtenderHashRoute,
  AuthHandoffRoute: AuthHandoffRoute,
  CheckinTokenRoute: CheckinTokenRoute,
  PulseTokenRoute: PulseTokenRoute,
  authIndexRoute: authIndexRoute,
  authLTokenRoute: authLTokenRoute,
  PulsePreviewTokenRoute: PulsePreviewTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
